{
  "footer": {
    "week": "week",
    "rowsPerPage": "rows per page",
    "page": "page"
  },
  "dashboard": {
    "invoicedRevenue": "Invoiced revenue",
    "bookedRevenue": "Booked orders",
    "thisMonth": "this month",
    "thisWeek": "this week",
    "thisYear": "this year",
    "vsLastYear": "vs last year",
    "noEntries": "Nothing planned",
    "whoIsIn": "In today",
    "nobodyCheckedIn": "No one has checked in yet",
    "recentActivity": "Recent interactions",
    "noActivity": "No recent activity",
    "quickLinks": "Quick access",
    "viewAll": "View all",
    "wk": "wk",
    "birthday": "Birthday: {name}",
    "previousYear": "Previous year",
    "nextYear": "Next year"
  },
  "label": {
    "new": "New",
    "soon": "Soon"
  },
  "navigation": {
    "packaging": "Packaging",
    "calculations": "Calculations",
    "boxStyles": "Fefco",
    "boardQualities": "Cardboard qualities",
    "machines": "Machines",
    "setup": "Setup",
    "stockSheets": "Stock sheets",
    "transportZones": "Transport zones",
    "countries": "Countries",
    "translations": "Translations",
    "palletSizes": "Collo pallet sizes",
    "shiftTypes": "4 - Shifts",
    "bundleStackings": "Bundle stackings",
    "colloTypes": "Collo types",
    "account": "Account",
    "accounts": "Accounts",
    "activities": "Activities",
    "visitors": "Visitors",
    "allProjects": "All Projects",
    "boards": "Boards",
    "apiKeys": "API Keys",
    "apiKeysAudit": "API keys per user",
    "approval": "Approval",
    "autoInvoicing": "Invoicing",
    "credit": "Credit",
    "bills": "Bills",
    "calendar": "2 - Company calendar",
    "chat": "Chat",
    "company": "1 - Company",
    "contacts": "Contacts",
    "contracts": "Contracts",
    "creditNotes": "Credit notes",
    "crm": "CRM",
    "crmSettings": "CRM Settings",
    "currency": "Currency",
    "currencyRates": "Currency Rates",
    "currencySettings": "Currency Settings",
    "connectedServices": "Connected services",
    "customModules": "Custom modules",
    "dashboard": "Dashboard",
    "debitNotes": "Debit notes",
    "departments": "Departments",
    "details": "Details",
    "documents": "Documents",
    "dunning": "Dunning",
    "email": "Email",
    "emailTemplates": "Email templates",
    "employees": "Employees",
    "expenses": "Expenses",
    "fileDropzone": "Files",
    "finance": "Finance",
    "general": "General",
    "humanResources": "Human Resources",
    "inventory": "Inventory",
    "invoices": "Sales invoices",
    "language": {
      "language": "Language"
    },
    "leads": "Leads",
    "leave": "Absence",
    "lifecycle": "Lifecycle",
    "locations": "Locations",
    "lookups": "Lookups",
    "machineRuns": "Machine runs",
    "maintenance": "Maintenance",
    "marketplace": "Marketplace",
    "milestones": "Milestones",
    "mode": {
      "dark": "Dark",
      "light": "Light",
      "mode": "Mode",
      "system": "System"
    },
    "modules": "Modules",
    "myHr": "My HR",
    "numbering": "Numbering",
    "oidcClients": "OIDC Clients",
    "onboarding": "Onboarding",
    "opportunities": "Opportunities",
    "apAging": "AP aging",
    "arAging": "AR aging",
    "sales": "Sales",
    "cashflow": "Cashflow",
    "topCustomers": "Top customers",
    "outstanding": "Outstanding",
    "payments": "Payments",
    "paymentTerms": "Payment terms",
    "payroll": "Payroll",
    "performance": "Performance",
    "pipelines": "Pipelines",
    "production": "Production",
    "productionOrders": "Production orders",
    "products": "Products",
    "projects": "Projects",
    "purchaseOrders": "Purchase orders",
    "quotas": "Quotas",
    "quotes": "Quotes",
    "salesOrders": "Sales orders",
    "orderLines": "Order lines",
    "recruitment": "Recruitment",
    "recurring": "Recurring",
    "rolesPermissions": "Roles & Permissions",
    "settings": "Settings",
    "shifts": "Shifts",
    "supplierPaperboard": "Paperboard suppliers",
    "tags": "Tags",
    "tasks": "Tasks",
    "taxNotes": "VAT notices",
    "taxRates": "Tax rates",
    "team": "Team",
    "teams": "Teams",
    "timeline": "Timeline",
    "timeTracking": "Time Tracking",
    "training": "Training",
    "transfer": "Transfer",
    "users": "Users",
    "userNav": {
      "settings": "Settings",
      "security": "Security",
      "signOut": "Sign out"
    },
    "webhooks": "Webhooks",
    "lots": "Lots",
    "serials": "Serials",
    "stockMovements": "Stock movements",
    "adjust": "Adjust",
    "overview": "Overview",
    "paused": "Paused",
    "workspace": "Workspace",
    "deleting": "Deleting",
    "boxDesign": "BoxDesign",
    "fileViewer": "FileViewer",
    "addresses": "Addresses",
    "polls": "Polls",
    "referenceLists": "Reference lists",
    "shipments": "Shipping",
    "packingSlips": "Packing slips",
    "scanPallets": "Scan pallets",
    "inkoopVerkoop": "Purchasing & Sales",
    "logistics": "Logistics",
    "deliveryMethods": "Delivery methods",
    "logisticsSettings": "Settings",
    "ppwr": "PPWR",
    "ppwrSettings": "PPWR settings",
    "stockPosition": "Stock position",
    "stockValuation": "Stock valuation",
    "cartonToOrder": "Carton to order",
    "coproduction": "Coproduction",
    "cartonDeliveries": "Carton deliveries",
    "receiveCarton": "Receive carton",
    "integrationConnections": "1 - API Connections",
    "integrationTasks": "2 - API Tasks",
    "integrationRuns": "3 - API Messages",
    "integrationDatasets": "4 - API Datasets",
    "workCalendar": "3 - Work schedule",
    "machineCalendar": "Machine calendar",
    "machinePlanning": "Machine planning",
    "priceLists": "Price lists",
    "certifications": "Certifications",
    "designLibrary": "Design library",
    "hr": "HR",
    "timeRegistration": "Time registration",
    "timeRegistrationSettings": "Time registration",
    "leaveTypes": "Absence types",
    "leaveBalances": "Leave balances"
  },
  "packaging": {
    "recordNav": {
      "noResults": "No results",
      "records": "{count, plural, one {# record} other {# records}}"
    },
    "home": {
      "intro": "Corrugated box calculations, Fefco styles, board qualities and machines.",
      "cards": {
        "calculations": "Calculate and manage boxes",
        "boxDesign": "Design boxes with plano & 3D preview",
        "fileViewer": "View SVG, DXF, CF2, PDF, AI and EPS files",
        "boxStyles": "Fefco codes with plano & 3D preview",
        "boardQualities": "Corrugated board grades and supplier pricing",
        "machines": "Production machines, speeds and cost rates",
        "supplierPaperboard": "Paperboard suppliers and allowance tiers",
        "stockSheets": "Pre-cut board sheets held in stock",
        "palletSizes": "Pallet dimensions for palletization",
        "colloTypes": "Shipping collo types and dimensions",
        "countries": "Countries and delivery regions",
        "priceLists": "The price lists of board suppliers, with the date they take effect."
      }
    },
    "calculations": {
      "title": "Calculations",
      "loading": "Loading…",
      "listEmpty": "No calculations found.",
      "fallbackName": "Calculation {id}",
      "fields": {
        "number": "Number",
        "createdAt": "Created",
        "party": "Kind",
        "customer": "Customer",
        "article": "Article"
      },
      "editor": {
        "pageTitle": "Calculation",
        "newCalc": "New",
        "deleteConfirm": "Delete this calculation?",
        "duplicateBanner": "Source calculation loaded — description cleared for the copy.",
        "versionConflict": "This calculation was changed elsewhere. Reload the page to see the latest version before saving again.",
        "validationIntro": "Resolve the following errors before calculating:",
        "calculate": "Calculate",
        "calculating": "Calculating…",
        "promote": "Create a product",
        "promoteSuccess": "Product created from calculation",
        "updateProduct": "Update the product",
        "updateProductSuccess": "Product updated from calculation",
        "offerteNumberAssigned": "Quote number {number} created",
        "box": {
          "length": "L (mm)",
          "width": "W (mm)",
          "height": "H (mm)",
          "fefco": "Fefco code",
          "variant": "Variant",
          "variantSymmetric": "symmetric",
          "variantDiecut": "die-cut",
          "quality": "Quality",
          "closure": "Closure type",
          "closureDefault": "glue (default)",
          "gl": "GL choice",
          "verlengdGl": "Extended GL (mm)",
          "verlengdGlPlaceholder": "0 = no extension",
          "print": "Printing",
          "printReminderCode": "This customer always wants their code on the box.",
          "printReminderResy": "This customer always wants the RESY symbol on the box.",
          "printReminderBoth": "This customer always wants their code and the RESY symbol on the box.",
          "diecut": "Die-cut",
          "none": "none"
        },
        "gl": {
          "gl0": "GL0 — W-side, left, extended",
          "gl1": "GL1 — W-side, left (default)",
          "gl2": "GL2 — L-side, left, extended",
          "gl3": "GL3 — L-side, left",
          "gl4": "GL4 — W-side, right, extended",
          "gl5": "GL5 — W-side, right",
          "gl6": "GL6 — L-side, right, extended",
          "gl7": "GL7 — L-side, right"
        },
        "rest": {
          "description": "Note",
          "diecutPackaging": "Die-cut packaging",
          "planoRotated": "Flute crosswise",
          "fsc": "FSC",
          "fscClaim": "FSC claim",
          "fscClaimPlaceholder": "Company claim (default)",
          "deliveryCondition": "Delivery condition",
          "country": "Country",
          "postalCode": "Postal code",
          "articleType": "Article type",
          "articleDescription": "Article description",
          "customerArticleReference": "Customer article reference",
          "articleExtraInfo": "Extra article information for the quote",
          "nl": "NL – Netherlands",
          "de": "DE – Germany",
          "be": "BE – Belgium",
          "customer": "Customer",
          "customerPlaceholder": "Select customer…",
          "shipTo": "Ship-to",
          "shipToOwnCompany": "Own company",
          "customerOwnCompany": "Own company"
        },
        "staffels": {
          "title": "Quantity tiers",
          "num": "#",
          "quantity": "Quantity",
          "typeOverride": "Type / Override",
          "closure": "Closure",
          "supplierStock": "Supplier / Stock sheet",
          "removeConfirm": "Remove tier {n}?",
          "remove": "Remove tier",
          "autoLabel": "Auto (production → stock)",
          "forceProduction": "↑ Force production",
          "forceStock": "↓ Force stock",
          "manualGroup": "Manual type",
          "coproductie": "Co-production",
          "uitbesteding": "Outsourcing",
          "inkoop": "Purchase",
          "overige": "Other",
          "auto": "Auto",
          "autoSupplier": "Automatic (cheapest)",
          "loading": "Loading…"
        },
        "panels": {
          "gl": "GL (mm)",
          "o": "O (mm)",
          "e": "E (mm)",
          "h1": "h1 (mm)"
        },
        "creditors": {
          "title": "Creditors",
          "creditor": "Creditor {n}",
          "name": "Name",
          "reference": "Reference",
          "note": "Note"
        },
        "margins": {
          "title": "Margins",
          "block1": "Block 1 (%)",
          "block2": "Block 2 (%)",
          "block3": "Block 3 (%)",
          "offer": "Offer (%)",
          "articlePricesUpdatedOn": "Article prices updated on {date}"
        },
        "result": {
          "autoCorrPrefix": "Closure type",
          "autoCorrMid": "is not allowed for this Fefco type. Automatically changed to",
          "autoCorrAllowed": "allowed",
          "panels": "Panels",
          "manual": "manual",
          "bDirection": "B direction (width)",
          "lDirection": "L direction (length cut)",
          "recalcPanels": "Recalculate with panel override",
          "resetPanels": "Reset panels",
          "planoWeight": "Sheet & weight",
          "planoPackaging": "Packaging sheet",
          "rotated": "rotated",
          "partsPerBox": "Parts / box",
          "partsUnit": "sheets / box",
          "multiUp": "Pieces out",
          "sheet": "Sheet",
          "m2PerPlano": "m² / sheet",
          "m2PerSheet": "m² / full sheet",
          "m2PerUnit": "m² / piece",
          "weightPerPlano": "Weight / sheet",
          "weightPerSheet": "Weight / full sheet",
          "weightPerUnit": "Weight / piece",
          "recalcSheet": "Recalculate with sheet override",
          "resetSheet": "Reset to calculated",
          "diecutPlate": "Die-cut plate",
          "plateWidth": "Plate W",
          "plateLength": "Plate L",
          "diecutMultiUp": "Pieces out (W × L = {n})",
          "m2PerDiecutPlate": "m² / die-cut plate",
          "effM2PerBox": "Effective m² / box",
          "wastePct": "(+{n}% waste)",
          "weightPerDiecutPlate": "Weight / die-cut plate",
          "recalcDiecut": "Recalculate with die-cut plate",
          "transportColli": "Transport & colli",
          "bundle": "Bundle",
          "pieces": "pcs",
          "bundleSpread": "Bundle spread",
          "colloType": "Collo/pallet type",
          "colli": "Pallet size (cm)",
          "bundleStacking": "Bundle stacking",
          "bundlesInHeight": "Bundles in height",
          "piecesPerColli": "Pieces / colli",
          "maxColloHeight": "Max collo height (cm)",
          "effColliSpread": "Effective colli spread",
          "stackable": "stackable",
          "rotatedNote": "(rotated)",
          "ldmPerColli": "Load metre / colli",
          "recalcColli": "Recalculate with colli override",
          "resetColli": "Reset colli override",
          "autoCollo": "auto ({label})",
          "autoColloDefault": "auto (one-way pallet)",
          "auto": "auto",
          "noFreight": "no freight",
          "dropshipTiers": "Drop shipping: tier {tiers}",
          "zoomTitle": "Click to enlarge",
          "sheetScores": "Order sheet scores",
          "sheetScoresDiecut": "Order format (die-cut sheet)",
          "sheetScoresB": "B direction — parallel to the flute · scores are applied by the supplier",
          "sheetScoresL": "L direction (cut-off)",
          "saveSheetScores": "Save scores",
          "resetSheetScores": "Reset scores",
          "sheetScoresSumMismatch": "Scores add up to {sum}, sheet is {sheet}",
          "sheetLengthMismatch": "L direction is {value}, sheet is {sheet}",
          "sheetScoresTooMany": "Tier {quantities} · {supplier}: {lines} scores, maximum {max}",
          "sheetScoresTooClose": "Tier {quantities} · {supplier}: score {from} → {to} is {distance} mm, minimum {min} mm"
        },
        "staffelTable": {
          "selectionResult": {
            "geenMachine": "no machine",
            "nietMogelijk": "not possible",
            "planoPastNiet": "plano doesn't fit",
            "transportPastNiet": "no freight rate"
          },
          "title": "Tier prices",
          "toQuote": "→ Quote",
          "toArticle": "→ Article",
          "toQuoteTitle": "Guideline → Quote for all tiers",
          "toArticleTitle": "Quote → Article for all tiers",
          "selection": "Selection",
          "qtyCustomer": "Qty customer",
          "qtyOrdered": "Qty ordered",
          "totalM2": "Total m²",
          "block1": "Block 1",
          "machine": "Machine",
          "block2a": "Block 2A",
          "block2b": "Block 2B",
          "block2": "Block 2",
          "block3": "Block 3",
          "guideline": "Guideline",
          "quote": "Quote",
          "article": "Article",
          "handel": "Trade",
          "noMachineRun": "no machine run",
          "informative": "informative",
          "creditorsForTier": "Creditors — tier {n}",
          "unitPrice": "Unit price",
          "totalCreditorsPerUnit": "Total creditors/piece",
          "dropshipping": "Drop shipping",
          "recalc": "Recalculate",
          "informativeNote": "Informative — does not count in guideline for {kind}.",
          "defaultKind": "production/stock"
        },
        "machineRoute": {
          "route": "Route",
          "plano": "sheet",
          "gl": "GL",
          "fallback": "(fallback)",
          "productionSlip": "Production slip",
          "prio": "prio",
          "plate": "Plate",
          "changed": "changed",
          "speed": "Speed",
          "perHour": "p/h",
          "amount": "Amount",
          "sheets": "Sheets",
          "times": "Times",
          "setup": "Setup",
          "production": "Production",
          "down": "Down",
          "cleanup": "Cleanup",
          "min": "min",
          "perHourCost": "/h",
          "supported": "✓ +€{price} · +{time} min setup",
          "notSupported": "✗ not supported on this machine",
          "alternative": "Alternative:",
          "autoSelection": "(auto — prio selection)",
          "recalcMachine": "Recalculate with machine override",
          "resetMachine": "Reset machine override",
          "block2aMachines": "Block 2A machines",
          "planosLabel": "Sheets",
          "planoPackLabel": "Packaging sheets"
        },
        "drawings": {
          "fefco3d": "Fefco 3D",
          "fefcoPlano": "Fefco sheet",
          "loading3d": "Loading 3D…",
          "loading": "Loading…",
          "waitResult": "Waiting for tier result",
          "capture": "Capture",
          "captureSaving": "Capturing…",
          "captureDone": "Drawing captured",
          "captureHint": "Turn the box to the angle and fold you want on the quote and the declaration.",
          "export": {
            "label": "Export",
            "dxf": "DXF",
            "pdf": "PDF (production)",
            "pdfDrukmodel": "PDF (print model)",
            "cff2": "CFF2",
            "eps": "EPS",
            "failed": "Export failed"
          }
        },
        "notFound": {
          "title": "Calculation not found",
          "body": "This calculation does not exist or was deleted ({id}).",
          "backToList": "Back to calculations"
        },
        "priceList": {
          "useUpcoming": "Calculate with price list {number} from {date}",
          "fromList": "Price list {number}, valid from {date}",
          "fromQuality": "Price on the quality",
          "futureNotice": "This calculation uses price list {number}: prices that only apply from {date}.",
          "missing": "{supplier}: no price in price list {number} (valid from {date}); this supplier drops out."
        },
        "tabs": {
          "general": "Details",
          "drawings": "Drawings",
          "files": "Files"
        },
        "articlePriceMissing": {
          "title": "Article prices missing",
          "body": "These tiers have no article price: {quantities}. Enter the price in the Article column, or copy the quote prices with → Article, and click Save. Then you can create or update the product."
        }
      },
      "errors": {
        "FEFCO_NOT_FOUND": "FEFCO code \"{fefco}\" does not exist",
        "FEFCO_INACTIVE": "FEFCO code \"{fefco}\" is not active",
        "FEFCO_REQUIRED": "FEFCO code is required",
        "QUALITY_NOT_FOUND": "Quality \"{quality}\" does not exist",
        "QUALITY_INACTIVE": "Quality \"{quality}\" is not active",
        "QUALITY_NO_SUPPLIER": "Quality \"{quality}\" has no supplier — calculation not possible",
        "QUALITY_REQUIRED": "Quality is required",
        "LENGTH_REQUIRED": "Length is required",
        "WIDTH_REQUIRED": "Width is required",
        "DIMENSION_WIDTH_EXCEEDS_LENGTH": "Width ({width} mm) may not exceed Length ({length} mm)",
        "DIMENSION_HEIGHT_EXCEEDS_WIDTH": "Height ({height} mm) may not exceed Width ({width} mm)",
        "DIMENSION_HEIGHT_REQUIRED": "Height is required",
        "PLANO_EXCEEDS_TRAILER_WIDTH": "Sheet size {width}×{length} mm does not fit the trailer: at least one dimension must be ≤ 2435 mm",
        "SHEET_SMALLER_THAN_PLANO": "Sheet {sheet} mm is smaller than packaging sheet × number up ({min} mm)",
        "DELETE_FAILED": "Delete failed",
        "CALCULATION_IN_USE": "Cannot delete: the calculation is still used on {usage}. Remove it there first.",
        "inUse": {
          "product": "{count, plural, one {# product} other {# products}}",
          "quoteLine": "{count, plural, one {# quote line} other {# quote lines}}",
          "orderLine": "{count, plural, one {# order line} other {# order lines}}",
          "financeLine": "{count, plural, one {# invoice line} other {# invoice lines}}",
          "stockSheet": "{count, plural, one {# stock sheet} other {# stock sheets}}"
        },
        "EXCHANGE_RATE_MISSING": "No exchange rate {from} → {to} for supplier \"{supplier}\". Add the rate under Settings → Currency, or correct the currency of this supplier account.",
        "PANELS_REQUIRED": "At least one B panel and one L panel with a value greater than 0 is required.",
        "LOAD_FAILED": "The calculation could not be loaded. Reload the page; calculating is disabled so the stored calculation is not overwritten.",
        "CONNECTION_ERROR": "Connection error: {message}",
        "STAFFEL_QUANTITY_REQUIRED": "Quantity is required",
        "STAFFEL_QUANTITY_OUT_MIN": "Pieces-out must be at least 1",
        "STAFFELS_MIN_ONE": "At least one tier with a quantity is required",
        "STAFFELS_MAX_SIX": "At most 6 tiers are allowed",
        "STAFFELS_DUPLICATE_TIER": "Each tier number may occur only once",
        "SETUP_MISSING": "The calculation setup has never been saved. Fill in the surcharges under Settings → Packaging → Setup and save once.",
        "NOT_FOUND": "Calculation {id} does not exist",
        "CLOSURE_TYPE_NOT_ALLOWED": "Closure {closure} is not allowed for this FEFCO (allowed: {allowed})",
        "generic": "Something went wrong while calculating"
      },
      "party": {
        "internal": "Internal",
        "customer": "Customer",
        "all": "All"
      }
    },
    "machine": {
      "title": "Machines",
      "new": "New machine",
      "delete": "Delete",
      "loading": "Loading…",
      "notFound": "Machine not found.",
      "listEmpty": "No machines yet.",
      "created": "Machine created.",
      "saved": "Machine saved.",
      "deleted": "Machine deleted.",
      "active": "Active",
      "inactive": "Inactive",
      "validationId": "An ID is required.",
      "deleteConfirmTitle": "Delete machine?",
      "deleteConfirm": "This permanently removes the machine. It cannot be deleted while it is used in saved calculation lines.",
      "sections": {
        "identification": "Identification",
        "classification": "Status & classification",
        "dimensions": "Dimensions",
        "costs": "Costs & capacity",
        "speedMatrix": "Speed matrix",
        "diecut": "Die-cutting add-ons",
        "addprint": "Print add-ons",
        "other": "Other",
        "operations": "Operations"
      },
      "matrix": {
        "planoRange": "Plano range",
        "bMin": "B min",
        "bMax": "B max",
        "lMin": "L min",
        "lMax": "L max",
        "dikte": "Thickness",
        "range": "Range",
        "skipfeed": "Skip-feed",
        "addRow": "Add row"
      },
      "fields": {
        "id": "ID (UUID)",
        "idMachine": "Machine ID",
        "machineName": "Name",
        "machineShortcode": "Short code",
        "machineNumber": "Planning",
        "constructionYear": "Build year",
        "isActive": "Active",
        "inPlanning": "In planning",
        "inPlanningHint": "Appears in the machine calendar, capacity and qualifications. Off for trade and co-production. Rows with the same machine ID are one machine.",
        "centerPoint": "Centre point on production slip",
        "centerPointHint": "The zero point from which the inliner is set left and right. Inliners only; empty = no centre point on the slip.",
        "centerPointPlanoMinusGlHalf": "(plano − GL) / 2",
        "calcMachPrio": "Calc priority",
        "fenceIds": "Machine closure",
        "typeIds": "Machine type",
        "fefcoCodes": "Fefco codes",
        "fefcoCodesPlaceholder": "Search FEFCO code…",
        "planoWidthMin": "Plano B min (mm)",
        "planoWidthMax": "Plano B max (mm)",
        "planoLengthMin": "Plano L min (mm)",
        "planoLengthMax": "Plano L max (mm)",
        "panelWidthMin": "Panel B min (mm)",
        "panelWidthMax": "Panel B max (mm)",
        "panelLengthMin": "Panel L min (mm)",
        "panelLengthMax": "Panel L max (mm)",
        "panelHeightMin": "Panel H min (mm)",
        "panelHeightMax": "Panel H max (mm)",
        "thicknessMin": "Thickness min (mm)",
        "thicknessMax": "Thickness max (mm)",
        "thicknessMinForPrint": "Thickness min print (mm)",
        "printType": "Print type",
        "printWidthMax": "Print area B max (mm)",
        "printLengthMax": "Print area L max (mm)",
        "scoringMin": "Crease spacing min (mm)",
        "scoringMax": "Crease spacing max (mm)",
        "slitWidth": "Slit width (mm)",
        "idThicknessForPrint": "Machine can also print only",
        "hourlyCostPrice": "Hourly cost (€)",
        "hoursAvailable": "Hours available per year",
        "timeSetup": "Setup time (min)",
        "timeCleanup": "Cleanup time (min)",
        "timeDowntime": "Downtime (min)",
        "speedT1": "Speed thk 1 (pcs/h)",
        "speedT2": "Speed thk 2 (pcs/h)",
        "speedT3": "Speed thk 3 (pcs/h)",
        "speedQuantity": "Quantity thresholds",
        "speedReduction": "Speed reduction (%)",
        "speedSurchargeMultipleOut": "Surcharge for multiple-out (%)",
        "addDiecutPunchingNum": "Option no.",
        "addDiecutPunchingPrice": "Surcharge (€)",
        "addDiecutPunchingSetupTime": "Extra setup time (min)",
        "addPrintOptionsNum": "Option no.",
        "addPrintPrice": "Surcharge (€)",
        "addPrintSetupTime": "Extra setup time (min)",
        "orderQuantityMin": "Min. order quantity",
        "flagProductionOtherWayAround": "Production reversed",
        "diecutPackaging": "Die-cut packaging",
        "occupation": "Occupation",
        "note": "Note",
        "orderM2Max": "Max. order (m²)"
      },
      "operations": {
        "add": "Add operation",
        "edit": "Edit operation",
        "empty": "No operations yet — without an operation the machine is not used in calculations.",
        "saveFirst": "Save the machine first; then add operations.",
        "created": "Operation added",
        "saved": "Operation saved",
        "deleted": "Operation deleted",
        "deleteConfirmTitle": "Delete operation?",
        "deleteConfirm": "The machine will no longer be used for this way of working in new calculations."
      }
    },
    "quality": {
      "title": "Board qualities",
      "new": "New quality",
      "delete": "Delete",
      "deleted": "Quality deleted.",
      "deleteConfirm": "Delete this quality?",
      "deleteConfirmBody": "This permanently removes the board quality. It cannot be deleted while it is still linked to suppliers, stock sheets or calculations.",
      "saved": "Quality saved.",
      "loading": "Loading…",
      "empty": "No board qualities found.",
      "notFound": "Quality not found.",
      "idRequired": "An ID is required.",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "fields": {
        "id": "ID",
        "isActive": "Active",
        "composition": "Composition",
        "fluteType": "Flute type",
        "wallCount": "Wall count",
        "thickness": "Thickness (mm)",
        "weightM2": "Grammage (g/m²)",
        "edgeCrushTest": "ECT (kN/m)",
        "recycledPercent": "Recycled content (%)",
        "baseMaterialId": "Base material",
        "colorLinersId": "Liner colour (outer/inner)",
        "note": "Note"
      },
      "hints": {
        "wallCount": "1 = single, 2 = double, 3 = triple. You fill it in yourself; only when it is empty does the drawing derive it from the flute type."
      },
      "placeholders": {
        "colorLinersId": "Select a liner colour"
      },
      "suppliers": {
        "title": "Suppliers",
        "add": "Add supplier",
        "editTitle": "Edit supplier link",
        "empty": "No suppliers linked yet.",
        "saved": "Supplier link saved.",
        "removed": "Supplier link removed.",
        "remove": "Remove",
        "removeConfirm": "Remove this supplier link?",
        "removeConfirmBody": "This unlinks the supplier from this board quality. The supplier record itself is kept.",
        "supplierRequired": "Select a supplier.",
        "actions": "Actions",
        "fields": {
          "supplierPaperboardId": "Supplier",
          "supplierName": "Supplier",
          "qualityCodeSupplier": "Supplier code",
          "qualityComposition": "Composition",
          "qualityThickness": "Thickness (mm)",
          "qualityWeightM2": "Grammage (g/m²)",
          "qualityEdgeCrushTest": "ECT (kN/m)",
          "qualityBoxCompressionTest": "BCT (kN)",
          "qualityDeliveryPeriod": "Lead time (days)",
          "priceEntity": "Price unit (m²)",
          "note": "Note"
        },
        "placeholders": {
          "supplierPaperboardId": "Select a supplier"
        },
        "tiers": {
          "title": "Purchase price tiers",
          "tier": "Tier",
          "threshold": "Threshold (m²)",
          "price": "Purchase price"
        }
      },
      "priceList": {
        "current": "Current price list:",
        "noPriceCurrent": "— no price for this code: the calculation skips this supplier.",
        "noPrice": "no price for this code",
        "upcoming": "From {date} price list",
        "history": "Price history",
        "perM2": "Prices per 1000 m², with the change from the previous list.",
        "fromList": "— the prices below come from the list.",
        "edited": "adjusted",
        "editTitle": "Prices from price list {number}, valid from {date}",
        "editHint": "Changing them adjusts the price list; the line is then marked as adjusted.",
        "addHint": "This quality is not in the list. Enter a price to add it to the list.",
        "unit": "Price per {m2} m²",
        "fromM2": "From (m²)",
        "scalesIncomplete": "Enter a quantity in whole m² and a price for each tier.",
        "scalesOrder": "The tiers must go up.",
        "codeRequired": "Enter the supplier code first: that is how the quality gets into the list.",
        "unitFromList": "{m2} m² (from price list {number})"
      }
    },
    "supplierPaperboard": {
      "title": "Paperboard suppliers",
      "newTitle": "New supplier",
      "delete": "Delete",
      "deleteConfirmTitle": "Delete supplier?",
      "deleteConfirm": "This permanently deletes the supplier and its allowance tiers. Suppliers still linked to a board quality cannot be deleted. This action cannot be undone.",
      "saved": "Supplier saved",
      "deleted": "Supplier deleted",
      "back": "Back to suppliers",
      "loading": "Loading…",
      "listEmpty": "No suppliers yet",
      "notFound": "Supplier not found",
      "active": "Active",
      "inactive": "Inactive",
      "sections": {
        "general": "General",
        "flute": "Flute",
        "pallet": "Pallet",
        "bonus": "Supplier bonus",
        "notes": "Notes"
      },
      "fields": {
        "creditorName": "Supplier",
        "isActive": "Active",
        "lmMin": "Minimum order (lm)",
        "m2Min": "Minimum order (m²)",
        "planoMin": "Plano min (W × L)",
        "planoMax": "Plano max (W × L)",
        "planoWidthMin": "Plano width min (mm)",
        "planoWidthMax": "Plano width max (mm)",
        "planoLengthMin": "Plano length min (mm)",
        "planoLengthMax": "Plano length max (mm)",
        "flute": "Flute types",
        "fluteHint": "Comma-separated, e.g. E, B, C, EB, BC",
        "fluteMinQuantity": "Flute minimum quantity",
        "fluteMinQuantityHint": "Comma-separated numbers, parallel to flute types",
        "scoringMax": "Max. scores",
        "scoringMinDistance": "Min. score distance (mm)",
        "scoringMinDistanceTxt": "Scoring description",
        "palletStackingHeight": "Pallet stacking height (mm)",
        "palletType": "Pallet types",
        "supplierBonus": "Supplier bonus (%)",
        "supplierBonusHint": "Comma-separated discount rates, parallel to the thresholds",
        "supplierBonusQuota": "Bonus thresholds",
        "supplierBonusQuotaHint": "Comma-separated m² thresholds",
        "note": "Note"
      },
      "tiers": {
        "title": "Allowance / discount tiers",
        "tierIndex": "#",
        "widthFrom": "Width from",
        "widthTill": "Width till",
        "lengthFrom": "Length from",
        "lengthTill": "Length till",
        "price": "Price",
        "empty": "No allowance/discount tiers",
        "actions": "Actions",
        "add": "Add tier",
        "addTitle": "Add tier",
        "editTitle": "Edit tier",
        "saved": "Tier saved",
        "deleted": "Tier deleted",
        "deleteConfirm": "Delete tier?",
        "deleteConfirmBody": "This tier will be permanently deleted."
      }
    },
    "setup": {
      "title": "Setup",
      "subtitle": "Calculation surcharges and the overdelivery limit",
      "saved": "Setup updated.",
      "loading": "Loading…",
      "loadFailed": "The settings could not be loaded. Reload the page.",
      "fields": {
        "setupAdditionCalcBlock1": "Block 1 surcharge %",
        "setupAdditionCalcBlock2": "Block 2 surcharge %",
        "setupAdditionCalcBlock3": "Block 3 surcharge %",
        "setupAdditionOffer": "Quotation surcharge %",
        "setupAdditionDetritusContribution": "Waste contribution",
        "setupMaxDifferenceInAmountWithStockSheets": "Max. difference stock sheets (€)",
        "setupMaxPercentageInAmountWithOrderSupplierSheets": "Max. supplier deviation %",
        "note": "Note"
      }
    },
    "stockSheet": {
      "title": "Stock sheets",
      "new": "New stock sheet",
      "edit": "Edit stock sheet",
      "delete": "Delete",
      "loading": "Loading…",
      "empty": "No stock sheets yet",
      "notFound": "Stock sheet not found",
      "saved": "Stock sheet saved",
      "deleted": "Stock sheet deleted",
      "deleteConfirmTitle": "Delete stock sheet?",
      "deleteConfirm": "This stock sheet will be permanently deleted. This action cannot be undone.",
      "active": "Active",
      "inactive": "Inactive",
      "fields": {
        "name": "Name",
        "qualityId": "Board quality",
        "fefcoId": "Fefco",
        "sheetWidth": "Width (mm)",
        "sheetLength": "Length (mm)",
        "dimensions": "Size (W × L)",
        "qualitySupplierRelId": "Quality supplier",
        "purchasePrice": "Purchase price",
        "isActive": "Active",
        "note": "Note",
        "onHand": "Stock",
        "calculation": "Calculation",
        "product": "Product",
        "quantity": "Order quantity (sheets)",
        "reservedForAccountId": "Customer only"
      },
      "placeholders": {
        "name": "e.g. Stock 1450x3000mm F0110 B322 unscored",
        "qualityId": "Select a board quality",
        "fefcoId": "Select a Fefco code",
        "qualitySupplierRelId": "Optional — select a supplier",
        "qualitySupplierSelectQuality": "Select a board quality first",
        "purchasePrice": "e.g. 1.327",
        "product": "Search for a product",
        "reservedForAccountId": "Everyone"
      },
      "help": {
        "product": "A product from an F0110 calculation with one tier and a fixed supplier. Name, size, quality, supplier and price come from that calculation.",
        "name": "Descriptive name of the stock sheet",
        "isActive": "Active sheets are available for calculations",
        "purchasePrice": "Price per sheet used by a box cut from this stock sheet.",
        "createCalculation": "Creates an F0110 calculation for this sheet (one tier, from the supplier above) and links it. Then promote the calculation to a product and turn on stock there.",
        "reservedForAccountId": "Choose a customer if this sheet is only for that customer's boxes. Empty: any calculation can use it."
      },
      "actions": {
        "actualize": "Update purchase prices",
        "createCalculation": "Create calculation"
      },
      "actualize": {
        "done": "{count, plural, one {# stock sheet updated} other {# stock sheets updated}}",
        "failed": "Not updated: {names}",
        "reason": {
          "calculation_invalid": "the calculation could not be calculated",
          "no_price": "no price from the supplier",
          "conflict": "changed by someone else in the meantime",
          "product_not_updated": "the product could not be updated"
        }
      },
      "calculationCreated": "Calculation created and linked"
    },
    "fefco": {
      "title": "Fefco codes",
      "new": "New Fefco",
      "delete": "Delete",
      "loading": "Loading…",
      "notFound": "Fefco not found.",
      "listEmpty": "No Fefco codes yet.",
      "created": "Fefco created.",
      "saved": "Fefco saved.",
      "deleted": "Fefco deleted.",
      "active": "Active",
      "inactive": "Inactive",
      "produce": "Produce",
      "purchase": "Purchase",
      "validationId": "An ID is required.",
      "deleteConfirmTitle": "Delete Fefco?",
      "deleteConfirm": "This permanently removes the Fefco code. It cannot be deleted while it is used by a machine, a stock sheet or a calculation.",
      "sections": {
        "identification": "Identification",
        "panels": "Panel formulas",
        "packaging": "Packaging plano",
        "machine": "Machine & closure",
        "images": "Images (SVG in public/fefco/)"
      },
      "fields": {
        "id": "ID",
        "idLong": "ID (long)",
        "coupledWithFefco": "Coupled Fefco",
        "isActive": "Active",
        "canProduce": "Produce",
        "noteFefco": "Note",
        "builderFamily": "Builder family",
        "slitRelief": "Slit relief (mm)",
        "panelsWidth": "Panels width (planoWidth)",
        "panelsLength": "Panels length (planoLength)",
        "numberOfParts": "Number of parts",
        "numberOfPartsWithFefco": "Parts with Fefco",
        "allowancesWidth": "Width allowances",
        "allowancesLength": "Length allowances",
        "v1Factor": "V1 factor",
        "packagingPlanoWidth": "Packaging plano width",
        "packagingPlanoLength": "Packaging plano length",
        "packagingThickness": "Packaging thickness",
        "boxFenceNumbers": "Machine closure",
        "machineTypeNumbers": "Machine type",
        "imagePlano": "Plano image",
        "image3d": "3D image"
      },
      "hints": {
        "canProduce": "Self-produce; otherwise purchase only",
        "builderFamily": "Plano-engine builder; empty = no plano render",
        "panelsCsv": "Comma-separated expressions",
        "allowancesCsv": "Comma-separated numbers per panel",
        "v1Factor": "Formula (Base × T (board thickness) — e.g. 0.75*T)",
        "packagingPlanoWidth": "Formula (e.g. 'H' or 'B+3*T')",
        "packagingPlanoLength": "Formula (e.g. 'L+B' or 'L+2*T')",
        "packagingThickness": "Formula (e.g. '4*T' or '3*T')",
        "imagePlano": "File name without path"
      },
      "builderFamily": {
        "none": "—",
        "slotted": "slotted (0200 series)",
        "sleeve": "sleeve (0501)",
        "sheet": "sheet (0110)",
        "telescopic": "telescopic (0427)",
        "tray-locking": "tray-locking (0216, 0221)",
        "wrap-around": "wrap-around (0409, 0410)"
      },
      "gl": {
        "title": "GL variants",
        "subtitle": "Data-driven panel/allowance overrides per GL code.",
        "add": "Add variant",
        "saved": "GL variant saved.",
        "deleted": "GL variant deleted.",
        "listEmpty": "No GL variants yet.",
        "validationCode": "A GL code is required.",
        "deleteConfirmTitle": "Delete GL variant?",
        "deleteConfirm": "This permanently removes the GL variant.",
        "addTitle": "Add variant",
        "editTitle": "Edit variant",
        "actions": "Actions",
        "fields": {
          "glCode": "GL",
          "panelsLength": "Panels length",
          "allowancesLength": "Length allowances",
          "mirror": "Mirror"
        }
      },
      "validationAllowanceCount": "Each panel needs exactly one allowance: {panels} panels, {allowances} allowances. Use a dot as the decimal separator — a comma splits the value in two."
    },
    "bundleStacking": {
      "title": "Bundle stacking",
      "new": "New configuration",
      "delete": "Delete",
      "loading": "Loading…",
      "notFound": "Bundle stacking not found.",
      "listEmpty": "No bundle stacking configurations yet.",
      "created": "Bundle stacking created.",
      "saved": "Bundle stacking saved.",
      "deleted": "Bundle stacking deleted.",
      "validationId": "An ID is required.",
      "deleteConfirmTitle": "Delete bundle stacking?",
      "deleteConfirm": "This permanently removes the configuration. It cannot be deleted while it is used in saved calculations.",
      "fields": {
        "id": "ID",
        "note": "Note",
        "bundleCount": "Number of bundles",
        "orientation": "Orientation",
        "palletsLength": "Pallets in length",
        "palletsWidth": "Pallets in width",
        "palletQuantity": "Pallets total",
        "palletsGrid": "Pallets (L×W)",
        "bundlesInLength": "Bundles in length",
        "bundlesInWidth": "Bundles in width",
        "nestedLengthCoeffL": "Nested L-coeff·L",
        "nestedLengthCoeffW": "Nested L-coeff·W",
        "nestedWidthCoeffL": "Nested W-coeff·L",
        "nestedWidthCoeffW": "Nested W-coeff·W",
        "image": "Image"
      },
      "hints": {
        "id": "E.g. '2a 1x1'",
        "note": "Short description",
        "orientation": "How bundles sit on the pallet",
        "palletQuantity": "= pallets in length × pallets in width",
        "nullWhenNested": "Leave empty when nested",
        "nestedOnly": "Only for nested orientation",
        "image": "PNG file name without path"
      },
      "orientations": {
        "a": "bundle-L ∥ pallet-L ∥ colli-L",
        "b": "bundle-L ∥ pallet-W ∥ colli-W",
        "c": "bundle-L ∥ pallet-W ∥ colli-L",
        "n": "nested (mixed orientations)"
      }
    },
    "boxDesign": {
      "title": "BoxDesign",
      "length": "L (mm)",
      "width": "W (mm)",
      "height": "H (mm)",
      "fefco": "FEFCO",
      "quality": "Quality",
      "slitWidth": "Slit width (mm)",
      "variant": "Variant",
      "variants": {
        "f2011": "tape",
        "f2012": "glue (default)",
        "f2013": "tape (die-cut)",
        "f2014": "glue (die-cut)"
      },
      "gl": "GL choice",
      "verlengdGl": "Extended GL (mm)",
      "verlengdGlRequired": "Enter the length to draw.",
      "orientation": "Orientation",
      "bottom": "Bottom (flaps down)",
      "lid": "Lid (flaps up)",
      "overlap": "Overlap / h1 (mm)",
      "cornerVariant": "Corner variant",
      "slotter": "Slotter (square corner)",
      "diecut": "Die-cut (R3)",
      "tab2dInside": "2D inside",
      "tab2dOutside": "2D outside",
      "tab3d": "3D",
      "emptyState": "Fill in the fields and click Draw to generate the drawing.",
      "loading": "Loading…",
      "loading3d": "Loading 3D…",
      "export": "Export",
      "noSvg": "No SVG preview available",
      "fmtDxfDesign": "DXF design",
      "fmtSvg": "SVG",
      "flatpack": "Flat-pack",
      "assembly": "Assembly",
      "fold": "Fold",
      "generate": "Draw"
    },
    "fileViewer": {
      "drawing": "Drawing",
      "title": "FileViewer",
      "intro": "View SVG, DXF, CF2, PDF, AI, EPS, JPG, PNG and WebP files. Nothing is uploaded or stored.",
      "dropHere": "Drop a file here",
      "orClick": "or click to choose",
      "startHint": "Drop a file on the left to get started.",
      "exportPdf": "PDF",
      "exportSvg": "SVG",
      "exportWebp": "WebP",
      "unsupportedType": "Unsupported file type. Supported: SVG, DXF, CF2, PDF, AI, EPS, JPG, PNG, WebP.",
      "parseFailed": "Could not read the file:",
      "unknownError": "Unknown error",
      "statEntities": "entities",
      "statLayers": "Layers:",
      "statNotShown": "Not shown:",
      "statBbox": "bbox:",
      "statUserUnits": "(user units)",
      "statPagesOne": "page",
      "statPagesMany": "pages",
      "statSegments": "segments",
      "statLabels": "labels",
      "statPaths": "paths",
      "export": "Export",
      "truncatedNotice": "Only the start of this file is drawn — too many elements to render smoothly."
    },
    "priceLists": {
      "title": "Price lists",
      "entityTitle": "Price list {number}",
      "saved": "Price list saved",
      "deleted": "Price list deleted",
      "inUse": "A calculation or purchase order took a price from this list, so it cannot be deleted.",
      "deleteConfirmTitle": "Delete price list?",
      "deleteConfirm": "The list and its files will be deleted. Calculations then use the previous list again.",
      "losingConfirmTitle": "Save anyway?",
      "losingConfirm": "Some qualities of an added supplier are not in this list and have no price from that supplier from the effective date.",
      "thresholdsInvalid": "Enter the tier thresholds as ascending whole numbers, separated by semicolons.",
      "stand": {
        "current": "Current",
        "upcoming": "Upcoming",
        "replaced": "Replaced"
      },
      "section": {
        "general": "General",
        "suppliers": "Suppliers",
        "lines": "Lines"
      },
      "fields": {
        "listNumber": "Number",
        "offerDate": "Date",
        "validFromOrders": "New orders from",
        "validFromDeliveries": "Running orders from",
        "priceUnit": "Price per",
        "surcharge": "Small quantity surcharge",
        "thresholds": "Tier thresholds (m²)",
        "suppliers": "Suppliers",
        "lineCount": "Lines",
        "stand": "Status"
      },
      "help": {
        "validFromOrders": "An order from this day gets the prices of this list. From the supplier’s file.",
        "validFromDeliveries": "A running order with a delivery date from this day also gets the prices of this list. Taken from the PDF; without a PDF the first date.",
        "thresholdsInferred": "This list has no tier headings; the thresholds were inferred. Change them if the supplier uses other thresholds, for example 500; 1500; 5000; 10000.",
        "thresholdsFromFile": "From the column headings of the file.",
        "suppliers": "The mills this list applies to."
      },
      "lines": {
        "code": "Code",
        "priority": "P",
        "composition": "Composition",
        "from": "from {m2} m²",
        "surchargeBelow": "below {m2} m²: +{amount}",
        "matched": "Quality",
        "hasQuality": "linked",
        "noQuality": "no quality",
        "search": "Search by code or composition",
        "priceUnit": "Prices in {unit}",
        "empty": "No lines",
        "edited": "adjusted on {date}"
      },
      "import": {
        "title": "Import price list",
        "intro": "Choose the supplier’s CSV and PDF; several offers at once is fine. A CSV and a PDF with the same number belong together; a price list the app recognises can also be just a PDF. You first see what changes; nothing is saved until you click Save.",
        "choose": "Choose files",
        "noFiles": "No files chosen",
        "reading": "Reading files…",
        "savedCount": "{count, plural, one {# price list saved} other {# price lists saved}}",
        "saved": "Price list {number} saved",
        "noPdf": "without PDF",
        "pdfOnly": "PDF only, prices read from the PDF",
        "surchargeAsScale": "stored as a tier from 0 in the list",
        "chooseSuppliers": "Choose which suppliers this list applies to; the preview then appears.",
        "inferred": "inferred",
        "todayChanges": "This list already applies from today: new calculations use it straight away.",
        "matched": "{supplier}: {count, plural, one {# quality gets a price} other {# qualities get a price}}",
        "unknownCodes": "{count, plural, one {# code without a quality:} other {# codes without a quality:}}",
        "losingPrice": "{count, plural, one {# quality is not in this list and no longer gets a price from this supplier:} other {# qualities are not in this list and no longer get a price from this supplier:}}",
        "acknowledge": "I understand: these qualities no longer get a price",
        "quality": "Quality",
        "perM2": "Old → new, per m², with the difference in percent. Old is the list that applies the day before the start date.",
        "pairError": {
          "pdf_without_csv": "{file}: no CSV with the same number chosen, and the app does not recognise it as a price list. Choose the matching CSV.",
          "duplicate_csv": "{file}: another CSV with the same number is already chosen.",
          "duplicate_pdf": "{file}: another PDF with the same number is already chosen.",
          "not_csv_or_pdf": "{file}: not a CSV or PDF."
        },
        "leadTimes": "Lead times",
        "leadTimeChanges": "{count, plural, =0 {unchanged} one {# quality gets a lead time from the priority} other {# qualities get a lead time from the priority}}"
      }
    }
  },
  "search": {
    "noResults": "No results found.",
    "search": "Search...",
    "typeCommand": "Type a command or search..."
  },
  "crm": {
    "dashboard": {
      "title": "CRM",
      "leadsInQueue": "Open leads",
      "weightedPipeline": "Weighted pipeline",
      "weightedPipelineUnconverted": "{count, plural, one {# opportunity without an exchange rate is not counted} other {# opportunities without an exchange rate are not counted}}",
      "overdueActivities": "Overdue activities",
      "viewAll": "View all",
      "viewPipeline": "View pipeline"
    },
    "common": {
      "new": "New",
      "edit": "Edit",
      "delete": "Delete",
      "deleted": "Deleted",
      "deleteConfirm": "This record will be permanently deleted. This action cannot be undone.",
      "creating": "Creating…",
      "search": "Search",
      "noRecords": "No records yet.",
      "required": "Required",
      "optional": "Optional",
      "createdAt": "Created",
      "updatedAt": "Updated",
      "status": "Status",
      "convert": "Convert",
      "selected": "selected"
    },
    "lead": {
      "entity": "Lead",
      "entityPlural": "Leads",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "mobilePhone": "Mobile phone",
      "company": "Company",
      "jobTitle": "Job title",
      "source": "Source",
      "sourceDetail": "Source (name)",
      "score": "Score",
      "notes": "Notes",
      "statusNew": "New",
      "statusWorking": "Working",
      "statusQualified": "Qualified",
      "statusUnqualified": "Unqualified",
      "statusConverted": "Converted",
      "newLead": "New lead",
      "importCsv": "Import CSV",
      "runConversion": "Run conversion",
      "createNewContact": "Create new contact",
      "linkExistingContact": "Link existing contact",
      "createNewAccount": "Create new account",
      "linkExistingAccount": "Link existing account",
      "opportunityName": "Opportunity name",
      "importMapColumns": "Map columns",
      "importColumnInFile": "Column in the file",
      "importMapsTo": "Import as",
      "importSkipColumn": "Don't import"
    },
    "account": {
      "entity": "Account",
      "entityPlural": "Accounts",
      "kind": "Type",
      "kindBusiness": "Company",
      "kindConsumer": "Consumer",
      "name": "Name",
      "legalName": "Legal name",
      "accountManager": "Account manager",
      "leadSource": "Acquired via",
      "leadSourceDetail": "Acquired via (name)",
      "website": "Website",
      "industry": "Industry",
      "subIndustry": "Sub-industry",
      "newAccount": "New account",
      "saved": "Account saved.",
      "deleted": "Account deleted",
      "deleteConfirm": "This account will be permanently deleted.",
      "customer": "Customer",
      "supplier": "Supplier",
      "deliveryAddress": "Delivery address",
      "alwaysFsc": "Always FSC",
      "alwaysPrintCode": "Always print code",
      "alwaysPrintResy": "Always print RESY",
      "pricesTwoDecimals": "Prices in 2 decimals",
      "sendPriceList": "Send price list on price change",
      "sendPriceListYes": "Receives a price list",
      "lastPriceListDate": "Last price list sent",
      "isTrader": "Reseller",
      "protectedBy": "Protected by",
      "parentAccount": "Parent company",
      "protectedByLine": "Protected relationship of {trader}",
      "relationStatus": "Relationship status",
      "role": "Role",
      "statusTrader": "Reseller",
      "statusProtected": "Protected",
      "statusUnprotected": "Unprotected",
      "debtorNumber": "Debtor number",
      "lastArticleSeq": "Last article sequence",
      "lastArticleNumberIs": "Last article number: {number}",
      "firstArticleNumberWillBe": "The first article number will be {number}",
      "lastArticleSeqNoDebtor": "Without a debtor number a product gets no article number.",
      "creditorNumber": "Creditor number",
      "registrationNumber": "Registration number",
      "vatNumber": "VAT number",
      "defaultPaymentTerm": "Default payment term",
      "creditLimit": "Customer credit limit (insured)",
      "supplierCreditLimit": "Credit with this supplier",
      "creditLimitDefaultHint": "Empty = default {limit}",
      "creditHold": "Credit hold",
      "invoiceBundling": "Invoicing",
      "invoiceBundlingDesc": "Decides whether the nightly run and the invoice button may put lines from different orders on one invoice.",
      "invoiceBundlingPerOrder": "Per order",
      "invoiceBundlingCollect": "Collective invoice",
      "iban": "IBAN",
      "bic": "BIC",
      "bankName": "Bank name",
      "primaryCurrency": "Primary currency",
      "phone": "Phone",
      "email": "Email",
      "openingHours": "Opening hours",
      "notes": "Note",
      "delivery": {
        "tab": "Delivery details",
        "colloType": "Collo/pallet type",
        "palletSize": "Pallet size (cm)",
        "colloMaxHeight": "Max collo height (cm)",
        "maxUndersupply": "Max. under-delivery (%)",
        "maxOversupply": "Max. over-delivery (%)",
        "palletLabelPlacement": "Pallet label placement",
        "emptyPackagingOff": "Delivery fields appear when the Packaging module is enabled.",
        "restriction1": "Delivery restriction 1",
        "restriction2": "Delivery restriction 2",
        "notesDelivery": "Delivery notes",
        "deliveryTxtForTransporter": "Text for transporter",
        "openingHours": "Delivery times",
        "weekday": {
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri"
        }
      },
      "activeSince": "Relationship since",
      "activeSinceYears": "{years} years of relationship",
      "logo": "Customer logo",
      "logoSaveFirst": "Save the account first to add a logo.",
      "logoTooLarge": "Logo is too large (max 5 MB).",
      "logoUploading": "Uploading…",
      "logoReplace": "Choose a logo",
      "logoUploaded": "Logo uploaded",
      "logoRemove": "Remove logo"
    },
    "contact": {
      "entity": "Contact",
      "entityPlural": "Contacts",
      "type": "Type",
      "typePerson": "Person",
      "typeDepartment": "Department",
      "firstName": "First name",
      "lastName": "Last name",
      "name": "Name",
      "middleName": "Middle name",
      "account": "Account",
      "email": "Email",
      "phoneMobile": "Mobile",
      "phoneWork": "Work phone",
      "jobTitle": "Job title",
      "notes": "Note",
      "roles": "Documents & messages",
      "rolesSales": "Sales",
      "rolesPurchase": "Purchasing",
      "roleQuote": "Quote",
      "roleOrderConfirmation": "Order confirmation",
      "roleShipping": "Freight notice / packing slip / waybill",
      "roleShippingCarrier": "Carrier freight notice",
      "roleSalesInvoice": "Sales invoices + credit notes",
      "roleDunning": "Reminders + statements",
      "rolePurchaseOrder": "Purchase orders",
      "rolePurchaseInvoice": "Purchase invoices",
      "emailOptIn": "Opt in/out",
      "mailings": "Mailings",
      "newContact": "New contact",
      "searchAccount": "Search account…"
    },
    "opportunity": {
      "primaryContact": "Primary contact",
      "entity": "Opportunity",
      "entityPlural": "Opportunities",
      "name": "Name",
      "account": "Account",
      "pipeline": "Pipeline",
      "stage": "Stage",
      "amount": "Amount",
      "currency": "Currency",
      "probability": "Probability",
      "expectedCloseDate": "Expected close",
      "closeReason": "Close reason",
      "newOpportunity": "New opportunity",
      "viewKanban": "Kanban",
      "viewList": "List",
      "changeStage": "Change stage",
      "closed": "Closed",
      "won": "Won",
      "lost": "Lost"
    },
    "visit": {
      "entity": "Visit",
      "entityPlural": "Visitors",
      "newVisit": "New visitor",
      "createdToast": "Visitor added",
      "description": "Description",
      "visitorName": "Visitor",
      "company": "Company",
      "companyTyped": "{name} (not in CRM)",
      "host": "Host",
      "location": "Location",
      "purpose": "Purpose",
      "expectedAt": "Expected",
      "durationMinutes": "Expected duration (min)",
      "durationHint": "Auto-checkout after this many minutes on site",
      "badgeNumber": "Badge",
      "notes": "Notes",
      "status": "Status",
      "statusExpected": "Expected",
      "statusOnSite": "On-site",
      "statusLeft": "Left",
      "checkIn": "Check in",
      "checkOut": "Check out"
    },
    "activity": {
      "entity": "Activity",
      "entityPlural": "Activities",
      "type": "Type",
      "typeCall": "Call",
      "typeMeeting": "Meeting",
      "onSite": "On-site",
      "onSiteHint": "Takes place at our own premises",
      "typeEmail": "Email",
      "typeTask": "Task",
      "typeNote": "Note",
      "subject": "Subject",
      "body": "Body",
      "dueAt": "Due",
      "completedAt": "Completed",
      "priority": "Priority",
      "priorityLow": "Low",
      "priorityNormal": "Normal",
      "priorityHigh": "High",
      "relatedTo": "Related to",
      "relatedRecord": "Record",
      "markComplete": "Mark complete",
      "outcome": "Outcome",
      "myOpen": "My open",
      "overdue": "Overdue",
      "completed": "Completed",
      "newActivity": "New activity"
    },
    "settings": {
      "visitors": {
        "title": "Visitor settings",
        "enabled": "End-of-day checkout",
        "endOfDayTime": "Time",
        "endOfDayHint": "Automatically check out everyone still on site at the set time",
        "timeRequired": "Set a time to enable end-of-day checkout",
        "timezone": "Timezone",
        "timezoneHint": "IANA name, e.g. Europe/Amsterdam"
      },
      "pipelines": {
        "title": "Pipelines",
        "newPipeline": "New pipeline",
        "defaultBadge": "Default",
        "setDefault": "Set as default",
        "stages": "Stages",
        "newStage": "New stage",
        "stageName": "Stage name",
        "stageColor": "Color",
        "stageProbability": "Probability (%)",
        "isWon": "Won",
        "isLost": "Lost"
      },
      "webhooks": {
        "title": "Webhooks",
        "newWebhook": "New webhook",
        "editWebhook": "Edit webhook",
        "secretRevealTitle": "Save this secret now",
        "secretRevealHelp": "You won't see it again. Store it in your integration.",
        "copySecret": "Copy secret",
        "token": "Token",
        "rateLimitPerMin": "Rate limit / min",
        "deliveries": "Deliveries",
        "lastReceived": "Last received",
        "receiptCount": "Received",
        "allowedOrigins": "Allowed origins",
        "allowedOriginsHelp": "One address per line, such as https://www.example.com. Empty lets every origin through. Once you fill it in, the webhook only accepts a request that comes from one of these addresses; a server posting on its own usually sends no origin and is then refused.",
        "deleteDescription": "The webhook accepts no more leads after this. It stays in the list as Inactive, with its deliveries, and you switch it back on with Active in the edit window.",
        "message": "Message",
        "result": {
          "success": "Lead created",
          "validation_error": "Refused",
          "rate_limited": "Too many requests",
          "duplicate": "Duplicate",
          "server_error": "Server error"
        }
      },
      "currency": {
        "title": "Currency",
        "primaryCurrency": "Primary currency",
        "rateSource": "Rate source",
        "rateSourceManual": "Manual entry",
        "rateSourceApi": "API provider",
        "provider": "Provider",
        "providerKey": "API key",
        "refreshSchedule": "Refresh schedule",
        "scheduleDaily": "Daily",
        "scheduleWeekly": "Weekly",
        "scheduleOnDemand": "On demand",
        "fetchNow": "Fetch now",
        "lastRefresh": "Last refresh",
        "rates": "Rates",
        "fromCurrency": "From",
        "toCurrency": "To",
        "rate": "Rate",
        "effectiveDate": "Effective date",
        "currencySelection": "Currency selection",
        "currencySelectionPlaceholder": "Select currencies",
        "currencySelectionSearch": "Search currencies…",
        "currencySelectionEmpty": "No currencies",
        "currencySelectionReload": "Reload",
        "currencySelectionHint": "Currencies to keep rates for. Empty keeps every currency the provider returns. Save your API key first, then reload.",
        "createTitle": "Add manual rate",
        "editTitle": "Edit {from} → {to}",
        "deleteTitle": "Delete {from} → {to}?",
        "deleteDescription": "This removes the rate for {date}. If you're on the API source, the next refresh will re-fetch it.",
        "deleteAll": "Delete all",
        "deleteAllTitle": "Delete all currency rates?",
        "deleteAllDescription": "Removes every row in this workspace ({count}). If you're on the API source, the next refresh will repopulate today's rates, but historical rates are gone for good.",
        "deleteAllToast": "Deleted {count} rates",
        "providerKeyHint": "ECB is keyless. Leave blank to keep the existing value.",
        "currencySelectionSelected": "{count} selected",
        "fetchedToast": "{count} rates fetched",
        "lastRefreshError": "Error",
        "status": {
          "success": "Succeeded",
          "failed": "Failed"
        }
      },
      "lookups": {
        "title": "Lookups",
        "newEntry": "New entry",
        "key": "Key",
        "name": "Name",
        "sortOrder": "Sort order",
        "active": "Active",
        "keyHint": "lowercase, underscores, starts with a letter",
        "tables": {
          "lead_sources": "Lead Sources",
          "industries": "Industries",
          "sub_industries": "Sub-industries",
          "account_types": "Account Types",
          "lifecycle_stages": "Lifecycle Stages",
          "deal_types": "Deal Types",
          "forecast_categories": "Forecast Categories",
          "close_reasons": "Close Reasons",
          "competitors": "Competitors",
          "campaigns": "Campaigns",
          "certification_types": "Certification Types",
          "delivery_restrictions": "Delivery restrictions"
        },
        "valueEn": "Name (EN)",
        "valueNl": "Name (NL)",
        "valueDe": "Name (DE)",
        "valueFr": "Name (FR)",
        "notes": "Note",
        "tabs": {
          "identification": "Identification",
          "translations": "Translated values"
        }
      },
      "seed": {
        "button": "Seed defaults",
        "confirmTitle": "Seed CRM defaults?",
        "confirmBody": "This inserts default rows into the 10 CRM lookup tables, creates a default sales pipeline with 6 stages (if none exists), and ensures the currency settings row exists. The operation is idempotent — existing rows are preserved.",
        "alreadySeeded": "Already seeded — nothing to do",
        "done": "CRM defaults seeded"
      }
    },
    "timeline": {
      "commented": "Commented",
      "eventFallback": "Event",
      "event": {
        "created": "Created",
        "updated": "Updated",
        "deleted": "Deleted",
        "restored": "Restored",
        "stage_changed": "Stage changed",
        "owner_changed": "Owner changed",
        "converted": "Converted",
        "tag_added": "Tag added",
        "tag_removed": "Tag removed",
        "comment_added": "Comment added",
        "won": "Won",
        "lost": "Lost",
        "vat_verified": "VAT verified"
      },
      "by": "by"
    },
    "certification": {
      "entityPlural": "Certifications",
      "add": "Add certification",
      "edit": "Edit certification",
      "type": "Type",
      "certificateNumber": "Certificate number",
      "issuingBody": "Issuing body",
      "validFrom": "Valid from",
      "validUntil": "Valid until",
      "scope": "Scope",
      "notes": "Notes",
      "documents": "Documents",
      "saved": "Certification saved",
      "deleteConfirm": "This certification and its documents will be permanently removed.",
      "statusActive": "Active",
      "statusSuspended": "Suspended",
      "statusPending": "Pending",
      "statusWithdrawn": "Withdrawn",
      "badgeExpiring": "Expiring soon",
      "badgeExpired": "Expired"
    }
  },
  "rbac": {
    "teams": {
      "title": "Teams",
      "subtitle": "Groups of users who get the same roles together.",
      "created": "Team created",
      "updated": "Team updated",
      "deleted": "Team deleted",
      "delete": "Delete",
      "remove": "Remove",
      "create": "Create",
      "createTitle": "Create team",
      "createBody": "Pick a descriptive name. Members can be added next.",
      "deleteTitle": "Delete team",
      "deleteBody": "Members lose the roles they had through this team; their own roles stay. This cannot be undone.",
      "empty": "No teams yet. Create one to start grouping users.",
      "members": "Members",
      "name": "Name",
      "description": "Description",
      "memberAdded": "Member added",
      "memberRemoved": "Member removed",
      "searchUsers": "Search by name or email",
      "noMatches": "No matching users",
      "noMembers": "No members yet",
      "descPlaceholder": "Optional",
      "editTitle": "Edit team",
      "roles": "Roles",
      "rolesHint": "Everyone on this team gets these roles on top of their own. A team can only grant, never take away.",
      "noRoles": "No roles yet. Assign one so members inherit its permissions.",
      "roleAdded": "Role assigned to team",
      "roleRemoved": "Role removed from team",
      "removeRole": "Remove role",
      "details": "Details",
      "notFound": "Team not found.",
      "help": {
        "title": "How teams work",
        "intro": "A team is a named group of people. Its main use is giving the same roles to everyone in it at once, instead of assigning roles person by person.",
        "members": "Members: add people to the team. Someone can be in several teams.",
        "roles": "Roles: everyone in the team gets these roles on top of their own.",
        "limit": "A team can only add permissions, never take them away. To restrict someone, deny the permission on one of their own roles.",
        "count": "The Users count on Roles & Permissions also includes people who have a role through a team."
      }
    },
    "roles": {
      "title": "Roles & Permissions",
      "subtitle": "Manage who can read, write, and administer data in each module.",
      "new": "Create role",
      "columnType": "Type",
      "columnUsers": "Users",
      "system": "System",
      "custom": "Custom",
      "clone": "Clone",
      "empty": "No roles yet.",
      "emptyCustom": "No custom roles yet. Create your own, or take a look at the system roles first.",
      "viewSystem": "Check out the system roles",
      "created": "Role created",
      "updated": "Role updated",
      "deleted": "Role deleted",
      "cloned": "Role cloned",
      "deleteTitle": "Delete role?",
      "deleteBody": "Users currently assigned this role will lose its grants. This cannot be undone.",
      "detailsBody": "After the role exists you'll be taken to the editor to pick which module actions and fields it grants.",
      "keyLabel": "Key",
      "keyHint": "Lowercase letters, numbers, and underscores. Used as the stable identifier in the DB; cannot be renamed after creation.",
      "keyInvalid": "Must start with a letter and contain only a-z, 0-9, _",
      "back": "Back",
      "systemReadonly": "System role (read-only)",
      "saveChanges": "Save changes",
      "notFound": "Role not found",
      "loadingRegistry": "Loading module registry…",
      "allFields": "All fields",
      "inheritedHint": "through a broader right: on all fields, the whole module or all modules",
      "showFields": "Show fields ({count})",
      "hideFields": "Hide fields ({count})",
      "sensitive": "sensitive",
      "denyHint": "Ctrl+click to toggle deny",
      "actionRead": "Read",
      "actionCreate": "Create",
      "actionUpdate": "Update",
      "actionDelete": "Delete",
      "actionManage": "Manage",
      "actionReassign": "Reassign",
      "assignTitle": "Users & Roles",
      "assignSubtitle": "Assign roles to users.",
      "userColumn": "User",
      "rolesColumn": "Roles",
      "noRoles": "No roles",
      "sys": "sys",
      "systemNames": {
        "admin": "Admin",
        "member": "Member",
        "hr_admin": "HR Admin",
        "hr_viewer": "HR Viewer",
        "accountant": "Accountant",
        "purchaser": "Purchaser",
        "payroll_admin": "Payroll Admin",
        "sales_rep": "Sales rep",
        "sales_manager": "Sales manager",
        "marketing": "Marketing",
        "support": "Support",
        "inventory_viewer": "Inventory Viewer",
        "inventory_manager": "Inventory Manager",
        "production_viewer": "Production Viewer",
        "production_planner": "Production Planner",
        "logistics_viewer": "Logistics Viewer",
        "logistics_manager": "Logistics Manager",
        "integrations_admin": "Integrations Admin",
        "integrations_viewer": "Integrations Viewer",
        "ppwr_viewer": "PPWR Viewer",
        "ppwr_manager": "PPWR Manager",
        "calculator": "Calculator",
        "packaging_manager": "Packaging Manager",
        "product_viewer": "Product Viewer",
        "product_manager": "Product Manager",
        "project_member": "Project Member",
        "project_manager": "Project Manager",
        "hr_time": "HR time registration",
        "time_clock": "Time clock"
      },
      "systemDescriptions": {
        "admin": "Owner-level access: can do everything. Workspace managers get this role by default.",
        "member": "Default role. Self-service only: own attendance, payslips and leave.",
        "hr_admin": "Full HR access across all entities and fields.",
        "hr_viewer": "Read-only HR; sensitive fields (salary, payroll amounts, contract text, ID number, IBAN, address) hidden.",
        "accountant": "Full finance access, plus read-only sight of purchase orders.",
        "purchaser": "Creates and manages purchase orders to suppliers.",
        "payroll_admin": "Reads employees including salary and runs payroll. Does not manage hiring.",
        "sales_rep": "Manages leads, opportunities, accounts, contacts, activities and visits.",
        "sales_manager": "Full CRM and sales access.",
        "marketing": "Full lead access; opportunities, accounts and contacts read-only.",
        "support": "Reads leads and opportunities; updates accounts and contacts.",
        "inventory_viewer": "Read-only inventory: catalogue, stock levels and movements; cost amounts hidden.",
        "inventory_manager": "Full inventory access: catalogue, adjustments, transfers, lots and serials.",
        "production_viewer": "Read-only access to production orders.",
        "production_planner": "Plans production orders and marks them complete.",
        "logistics_viewer": "Read-only access to shipments, colli, delivery methods, transport zones and rates.",
        "logistics_manager": "Manages delivery methods, transport zones and rates, and processes shipments and colli.",
        "integrations_admin": "Configures connections and tasks, runs them and reads the message log and datasets.",
        "integrations_viewer": "Reads tasks, the message log and datasets, for diagnosis.",
        "ppwr_viewer": "Read-only access to packaging declarations and the issued documents.",
        "ppwr_manager": "Manages the type declaration per article and the uploaded static declarations.",
        "calculator": "Creates and maintains packaging calculations and their master data. Deleting stays with the packaging manager.",
        "packaging_manager": "Full packaging access: calculations, FEFCO, qualities, machines and master data.",
        "product_viewer": "Read-only access to the product master.",
        "product_manager": "Full product master access: articles, prices, attachments and barcodes.",
        "project_member": "Works inside projects: reads everything and keeps tasks, time entries and polls up to date. Does not create or delete projects.",
        "project_manager": "Full projects access: projects, milestones, tasks, members, time and polls.",
        "hr_time": "Keeps time registrations and leave up to date; cannot see salary, national ID or IBAN.",
        "time_clock": "For a badge scanner: may only register scans."
      },
      "copyName": "{name} (copy)"
    }
  },
  "email": {
    "compose": {
      "title": "Compose email",
      "tab": {
        "edit": "Edit",
        "preview": "Preview"
      },
      "field": {
        "template": "Template",
        "templateLoading": "Loading templates…",
        "to": "To",
        "cc": "Cc",
        "bcc": "Bcc",
        "subject": "Subject",
        "body": "Body",
        "attachPdf": "Attach PDF"
      },
      "preview": {
        "loading": "Rendering preview…",
        "subject": "Subject",
        "frameTitle": "Email preview"
      },
      "action": {
        "send": "Send",
        "preview": "Preview",
        "backToEdit": "Back to edit"
      },
      "error": {
        "invalidEmail": "Not a valid email address: {email}"
      },
      "toast": {
        "sent": "Email queued for delivery"
      },
      "warnings": {
        "title": "Check before sending",
        "hint": "These do not block the send, but you have to acknowledge them.",
        "openSubject": "Open article"
      }
    },
    "sent": {
      "title": "Sent",
      "empty": "This document has not been sent yet.",
      "deleted": "Send record deleted",
      "status": {
        "queued": "Queued",
        "sent": "Sent",
        "failed": "Failed",
        "cancelled": "Cancelled"
      },
      "deleteDialog": {
        "title": "Delete send record?",
        "body": "The row disappears from the send history, together with the per-recipient delivery status. This cannot be undone."
      },
      "resend": "Resend",
      "resent": "Queued again",
      "resendDialog": {
        "title": "Resend?",
        "body": "This exact stored document is sent again to {to}. No new PDF is created."
      }
    }
  },
  "finance": {
    "numbering": {
      "title": "Finance numbering",
      "soort": "Kind",
      "format": "Format",
      "startNumber": "Start number",
      "currentNumber": "Current number",
      "notStarted": "Not started yet",
      "empty": "No document kinds",
      "editConfig": "Edit numbering",
      "adjustNumber": "Adjust number",
      "adjustWarning": "Numbers already issued keep their format. The new number cannot be lower than the current one.",
      "placeholderHelp": "Available codes:",
      "counterRequired": "The format must include the counter:"
    },
    "common": {
      "save": "Save",
      "saving": "Saving…",
      "cancel": "Cancel",
      "delete": "Delete",
      "close": "Close",
      "loading": "Loading…",
      "none": "(none)"
    },
    "page": {
      "invoices": "Invoices",
      "creditNotes": "Credit notes",
      "bills": "Bills",
      "debitNotes": "Debit notes"
    },
    "document": {
      "kind": {
        "ar_invoice": "Sales invoice",
        "ar_credit_note": "Credit note",
        "ap_bill": "Bill",
        "ap_debit_note": "Debit note"
      },
      "status": {
        "draft": "Draft",
        "issued": "Issued",
        "sent": "Sent",
        "paid": "Paid",
        "partial": "Partially paid",
        "void": "Void",
        "converted": "Converted",
        "pending_approval": "Pending approval",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "section": {
        "lines": "Lines",
        "notes": "Notes",
        "termsConditions": "Terms & conditions",
        "general": "Details"
      },
      "field": {
        "customer": "Customer",
        "supplier": "Supplier",
        "currency": "Currency",
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "paymentTerm": "Payment term",
        "customerReference": "Customer reference",
        "supplierReference": "Supplier reference",
        "notes": "Notes",
        "extraText": "Extra text"
      },
      "totals": {
        "subtotal": "Subtotal",
        "discount": "Discount",
        "shipping": "Shipping",
        "tax": "Tax",
        "total": "Total"
      },
      "action": {
        "issue": "Issue",
        "send": "Send",
        "void": "Void",
        "delete": "Delete",
        "applyToInvoice": "Apply to invoice",
        "downloadPdf": "Download PDF",
        "downloadingPdf": "Preparing PDF…"
      },
      "deleteDialog": {
        "title": "Delete this draft?",
        "body": "This will permanently remove the draft document."
      },
      "voidDialog": {
        "title": "Void document?",
        "body": "The document is kept with status Void, so it remains part of the record of facts. This cannot be undone.",
        "confirm": "Void document"
      },
      "applyDialog": {
        "title": "Apply credit note",
        "body": "Choose this customer's open invoices to settle the credit note against.",
        "overAllocated": "The allocations exceed the credit note's open amount."
      },
      "draftLabel": "Draft",
      "unnumberedLabel": "Not yet numbered",
      "notEditable": "This document is not editable",
      "atLeastOneLine": "At least one line is required",
      "partnerRequired": "Partner is required",
      "newTitle": "New {kind}"
    },
    "lineItem": {
      "column": {
        "description": "Description",
        "quantity": "Qty",
        "unitPrice": "Unit price",
        "discountPercent": "Disc %",
        "tax": "Tax",
        "total": "Total"
      },
      "addLine": "Add line",
      "removeAriaLabel": "Remove line",
      "dragAriaLabel": "Drag to reorder",
      "noLinesYet": "No lines yet.",
      "loadTaxFailed": "Failed to load tax rates",
      "shipping": {
        "title": "Shipping",
        "amount": "Delivery costs",
        "taxRate": "Tax rate"
      }
    },
    "list": {
      "column": {
        "number": "Number",
        "name": "Name",
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "total": "Total",
        "currency": "Currency",
        "status": "Status"
      },
      "filter": {
        "status": "Status",
        "allPartners": "All partners"
      },
      "empty": "No documents yet.",
      "deleteDialog": {
        "title": "Delete this draft?",
        "body": "This will permanently remove the draft document."
      }
    },
    "toast": {
      "saved": "Document saved",
      "issued": "Issued as {number}",
      "voided": "Voided",
      "creditApplied": "Credit note applied",
      "deleted": "Document deleted"
    },
    "autoInvoicing": {
      "title": "Invoicing",
      "enabledLabel": "Invoice automatically",
      "enabledDesc": "Every night, bundle released order lines into invoices, issue them and send them.",
      "time": "Time (UTC)",
      "timeDesc": "The run starts at the first quarter-hour after this time.",
      "from": "Sender",
      "fromDesc": "Leave empty to use the administration e-mail address."
    },
    "dunning": {
      "title": "Dunning",
      "enabledLabel": "Send overdue reminders automatically",
      "reminderL1Days": "First reminder (days overdue)",
      "reminderL2Days": "Second reminder (days overdue)",
      "reminderFinalDays": "Final notice (days overdue)",
      "helpText": "Reminders are sent shortly after midnight on the day a document crosses each threshold."
    },
    "payment": {
      "page": {
        "title": "Payments",
        "new": "Record payment"
      },
      "kind": {
        "received": "Received",
        "made": "Made",
        "credit_application": "Credit applied"
      },
      "status": {
        "confirmed": "Confirmed"
      },
      "creditNoteApplied": "Credit note {number} applied",
      "filter": {
        "all": "All payments"
      },
      "column": {
        "date": "Date",
        "kind": "Direction",
        "amount": "Amount",
        "status": "Status",
        "memo": "Memo"
      },
      "field": {
        "kind": "Direction",
        "partner": "Partner",
        "date": "Date",
        "currency": "Currency",
        "amount": "Amount",
        "memo": "Memo"
      },
      "section": {
        "allocations": "Allocations"
      },
      "action": {
        "recordPayment": "Record payment"
      },
      "allocation": {
        "empty": "No allocations.",
        "addRow": "Add allocation",
        "remainingLabel": "Remaining",
        "selectDocumentPlaceholder": "Select document…",
        "fillRemaining": "Fill with amount due",
        "fill": "Fill",
        "pickPartnerFirst": "Pick a partner to see open documents.",
        "overAllocated": "Allocations exceed the payment amount.",
        "column": {
          "document": "Document",
          "kind": "Kind",
          "due": "Due",
          "applied": "Applied"
        }
      },
      "list": {
        "empty": "No payments yet."
      },
      "toast": {
        "created": "Payment recorded",
        "deleted": "Payment deleted",
        "updated": "Payment updated"
      },
      "deleteDialog": {
        "title": "Delete this payment?",
        "body": "Allocations on this payment will be reversed and the affected documents recomputed."
      },
      "loadFailed": "Failed to load payment",
      "dialog": {
        "title": "Record payment",
        "remaining": "Remaining"
      }
    },
    "aging": {
      "page": {
        "arTitle": "AR aging",
        "apTitle": "AP aging"
      },
      "asOf": "As of {date}",
      "bucket": {
        "current": "Current",
        "1_30": "1–30 days",
        "31_60": "31–60 days",
        "61_90": "61–90 days",
        "90_plus": "90+ days"
      },
      "column": {
        "number": "Number",
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "daysOverdue": "Days overdue",
        "amountDue": "Amount due"
      },
      "totals": {
        "grandTotal": "Grand total"
      },
      "empty": "No outstanding documents.",
      "loadFailed": "Failed to load aging report"
    },
    "recurring": {
      "page": {
        "title": "Recurring schedules",
        "newTitle": "New recurring schedule",
        "detailTitle": "Recurring schedule"
      },
      "frequency": {
        "weekly": "Weekly",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "yearly": "Yearly"
      },
      "mode": {
        "draft": "Save as draft",
        "auto_send": "Issue & email",
        "auto_issue": "Issue"
      },
      "status": {
        "active": "Active",
        "completed": "Completed",
        "canceled": "Canceled",
        "paused": "Paused"
      },
      "field": {
        "name": "Schedule name",
        "kind": "Document type",
        "partner": "Partner",
        "currency": "Currency",
        "frequency": "Frequency",
        "startDate": "Start date",
        "endDate": "End date",
        "maxOccurrences": "Max occurrences",
        "mode": "Mode",
        "sendTo": "Send to",
        "sendToPlaceholder": "comma-separated emails",
        "paymentTerm": "Payment term",
        "templateNotes": "Notes",
        "templateTerms": "Terms"
      },
      "section": {
        "schedule": "Schedule",
        "template": "Document template",
        "delivery": "Delivery",
        "history": "Run history",
        "preview": "Next runs preview"
      },
      "column": {
        "name": "Name",
        "partner": "Partner",
        "frequency": "Frequency",
        "nextRunDate": "Next run",
        "occurrencesCount": "Runs",
        "status": "Status",
        "mode": "Mode"
      },
      "history": {
        "column": {
          "runAt": "Run at",
          "documentNumber": "Document",
          "status": "Status",
          "error": "Error"
        },
        "empty": "No runs yet.",
        "statusSuccess": "Success",
        "statusFailed": "Failed"
      },
      "action": {
        "create": "Create schedule",
        "pause": "Pause",
        "resume": "Resume",
        "delete": "Delete",
        "cancelSchedule": "Cancel schedule"
      },
      "toast": {
        "created": "Schedule created",
        "saved": "Schedule saved",
        "paused": "Schedule paused",
        "resumed": "Schedule resumed",
        "canceled": "Schedule canceled",
        "deleted": "Schedule deleted"
      },
      "cancelDialog": {
        "title": "Cancel this schedule?",
        "body": "Future generation will stop. The schedule and run history are kept for reference."
      },
      "deleteDialog": {
        "title": "Delete this schedule?",
        "body": "This permanently removes the schedule and its run history. Generated documents are kept."
      },
      "list": {
        "empty": "No recurring schedules yet."
      },
      "filter": {
        "all": "All",
        "active": "Active only",
        "completed": "Completed",
        "canceled": "Canceled"
      },
      "occurrencesLabel": "{count} of {max}",
      "occurrencesLabelOpen": "{count} runs",
      "loadFailed": "Failed to load schedule"
    },
    "reports": {
      "loadFailed": "Failed to load report",
      "empty": "No data for the selected range.",
      "field": {
        "dateRange": "Date range",
        "currency": "Currency",
        "pickRange": "Pick a date range"
      },
      "sales": {
        "title": "Sales",
        "subtitle": "Net revenue by month and tax rate: issued, partial and paid invoices, less credit notes.",
        "grandTotal": "Grand total",
        "byMonth": {
          "title": "Sales by month"
        },
        "byTax": {
          "title": "Sales by tax rate"
        },
        "column": {
          "month": "Month",
          "total": "Total",
          "invoices": "Invoices",
          "taxRate": "Tax rate",
          "percentage": "Rate",
          "taxable": "Taxable amount",
          "tax": "Tax amount"
        }
      },
      "cashflow": {
        "title": "Cashflow",
        "subtitle": "Money received vs money paid out, by month.",
        "netLabel": "Net",
        "chart": {
          "title": "Inflow vs outflow"
        },
        "column": {
          "month": "Month",
          "inflow": "Inflow",
          "outflow": "Outflow",
          "net": "Net"
        }
      },
      "topCustomers": {
        "title": "Top customers",
        "subtitle": "Customers with the highest net revenue (invoices less credit notes) in the selected range.",
        "field": {
          "limit": "Show top"
        },
        "chart": {
          "title": "Revenue by customer"
        },
        "table": {
          "title": "Detail"
        },
        "column": {
          "partner": "Customer",
          "email": "Email",
          "revenue": "Revenue",
          "invoices": "Invoices",
          "lastInvoice": "Last invoice"
        }
      },
      "outstanding": {
        "title": "Outstanding invoices",
        "asOf": "As of {date}",
        "grandTotal": "Total outstanding",
        "invoiceCount": "{count} invoice(s)",
        "field": {
          "asOf": "As of"
        },
        "column": {
          "number": "Number",
          "issueDate": "Issue date",
          "dueDate": "Due date",
          "daysOverdue": "Days overdue",
          "amountDue": "Amount due"
        }
      }
    },
    "credit": {
      "title": "Credit",
      "defaultLimit": "Default credit limit",
      "defaultLimitDesc": "Applies to a customer without a limit of its own: your own assessment, below the threshold above which the insurer assesses. Excluding VAT, in the base currency.",
      "alert": {
        "exceeded": "Credit limit exceeded: outstanding {open} + in the pipeline {pipeline} = {total}, limit {limit} ({source}). Amounts excluding VAT.",
        "supplierExceeded": "Credit with this supplier exceeded: outstanding {open} + on order {pipeline} = {total}, credit {limit} ({source}). Amounts excluding VAT.",
        "insured": "insured",
        "default": "default",
        "group": "group {holder}",
        "incomplete": "Amounts in {currencies} are not included: there is no exchange rate."
      }
    },
    "home": {
      "intro": "Invoices, payments and reports.",
      "cards": {
        "invoices": "Invoices to your customers",
        "creditNotes": "Credit notes on sales invoices",
        "bills": "Invoices from your suppliers",
        "debitNotes": "Debit notes on purchase invoices",
        "payments": "Amounts received and paid, matched to invoices",
        "recurring": "Invoices that come back on a fixed schedule",
        "arAging": "What customers still owe, by age",
        "apAging": "What you still owe suppliers, by age",
        "sales": "Net revenue per month and VAT rate",
        "cashflow": "Amounts received and paid per month",
        "topCustomers": "Customers with the highest net revenue",
        "outstanding": "All outstanding invoices"
      }
    }
  },
  "werktekeningen": {
    "title": "Working drawings"
  },
  "common": {
    "openWebsite": "Open website",
    "waitingForMe": "Waiting for me",
    "webhookDelivery": {
      "signature": "The signature does not match. Check that the sender uses this webhook's secret.",
      "origin": "The request came from an origin that is not under Allowed origins.",
      "rateLimited": "More than {limit} requests per minute."
    },
    "view": "View",
    "sortAscending": "Ascending",
    "sortDescending": "Descending",
    "hideColumn": "Hide column",
    "creating": "Creating…",
    "deleting": "Deleting…",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "saved": "Changes saved",
    "send": "Send",
    "address": {
      "street": "Street",
      "postalCode": "Postal code",
      "city": "City",
      "countryCode": "Country code",
      "stateRegion": "State / region",
      "registered": "Registered address",
      "postal": "Postal address",
      "billing": "Billing address",
      "shipping": "Shipping address",
      "sameAsRegistered": "Same as registered",
      "companyName": "Company name",
      "openInMaps": "View on map"
    },
    "saving": "Saving…",
    "vat": {
      "verify": "Verify",
      "verifying": "Verifying…",
      "checkedAt": "Checked {date}",
      "hintSaveFirst": "Save first to verify",
      "hintCompanyVatFirst": "Verify your own company VAT first",
      "active": "VAT validation (VIES)",
      "activeDesc": "Validate EU VAT numbers against the VIES service.",
      "status": {
        "valid": "Valid",
        "invalid": "Invalid",
        "unverified": "Unverified",
        "unavailable": "Unavailable"
      }
    },
    "name": "Name",
    "description": "Description",
    "active": "Active",
    "inactive": "Inactive",
    "all": "All",
    "status": "Status",
    "loading": "Loading…",
    "delete": "Delete",
    "language": "Language",
    "month": "Month",
    "year": "Year",
    "unsavedChangesConfirm": "You have unsaved changes. Leave without saving?",
    "versionConflict": "Someone else changed this record in the meantime. Your unsaved changes have been replaced with the latest data — re-enter them and save again.",
    "serverError": "Something went wrong on the server. The data on this screen may be incomplete — try again or reload the page.",
    "requiredFieldsMissing": "Fill in the required fields: {fields}",
    "combobox": {
      "clear": "Clear",
      "typeToSearch": "Type to search…",
      "searchPlaceholder": "Search…",
      "noResults": "No results"
    },
    "image": {
      "openInNewTab": "Open in new tab",
      "download": "Download",
      "print": "Print",
      "close": "Close",
      "previous": "Previous",
      "next": "Next",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "fit": "Fit",
      "downloadFailed": "Download failed"
    },
    "download": "Download",
    "deleteNamedConfirm": "\"{name}\" will be permanently deleted. This action cannot be undone.",
    "resetLayout": "Reset layout",
    "resetLayoutConfirm": "The layout will be reset to the module default. Customizations will be lost.",
    "fullscreenUnsupported": "Fullscreen mode is not supported in this browser.",
    "noOptions": "No options available",
    "selectLocation": "Select a location",
    "reset": "Reset",
    "optional": "Optional",
    "statuses": {
      "terminated": "Terminated",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "draft": "Draft",
      "expired": "Expired",
      "submitted": "Submitted",
      "acknowledged": "Acknowledged"
    },
    "audit": {
      "created": "created",
      "modified": "modified",
      "by": "by"
    },
    "deleted": "Deleted",
    "new": "New",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "create": "Create",
    "pickDate": "Pick a date",
    "pickDates": "Pick dates",
    "pickDateTime": "Pick date and time",
    "invalidDate": "Not a valid date",
    "addRow": "Add row",
    "moveRow": "Move row",
    "help": "Help",
    "selectPlaceholder": "Select…",
    "logoReplace": "Replace logo",
    "logoUploading": "Uploading...",
    "logoRemove": "Remove",
    "colorNone": "No colour",
    "colorClear": "Clear colour",
    "logoTooLarge": "Logo exceeds 5 MB",
    "logoUnsupportedType": "Unsupported image format. Use PNG.",
    "logoUploadedToast": "Logo uploaded",
    "logoRemovedToast": "Logo removed"
  },
  "oauthConsent": {
    "title": "{client} wants to access your account",
    "ownerLine": "Operated by {email}",
    "scopesHeading": "This will let it:",
    "allow": "Allow",
    "deny": "Deny",
    "loading": "Loading…",
    "error": "Could not load consent details.",
    "invalidRequest": "Invalid consent request.",
    "scope": {
      "openid": "Identify you across sessions",
      "email": "See your email address",
      "profile": "See your name and language",
      "moduleRead": "Read your data in this module",
      "moduleWrite": "Write data in this module",
      "tenantContext": "Read tenant info (name, currency, branding)",
      "tenantEvents": "Emit events into your workspace",
      "tenantWorkflows": "Trigger workflows in your workspace",
      "unknown": "Unknown permission"
    }
  },
  "oidcClients": {
    "list": "OIDC Clients",
    "listDescription": "Register and manage external OIDC clients that can authenticate users into this workspace.",
    "register": "Register client",
    "registerDescription": "Each client receives a unique ID and a secret. The secret is shown once at registration time.",
    "registering": "Registering…",
    "registered": "Client registered. Copy the secret now.",
    "displayName": "Display name",
    "ownerEmail": "Owner email",
    "redirectUris": "Redirect URIs",
    "redirectUrisHint": "One URL per line. HTTPS is required, except for localhost.",
    "scopesAllowed": "Allowed scopes",
    "scopesHint": "Choose the scopes this client may request. Defaults cover OpenID Connect plus module read/write.",
    "scopesPlaceholder": "Select scopes",
    "preferredClientId": "Preferred client ID (optional)",
    "preferredClientIdHint": "Lowercase letters, digits, and hyphens. Auto-generated when blank.",
    "clientId": "Client ID",
    "createdAt": "Registered",
    "statusColumn": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "rotate": "Rotate secret",
    "rotateConfirm": "Rotate this client secret? Existing services using the old secret will stop working until updated.",
    "deactivate": "Deactivate",
    "deactivateConfirm": "Deactivate this client? It will no longer issue tokens.",
    "deactivated": "Client deactivated.",
    "secretShownOnce": "Save this secret now — it will never be shown again. If you lose it, rotate to issue a new one.",
    "secretDialogTitle": "Client secret",
    "secretDialogClose": "I have saved this",
    "copied": "Copied to clipboard",
    "details": "Details",
    "actions": "Actions",
    "back": "Back",
    "empty": "No OIDC clients registered yet.",
    "loadError": "Could not load this client.",
    "errorMissingRedirect": "At least one redirect URI is required."
  },
  "apiKeys": {
    "title": "API keys",
    "subtitle": "Keys for the public REST API. A key may do exactly what you may.",
    "create": "Create key",
    "empty": "You haven't created any keys yet.",
    "name": "Name",
    "prefix": "Prefix",
    "lastUsed": "Last used",
    "expires": "Expires",
    "status": "Status",
    "actions": "Actions",
    "never": "Never",
    "active": "Active",
    "disabled": "Disabled",
    "revoked": "Revoked",
    "revoke": "Revoke",
    "revokedToast": "Key revoked",
    "showRevoked": "Show revoked keys",
    "revokeTitle": "Revoke API key?",
    "revokeBody": "Any program using this key stops working immediately. This cannot be undone.",
    "createTitle": "Create API key",
    "createDescription": "You see the key only once. Copy it before you close this window.",
    "namePlaceholder": "e.g. Attendance terminal hall 2",
    "days30": "30 days",
    "days90": "90 days",
    "year1": "1 year",
    "createdTitle": "Key created",
    "createdDescription": "Copy it now: you won't see it again. If you lose it, revoke it and create a new one.",
    "copied": "Copied to clipboard",
    "copiedIt": "I've copied it",
    "audit": {
      "title": "API keys per user",
      "subtitle": "See everyone's keys, revoke them, or switch API keys off for a user.",
      "user": "User",
      "email": "Email",
      "activeKeys": "Active keys",
      "disabled": "Disabled",
      "viewKeys": "View keys",
      "revokeAll": "Revoke all",
      "revokedCount": "Keys revoked: {count}",
      "revokeAllTitle": "Revoke all keys of {name}?",
      "revokeAllBody": "Every program using one of these keys stops working immediately. This cannot be undone.",
      "keysOf": "Keys of {name}"
    }
  },
  "modulesSettings": {
    "title": "Modules",
    "subtitle": "Customize your sidebar and manage external connections.",
    "toggle": {
      "externalEnabled": "Connection enabled",
      "externalDisabled": "Connection disabled"
    },
    "builtin": {
      "title": "Sidebar visibility",
      "empty": "No built-in modules available",
      "core": "Core",
      "hint": "These switches only affect your own sidebar. The modules and their data stay fully active for everyone else."
    },
    "external": {
      "title": "Connected services",
      "empty": "No connected services. Add one to integrate an external system.",
      "add": "Add connection"
    },
    "custom": {
      "title": "Custom modules",
      "empty": "No custom modules yet.",
      "manage": "Manage",
      "hint": "Custom modules are edited or removed from the builder."
    }
  },
  "entityRuntime": {
    "actions": {
      "new": "New {entity}",
      "edit": "Edit",
      "delete": "Delete",
      "view": "View",
      "openMenu": "Open menu"
    },
    "toolbar": {
      "searchPlaceholder": "Search {entityPlural}…",
      "clearSearch": "Clear search"
    },
    "empty": {
      "noResults": "No {entityPlural} match your search.",
      "noRecords": "No {entityPlural} yet",
      "noRecordsHint": "Create your first {entity} to get started.",
      "cta": "New {entity}"
    },
    "detail": {
      "audit": "Created {created} · updated {updated}",
      "auditBy": "Created {created} by {createdBy} · updated {updated} by {updatedBy}",
      "computed": "computed"
    },
    "form": {
      "required": "Required",
      "errorSummary": "Some fields need attention."
    },
    "moduleHome": {
      "entitiesHeading": "Entities",
      "rowCount": "{count, plural, =0 {empty} =1 {1 record} other {# records}}",
      "noEntities": "This module has no entities yet.",
      "noEntitiesHint": "Add entities from the module builder to start storing data."
    },
    "pagination": {
      "pageOf": "Page {page} of {totalPages}",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "customModules": {
    "title": "Custom modules",
    "subtitle": "Build no-code modules or connect external services. Both kinds appear here.",
    "back": "Back to modules",
    "col": {
      "name": "Name",
      "source": "Source",
      "version": "Version",
      "status": "Status"
    },
    "source": {
      "noCode": "No-code",
      "marketplace": "Marketplace",
      "external": "Connected service"
    },
    "status": {
      "active": "Active",
      "paused": "Paused",
      "disabled": "Disabled",
      "pending": "Pending",
      "connected": "Connected",
      "error": "Error"
    },
    "tabs": {
      "credentials": "Credentials",
      "manifest": "Manifest",
      "disconnect": "Disconnect"
    },
    "empty": {
      "title": "No modules yet",
      "subtitle": "Create a no-code module or connect a service to get started.",
      "cta": "Create module"
    },
    "connectedService": {
      "title": "Connect a service",
      "description": "Paste the service URL and we'll fetch its manifest. You'll see a preview before saving.",
      "field": {
        "displayName": "Display name",
        "displayNameHelp": "Shown in menus and on the credentials screen.",
        "serviceUrl": "Service base URL",
        "serviceUrlHelp": "We'll look for the manifest at /manifest under this URL unless you override below.",
        "manifestUrl": "Manifest URL (optional)",
        "manifestUrlHelp": "Override the default /manifest path."
      },
      "preview": "Preview manifest",
      "confirm": "Connect",
      "created": "Service connected"
    },
    "preview": {
      "entities": "Entities",
      "nav": "Navigation",
      "scopes": "Scopes",
      "events": "Events",
      "fields": "fields"
    },
    "credentials": {
      "warning": "If you lose these, you will have to rotate the affected credentials. Store them in your service's secret manager now.",
      "organizationId": "Organization ID",
      "organizationIdHelp": "Your tenant identifier. Always retrievable; used by the service to address tenant-scoped APIs.",
      "inboundGroup": "Inbound credentials",
      "inboundDescription": "Used by your service to verify requests proxied from cloud-erp users.",
      "hmacSecret": "HMAC shared secret",
      "hmacSecretHelp": "Verify the X-CloudERP-Signature header on every proxied request.",
      "oidcClientId": "OIDC client ID",
      "oidcClientIdHelp": "Public identifier for the OAuth dance when users sign in via cloud-erp.",
      "oidcClientSecret": "OIDC client secret",
      "oidcClientSecretHelp": "Used at the token endpoint. Treat as a password.",
      "outboundGroup": "Outbound credential",
      "outboundDescription": "Used by your service to call back into cloud-erp at /api/external-service/v1/*.",
      "serviceToken": "Service token",
      "serviceTokenHelp": "Bearer token for tenant-info, events emit, and workflow triggers.",
      "copy": "Copy",
      "copied": "Copied to clipboard",
      "toggleReveal": "Toggle visibility",
      "confirm": "I've saved these",
      "wrongType": "Credentials are only available for connected services.",
      "alreadyShown": "Credentials were already shown. Rotate them if you need a new copy.",
      "backToModule": "Back to module"
    },
    "manifest": {
      "lastFetched": "Last fetched",
      "refresh": "Refresh",
      "refreshed": {
        "connected": "Manifest refreshed",
        "error": "Refresh failed — see the error below"
      },
      "empty": "No cached manifest yet.",
      "notExternal": "Manifest preview is only available for connected services."
    },
    "disconnect": {
      "warning": "This is permanent. Tokens stop working immediately and existing data references break.",
      "consequence": {
        "tokens": "All issued tokens (HMAC, OIDC, service) are revoked.",
        "nav": "The service's navigation entries disappear from the sidebar.",
        "events": "Pending event deliveries are dropped.",
        "oidc": "The OIDC client is deactivated; users can no longer sign in to the service."
      },
      "typeName": "Type {name} to confirm",
      "confirm": "Disconnect",
      "dialogTitle": "Disconnect this service?",
      "dialogBody": "{name} will be removed. This cannot be undone.",
      "done": "Service disconnected",
      "notExternal": "Disconnect is only available for connected services."
    }
  },
  "externalRenderer": {
    "connectionUnavailable": "Connection unavailable",
    "connectionUnavailableHelp": "This connection isn't currently active. Reconnect the service to use it.",
    "unknownEntity": "Unknown entity",
    "deleteTitle": "Delete {name}?",
    "deleteWarning": "This permanently removes the record from the connected service.",
    "create": "Create",
    "created": "Record created",
    "updated": "Record updated",
    "deleted": "Record deleted"
  },
  "connectedServices": {
    "title": "Connected services",
    "subtitle": "External services that integrate with cloud-erp via OIDC and a manifest contract.",
    "add": "Add connection",
    "toggle": {
      "enabled": "Connection enabled",
      "disabled": "Connection disabled"
    },
    "empty": {
      "title": "No connected services yet",
      "subtitle": "Connect an external service to integrate it with cloud-erp.",
      "cta": "Add connection"
    }
  },
  "howToChoose": {
    "custom": {
      "headline": "Building a no-code module?",
      "body": "Custom modules are built from the admin UI. Data lives in cloud-erp, RBAC is inherited automatically. Best for adding structured data and workflows without code.",
      "linkLabel": "Or connect an external service"
    },
    "connected": {
      "headline": "Plugging in an existing service?",
      "body": "Connected services are external services you build in any language. They integrate with cloud-erp via OIDC + a manifest contract. Best when you have a service running elsewhere.",
      "linkLabel": "Or build a no-code module"
    }
  },
  "customModulesHelp": {
    "title": "Custom modules — getting started",
    "back": "Back to custom modules",
    "linkLabel": "Help",
    "loadError": "Could not load help content."
  },
  "builderRuntime": {
    "overview": {
      "fallbackTitle": "Module",
      "subtitle": "Module metadata, status, and destructive actions."
    },
    "entities": {
      "title": "Entities",
      "subtitle": "Tables your module stores data in.",
      "addAction": "New entity",
      "col": {
        "name": "Name",
        "key": "Key",
        "fields": "Fields"
      },
      "empty": {
        "title": "No entities yet",
        "subtitle": "Create your first entity to start storing structured data.",
        "cta": "New entity"
      },
      "new": {
        "title": "New entity",
        "subtitle": "Define a new record type for this module."
      },
      "edit": {
        "fallbackTitle": "Entity",
        "subtitle": "{count, plural, =0 {No fields} =1 {1 field} other {# fields}}"
      }
    },
    "workflows": {
      "title": "Workflows",
      "subtitle": "Run actions when records change.",
      "addAction": "New workflow",
      "col": {
        "name": "Name",
        "trigger": "Trigger",
        "steps": "Steps",
        "status": "Status"
      },
      "status": {
        "enabled": "Enabled",
        "autoPaused": "Auto-paused",
        "disabled": "Disabled"
      },
      "empty": {
        "title": "No workflows yet",
        "subtitle": "Trigger actions when records are created, updated, or deleted.",
        "cta": "New workflow"
      },
      "new": {
        "title": "New workflow",
        "subtitle": "Pick a trigger and define what should happen."
      },
      "edit": {
        "fallbackTitle": "Workflow"
      }
    },
    "webhooks": {
      "title": "Webhooks",
      "subtitle": "POST to an external URL when something happens.",
      "addAction": "New webhook",
      "col": {
        "name": "Name",
        "url": "URL",
        "event": "Event",
        "status": "Status"
      },
      "empty": {
        "title": "No webhooks yet",
        "subtitle": "Notify external systems when records change.",
        "cta": "New webhook"
      },
      "status": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "test": "Test",
      "rotate": "Rotate secret",
      "toast": {
        "deleted": "Webhook deleted",
        "testEnqueued": "Test delivery enqueued",
        "secretRotated": "Secret rotated"
      },
      "secret": {
        "title": "Copy this secret now",
        "body": "It won't be shown again. Use it to verify incoming webhook signatures.",
        "copy": "Copy",
        "copied": "Copied",
        "dismiss": "Dismiss"
      },
      "dialog": {
        "description": "The URL is validated against an SSRF block-list. A signing secret is generated and shown ONCE in the confirmation banner.",
        "namePlaceholder": "QA Slack alerts"
      }
    },
    "nav": {
      "title": "Navigation",
      "subtitle": "Decide where this module shows up in the sidebar.",
      "addAction": "Add item",
      "empty": {
        "title": "No nav items yet",
        "subtitle": "Add sidebar entries so users can find this module.",
        "cta": "Add item"
      }
    },
    "permissions": {
      "title": "Permissions",
      "subtitle": "Who can read or write records in this module.",
      "body": "Permissions for this module are managed in the global roles editor. Each role can be granted read, write, or admin access per entity.",
      "openRoles": "Open roles editor"
    },
    "audit": {
      "title": "Audit log",
      "subtitle": "Every change to this module's records.",
      "col": {
        "at": "When",
        "actor": "By",
        "action": "Action",
        "details": "Details"
      },
      "empty": {
        "title": "No audit entries yet",
        "subtitle": "Changes to records in this module will appear here."
      },
      "allowed": "Allowed",
      "denied": "Denied"
    },
    "manifest": {
      "title": "Manifest",
      "subtitle": "The full machine-readable definition of this module."
    },
    "credentials": {
      "title": "Credentials",
      "subtitle": "Tokens issued when the connection was registered."
    },
    "disconnect": {
      "title": "Disconnect",
      "subtitle": "Remove this module from the workspace."
    }
  },
  "users": {
    "title": "Users",
    "subtitle": "Manage who can sign into this workspace.",
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "workspaceManager": "Workspace manager",
    "disabled": "Disabled",
    "inviteCreated": "Invite created. Send them this link:",
    "copyLink": "Copy link",
    "copied": "Copied",
    "done": "Done",
    "sendInvite": "Send invite",
    "pendingInvites": "Pending invites ({count})",
    "resend": "Resend",
    "revoke": "Revoke",
    "revokeTitle": "Revoke invite?",
    "revokeDescription": "The invite link for {email} will stop working immediately.",
    "disable": "Disable",
    "enable": "Enable",
    "disableTitle": "Disable {email}?",
    "disableDescription": "They will lose access to this workspace until you re-enable them. Existing data is preserved.",
    "noUsers": "No users found.",
    "resetPassword": "Reset password",
    "inviteResent": "Invite resent",
    "inviteRevoked": "Invite revoked",
    "userDisabled": "User disabled",
    "userEnabled": "User enabled",
    "copyFailed": "Copy failed",
    "inviteMeta": "Role: {role} · Expires {date} · Invited by {email}",
    "addUserTitle": "Add a user to the workspace",
    "tabDirect": "Create directly",
    "inviteHint": "Email the user a link to set their own password.",
    "directHint": "Set credentials yourself and hand them over offline. Use this when the user has no addressable mailbox.",
    "roleSelect": "Select a role",
    "directEmailPlaceholder": "e.g. firstname.lastname@workspace.local",
    "optionalParen": "(optional)",
    "tempPassword": "Temporary password",
    "tempPasswordPlaceholder": "(auto-generate if blank)",
    "working": "Working…",
    "createUser": "Create user",
    "userCreated": "User created. Share these credentials with them — the password is shown only once.",
    "copyPassword": "Copy password",
    "resetTitle": "Reset password for {email}",
    "tabSendResetLink": "Send reset link",
    "tabSetPassword": "Set password",
    "resetEmailHint": "Email the user a link to set a new password themselves.",
    "resetDirectHint": "Set a new password directly and hand it over offline. The user is signed out of all existing sessions.",
    "newPassword": "New password",
    "newPasswordPlaceholder": "(auto-generate if blank, min 8 characters)",
    "passwordReset": "Password reset. Share these credentials with the user — the password is shown only once. All of their existing sessions have been signed out.",
    "resetLinkSent": "Password reset link sent to {email}",
    "editor": {
      "section": "User",
      "emailManagerHint": "A workspace manager's email address is changed at platform level.",
      "languageAuto": "Automatic (employee or workspace)",
      "openEmployee": "Open employee",
      "isAdmin": "Administrator",
      "isAdminHint": "All permissions in this workspace; requires two-factor authentication.",
      "roles": "Roles",
      "sessionHint": "Changing Administrator or the email address signs the user out; it can take up to 15 minutes to take effect.",
      "adminProtected": "This user is an administrator. Only an administrator can change this account.",
      "rolesHelp": {
        "title": "About roles",
        "intro": "Roles decide what this person can see and do. Pick as many as you need: they get the combined permissions of all of them.",
        "teams": "People also get the roles of every team they belong to. Those are managed under Teams and don't appear in this list.",
        "deny": "If one role denies a permission, it stays denied even when another role allows it.",
        "admin": "Administrators skip role checks: they can do everything, whatever roles they have."
      }
    }
  },
  "hr": {
    "department": {
      "entityPlural": "Departments",
      "emptyList": "No departments found",
      "manager": "Manager",
      "namePlaceholder": "e.g. Engineering",
      "noManager": "No manager",
      "descriptionPlaceholder": "Department description…",
      "newTitle": "New department",
      "create": "Create department",
      "nameRequired": "Department name is required",
      "created": "Department created",
      "updated": "Department updated",
      "deleted": "Department deleted",
      "deleteTitle": "Delete department",
      "deleteConfirm": "Are you sure you want to delete this department? Employees and job openings keep existing (their department link is cleared). This action cannot be undone."
    },
    "home": {
      "intro": "Manage your organization's workforce",
      "cards": {
        "employees": "Manage employee directory and profiles",
        "departments": "Manage organizational departments",
        "onboarding": "Track employee onboarding progress",
        "leave": "Manage absences and leave balances",
        "shifts": "Manage shift types and employee assignments",
        "performance": "Manage performance reviews",
        "contracts": "Manage employee contracts and templates",
        "documents": "Manage employee documents and expiry tracking",
        "lifecycle": "Track promotions, transfers, and separations",
        "payroll": "Manage salary structures, components, and payroll runs",
        "expenses": "Manage employee expense reimbursements",
        "recruitment": "Manage job openings, applicants, and interviews",
        "training": "Manage training events and employee enrollments",
        "timeRegistration": "See who clocked in and out, day by day",
        "leaveBalances": "See each employee's leave balance per year"
      }
    },
    "employee": {
      "firstName": "First name",
      "preferredName": "Preferred name",
      "middleName": "Middle name",
      "lastName": "Last name",
      "initials": "Initials",
      "companyEmail": "Company email",
      "companyPhone": "Company phone",
      "employeeNumber": "Employee number",
      "badgeNumber": "Badge number",
      "department": "Department",
      "departmentPlaceholder": "Select department",
      "manager": "Manager",
      "managerPlaceholder": "Select manager",
      "jobTitle": "Job title",
      "employmentType": "Employment type",
      "employmentTypePlaceholder": "Select type",
      "employmentTypeFullTime": "Full-time",
      "employmentTypePartTime": "Part-time",
      "employmentTypeContract": "Contract",
      "employeeType": "Employment relationship",
      "employeeTypePlaceholder": "Select type…",
      "employeeTypeGroup": {
        "own": "Own staff",
        "education": "Internship / education",
        "external": "External / hired",
        "other": "Other",
        "ownership": "Ownership"
      },
      "employeeTypeOption": {
        "employee": "Employee",
        "on_call": "On-call worker",
        "intern_bol": "Intern (BOL)",
        "intern_bbl": "Intern (BBL)",
        "temp_agency": "Temp-agency worker",
        "freelance": "Freelance / contractor",
        "seconded": "Seconded",
        "volunteer": "Volunteer",
        "shareholder": "Shareholder",
        "owner": "Owner",
        "dga": "Director-major shareholder (DGA)"
      },
      "hoursPerWeek": "Hours per week",
      "commuteDistanceKm": "Commuting distance (km)",
      "startDate": "Start date",
      "endDate": "End date",
      "personalEmail": "Personal email",
      "phone": "Phone number",
      "mobile": "Mobile number",
      "dateOfBirth": "Date of birth",
      "age": "{years} years old",
      "yearsOfService": "{years} years of service",
      "showBirthday": "Show birthday in the calendar",
      "gender": "Gender",
      "genderPlaceholder": "Select…",
      "list": {
        "title": "Employees",
        "empty": "No employees found",
        "colStatus": "Status",
        "statusActive": "Active",
        "statusInactive": "Inactive",
        "statusTerminated": "Terminated",
        "printBadges": "Print badges",
        "printBadgesDone": "{printed, plural, one {# badge} other {# badges}} created, {skipped} skipped.",
        "printBadgesNone": "Nobody in this list has a fitting badge number.",
        "badgesFileName": "badges"
      },
      "genderOption": {
        "male": "Male",
        "female": "Female",
        "other": "Other",
        "unknown": "Unknown"
      },
      "nationalId": "National ID",
      "iban": "Bank account (IBAN)",
      "emergencyContact": "Emergency contact",
      "salary": "Salary",
      "tabProfile": "Profile",
      "tabPrivate": "Private",
      "tabEmployment": "Employment",
      "tabBadge": "Badge",
      "badge": {
        "label": "TAG CARD",
        "symbology": "Code type: {symbology}",
        "symbologyHint": "You change this in the time registration settings.",
        "print": "Print",
        "noBadge": "Enter a badge number first.",
        "invalid": "This badge number does not fit the code type {symbology}.",
        "saveFirst": "Save first: the badge carries the saved badge number.",
        "printFailed": "The badge could not be created.",
        "fileName": "badge-{badge}"
      },
      "tabOnboarding": "Onboarding",
      "tabPerformance": "Performance",
      "tabLeave": "Leave",
      "onboardingProgress": "Onboarding progress",
      "performanceReviews": "Performance reviews",
      "tabNotes": "Notes",
      "notes": "Note",
      "notesHours": "Hours note",
      "newTitle": "New employee",
      "create": "Create employee",
      "created": "Employee created",
      "updated": "Employee updated",
      "firstNameRequired": "First name is required",
      "linkedUserTitle": "Linked account",
      "linkedUserId": "User ID: {id}",
      "linkedUserNone": "This employee is not linked to a user account yet. Once linked, the employee sees their own details in My HR.",
      "linkedUserLink": "Link account",
      "linkedUserLinked": "Account linked",
      "linkedUserUnlink": "Unlink",
      "linkedUserUnlinking": "Unlinking…",
      "linkedUserUnlinked": "Account unlinked",
      "linkedUserDialogTitle": "Link account to employee",
      "linkedUserDialogDescription": "Search for the user account that belongs to this employee. An account already linked to another employee is listed but cannot be chosen.",
      "linkedUserSearch": "Search by name or email",
      "linkedUserNoMatch": "No accounts match your search.",
      "linkedUserNoUsers": "No accounts found.",
      "linkedUserElsewhere": "Linked to another employee",
      "linkedUserCurrent": "Current",
      "linkedUserPick": "Link",
      "photo": {
        "upload": "Upload photo",
        "uploading": "Uploading…",
        "uploaded": "Photo saved",
        "remove": "Remove",
        "invalidType": "Please choose a PNG, JPEG or WebP image",
        "tooLarge": "Image is too large (max 5 MB)",
        "removed": "Photo removed"
      }
    },
    "common": {
      "status": "Status",
      "type": "Type",
      "startDate": "Start date",
      "endDate": "End date",
      "days": "Days",
      "employeeFallback": "Employee #{id}",
      "allDepartments": "All departments",
      "allEmployees": "All employees",
      "allStatuses": "All statuses",
      "allTypes": "All types",
      "employee": "Employee",
      "selectEmployee": "Select employee",
      "actions": "Actions"
    },
    "onboarding": {
      "pending": "Pending",
      "inProgress": "In progress",
      "completed": "Completed",
      "start": "Start",
      "complete": "Complete",
      "done": "Done",
      "empty": "No onboarding tasks",
      "taskUpdated": "Task updated",
      "dashboardTitle": "Onboarding dashboard",
      "dashboardSubtitle": "Track employee onboarding progress",
      "employeesOnboarding": "Employees onboarding",
      "activeOnboardings": "Active onboardings",
      "averageCompletion": "Average completion",
      "percentOfTotal": "{percent}% of total",
      "noEmployees": "No employees currently onboarding",
      "progress": "Progress",
      "tasksCount": "{done}/{total} tasks"
    },
    "performance": {
      "period": "Period",
      "cycle": "Cycle",
      "rating": "Rating",
      "empty": "No performance reviews yet",
      "allCycles": "All cycles",
      "areasOfImprovement": "Areas of improvement",
      "areasOfImprovementPlaceholder": "List areas for improvement…",
      "comments": "Comments",
      "commentsPlaceholder": "Additional comments…",
      "cycleOption": {
        "annual": "Annual",
        "biAnnual": "Bi-annual",
        "quarterly": "Quarterly"
      },
      "entityPlural": "Performance reviews",
      "periodEnd": "Period end",
      "periodStart": "Period start",
      "reviewer": "Reviewer",
      "statusOption": {
        "acknowledged": "Acknowledged",
        "draft": "Draft",
        "submitted": "Submitted"
      },
      "strengths": "Strengths",
      "strengthsPlaceholder": "List employee strengths…",
      "entitySingular": "Performance review",
      "newTitle": "New performance review",
      "newSubtitle": "Create a performance review for an employee",
      "create": "Create performance review",
      "created": "Performance review created",
      "updated": "Performance review updated",
      "deleted": "Performance review deleted",
      "deleteTitle": "Delete performance review",
      "deleteConfirm": "Are you sure you want to delete this performance review? This action cannot be undone."
    },
    "leave": {
      "requests": "Absences",
      "used": "Used",
      "daysUnit": "days",
      "empty": "No absences",
      "entityPlural": "Absences",
      "leaveType": "Type",
      "startDate": "Start date",
      "endDate": "End date",
      "daysCol": "Days",
      "reason": "Reason",
      "rejectionReason": "Rejection reason",
      "newTitle": "New absence",
      "newSubtitle": "Record an absence for an employee",
      "create": "Create absence",
      "created": "Absence created",
      "updated": "Absence updated",
      "deleted": "Absence deleted",
      "detailTitle": "Absence",
      "deleteTitle": "Delete absence",
      "deleteConfirm": "Are you sure you want to delete this absence? This action cannot be undone.",
      "emptyList": "No absences found",
      "employeeRequired": "Employee is required",
      "datesRequired": "Start and end dates are required",
      "allEmployees": "All employees",
      "allStatuses": "All statuses",
      "allTypes": "All types",
      "typeAnnual": "Annual",
      "typeSick": "Sick",
      "typeMaternity": "Maternity",
      "typePaternity": "Paternity",
      "typeUnpaid": "Unpaid",
      "typeBereavement": "Bereavement",
      "statusPending": "Pending",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "statusCancelled": "Cancelled",
      "unknownEmployee": "Unknown employee",
      "balancesTitle": "Leave balances",
      "initializing": "Initializing…",
      "startTime": "Start time",
      "endTime": "End time",
      "timeHint": "Empty = whole day",
      "agendaText": "Calendar line",
      "agendaTextHint": "Shown in the calendar and visible to everyone",
      "agendaTextTooLong": "The calendar line can be at most {max} characters",
      "hoursKind": "Hours type",
      "hoursKindNormal": "Normal",
      "hoursKindSpecial": "Special",
      "hoursKindNone": "None",
      "normalHours": "Normal hours",
      "specialHours": "Special hours",
      "hoursHint": "Computed from the roster by absence type; change to fix the hours by hand",
      "specialHoursHint": "If part counts as special leave, enter that part here and the rest under Normal hours",
      "recalculate": "Recalculate",
      "recalculated": "Hours recalculated",
      "recalculateHint": "Recompute the hours from the roster",
      "recalculateDirty": "Save or cancel your changes first",
      "start": "Start",
      "end": "End",
      "allYears": "All years",
      "period": "Period"
    },
    "contract": {
      "entityPlural": "Contracts",
      "emptyList": "No contracts found",
      "title": "Title",
      "statusDraft": "Draft",
      "statusExpired": "Expired",
      "statusTerminated": "Terminated",
      "template": {
        "entityPlural": "Contract templates",
        "listButton": "Templates",
        "emptyList": "No templates found",
        "newTitle": "New template",
        "entitySingular": "Template",
        "selectPlaceholder": "Select template (optional)",
        "body": "Body",
        "typeEmployment": "Employment",
        "typeNda": "NDA",
        "typeAmendment": "Amendment",
        "typeTermination": "Termination",
        "newSubtitle": "Create a reusable contract template",
        "create": "Create template",
        "created": "Template created",
        "updated": "Template updated",
        "deleted": "Template deleted",
        "notFound": "Template not found",
        "deleteTitle": "Delete template",
        "deleteConfirm": "This template will be permanently deleted. Contracts created from it keep their content."
      },
      "employeePlaceholder": "Select employee",
      "signedAt": "Signed",
      "notes": "Notes",
      "newTitle": "New contract",
      "newSubtitle": "Create a new employee contract",
      "create": "Create contract",
      "created": "Contract created",
      "updated": "Contract updated",
      "notFound": "Contract not found",
      "detailsSection": "Contract details",
      "activate": "Activate",
      "activating": "Activating…",
      "activated": "Contract activated",
      "terminate": "Terminate",
      "terminateTitle": "Terminate contract",
      "terminateConfirm": "Are you sure you want to terminate this contract? You can add a reason.",
      "terminateReason": "Reason (optional)",
      "terminateReasonPlaceholder": "Reason for termination…",
      "terminating": "Terminating…",
      "terminationReasonNote": "Reason for termination: {reason}",
      "terminated": "Contract terminated",
      "downloadPdf": "Download PDF",
      "fileSection": "Contract file",
      "fileSectionDescription": "Attach the signed contract (PDF). Save to apply.",
      "fileAttached": "A file is attached.",
      "noFileAttached": "No file attached.",
      "removeFile": "Remove",
      "filePickerHelper": "Max 50 MB. Uploaded on select; save to attach.",
      "fileTooLarge": "File is larger than 50 MB",
      "fileUploaded": "File uploaded — save to attach it",
      "uploadFailedStatus": "Upload failed ({status})",
      "contentSection": "Contract content",
      "contentFromTemplate": "Generated from the template"
    },
    "document": {
      "entityPlural": "Documents",
      "emptyList": "No documents found",
      "issuedDate": "Issued date",
      "expiryDate": "Expiry date",
      "allEmployees": "All employees",
      "allTypes": "All types",
      "typeIdCard": "ID card",
      "typePassport": "Passport",
      "typeVisa": "Visa",
      "typeWorkPermit": "Work permit",
      "typeCertificate": "Certificate",
      "typeMedical": "Medical",
      "typeOther": "Other",
      "newTitle": "Upload document",
      "upload": "Upload document",
      "uploading": "Uploading…",
      "uploaded": "Document uploaded",
      "uploadFailedStatus": "Upload failed ({status})",
      "file": "File",
      "fileHelp": "Max 50 MB. Stored privately in S3.",
      "fileTooLarge": "File is larger than 50 MB",
      "fileRequired": "Please choose a file to upload",
      "documentType": "Document type",
      "name": "Document name",
      "namePlaceholder": "Passport - John Doe",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes…",
      "updated": "Document updated",
      "deleted": "Document deleted",
      "deleteTitle": "Delete document",
      "deleteConfirm": "This document will be permanently deleted, including the stored file. This action cannot be undone.",
      "downloadFailed": "Could not get a download link"
    },
    "lifecycle": {
      "entityPlural": "Lifecycle events",
      "emptyList": "No lifecycle events found",
      "effectiveDate": "Effective date",
      "reason": "Reason",
      "changes": "Changes",
      "allEmployees": "All employees",
      "allTypes": "All types",
      "allStatuses": "All statuses",
      "typePromotion": "Promotion",
      "typeTransfer": "Transfer",
      "typeConfirmation": "Confirmation",
      "typeSeparation": "Separation",
      "typeSalaryRevision": "Salary revision",
      "statusPending": "Pending",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "statusCompleted": "Completed",
      "changeJobTitle": "Title",
      "changeSalary": "Salary",
      "changeConfirmation": "Confirmation",
      "changeLastDay": "Last day",
      "changeRelieving": "Relieving",
      "newTitle": "New lifecycle event",
      "newSubtitle": "Record an employee lifecycle change",
      "create": "Create event",
      "created": "Lifecycle event created",
      "employeeRequired": "Employee is required",
      "typeRequired": "Type is required",
      "effectiveDateRequired": "Effective date is required",
      "reasonPlaceholder": "Reason for the event…",
      "letterFileUrl": "Letter file URL",
      "changesSection": "Changes (applied to the employee on completion)",
      "jobTitlePlaceholder": "Senior Engineer",
      "finalWorkingDay": "Final working day",
      "relievingDate": "Relieving date",
      "confirmationDate": "Confirmation date",
      "entity": "Lifecycle event",
      "updated": "Lifecycle event updated",
      "deleted": "Lifecycle event deleted",
      "deleteTitle": "Delete lifecycle event",
      "complete": "Complete",
      "completeTitle": "Complete event",
      "completeConfirm": "The changes are applied to the employee. After that, the status and the changes of this event are fixed.",
      "completeConfirmSeparation": "The changes are applied to the employee, and the employee is set to Terminated. The end date becomes the relieving date, or the effective date if there is no relieving date. Active contracts expire and absences follow that end date.",
      "completeDone": "Completed: the changes are on the employee",
      "completeSaveFirst": "Save your changes first; completing applies what is saved.",
      "deleteConfirm": "This lifecycle event will be permanently deleted. This action cannot be undone."
    },
    "expenseClaim": {
      "entityPlural": "Expense claims",
      "emptyList": "No expense claims found",
      "title": "Title",
      "amount": "Amount",
      "currency": "Currency",
      "submitted": "Submitted",
      "statusDraft": "Draft",
      "statusSubmitted": "Submitted",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "statusPaid": "Paid",
      "titlePlaceholder": "Business travel expenses",
      "descriptionPlaceholder": "Optional description…",
      "items": "Expense items",
      "itemDescriptionPlaceholder": "Flight ticket to NYC",
      "category": "Category",
      "date": "Date",
      "total": "Total: {amount}",
      "categoryTravel": "Travel",
      "categoryMeals": "Meals",
      "categoryAccommodation": "Accommodation",
      "categorySupplies": "Supplies",
      "categoryOther": "Other",
      "newTitle": "New expense claim",
      "newSubtitle": "Submit an expense reimbursement request",
      "create": "Create expense claim",
      "created": "Expense claim created",
      "updated": "Expense claim updated",
      "deleted": "Expense claim deleted",
      "deleteTitle": "Delete expense claim",
      "deleteConfirm": "Are you sure you want to delete this expense claim? This action cannot be undone.",
      "titleRequired": "Title is required",
      "itemsRequired": "At least one expense item is required",
      "notEditable": "This expense claim is {status} and can no longer be edited.",
      "submit": "Submit",
      "submitting": "Submitting…",
      "submittedToast": "Expense claim submitted for approval",
      "approve": "Approve",
      "approving": "Approving…",
      "approvedToast": "Expense claim approved",
      "reject": "Reject",
      "rejecting": "Rejecting…",
      "rejectedToast": "Expense claim rejected",
      "rejectTitle": "Reject expense claim",
      "rejectDescription": "Provide a reason for rejecting this expense claim",
      "rejectAction": "Reject claim",
      "reason": "Reason",
      "reasonPlaceholder": "Reason for rejection…",
      "reasonRequired": "Rejection reason is required",
      "rejectionReason": "Rejection reason:",
      "markPaid": "Mark paid",
      "markingPaid": "Marking…",
      "paidToast": "Expense claim marked as paid"
    },
    "shiftAssignment": {
      "entityPlural": "Shift assignments",
      "emptyList": "No shift assignments found",
      "employeePlaceholder": "Select employee",
      "shiftType": "Shift type",
      "shiftTypePlaceholder": "Select shift type",
      "ongoing": "Ongoing",
      "entitySingular": "Shift assignment",
      "newTitle": "New shift assignment",
      "newSubtitle": "Assign a shift type to an employee",
      "create": "Create assignment",
      "created": "Shift assigned",
      "updated": "Assignment updated",
      "deleted": "Assignment deleted",
      "deleteTitle": "Delete shift assignment",
      "deleteConfirm": "Are you sure you want to delete this shift assignment? This removes the row entirely. To keep it as history instead, set an end date. This action cannot be undone.",
      "allPeriods": "All periods",
      "ongoingOnly": "Ongoing only",
      "weekdays": "Weekdays",
      "weekdaysHint": "The days this shift applies to. Nothing ticked = every day.",
      "allDays": "Every day"
    },
    "me": {
      "subtitle": "View your own HR data.",
      "noProfile": "No employee record found.",
      "noEmployeeTitle": "No employee linked to your account",
      "noEmployeeBody": "Your account isn't linked to an employee record yet, so there is nothing to show here. Ask an administrator to set up your employee account.",
      "noPayslips": "No payslips yet.",
      "cards": {
        "profile": "Your details",
        "leave": "Your absences + leave balance",
        "payslips": "Your pay history",
        "expenses": "Your submitted claims",
        "performance": "Your reviews",
        "hoursAndLeave": "Your registrations, leave and balance"
      }
    },
    "payroll": {
      "periodStart": "Period start",
      "periodEnd": "Period end",
      "gross": "Gross",
      "net": "Net",
      "payslips": "Payslips",
      "adding": "Adding…",
      "allTypes": "All types",
      "amount": "Amount",
      "base": "Base",
      "baseAmount": "Base amount",
      "calcType": "Calc type",
      "calculation": "Calculation",
      "calculationType": "Calculation type",
      "code": "Code",
      "components": "Components",
      "componentFallback": "Component #{id}",
      "deduction": "Deduction",
      "deductions": "Deductions",
      "descriptionPlaceholder": "Optional description…",
      "earning": "Earning",
      "earnings": "Earnings",
      "employeesWithSalary": "Employees with salary",
      "fixed": "Fixed",
      "latestRunNet": "Latest run net payroll",
      "latestRunStatus": "Latest run status",
      "no": "No",
      "notes": "Notes",
      "notesPlaceholder": "Optional notes…",
      "percentOfBase": "% of base",
      "percentOfGross": "% of gross",
      "period": "Period",
      "selectComponent": "Select component",
      "selectType": "Select type",
      "sortOrder": "Sort order",
      "totalDeductions": "Total deductions",
      "totalGross": "Total gross",
      "totalNet": "Total net",
      "variable": "Variable",
      "viewDetails": "View details",
      "yes": "Yes",
      "card": {
        "components": "Components",
        "componentsDesc": "Earnings & deduction components",
        "structures": "Structures",
        "structuresDesc": "Salary structure templates",
        "runs": "Payroll runs",
        "runsDesc": "Run & review payroll periods"
      },
      "component": {
        "entity": "Component",
        "entityPlural": "Salary components",
        "intro": "Manage earnings and deduction components",
        "emptyList": "No salary components found",
        "newTitle": "New salary component",
        "newSubtitle": "Create a new earning or deduction component",
        "editTitle": "Edit component",
        "editSubtitle": "Update salary component details",
        "create": "Create component",
        "update": "Update component",
        "created": "Component created",
        "updated": "Component updated",
        "deleted": "Component deleted",
        "deleteTitle": "Delete component",
        "deleteConfirm": "Are you sure you want to delete this component? This action cannot be undone.",
        "namePlaceholder": "Basic Salary",
        "codePlaceholder": "BASIC",
        "taxable": "Taxable",
        "fixedAmount": "Fixed amount"
      },
      "run": {
        "entityPlural": "Payroll runs",
        "intro": "History of all payroll processing runs",
        "emptyList": "No payroll runs found. Create your first run above.",
        "newTitle": "New payroll run",
        "newSubtitle": "Define the payroll period to process",
        "create": "Create run",
        "created": "Payroll run created",
        "periodStart": "Period start",
        "periodEnd": "Period end",
        "runDate": "Run date",
        "noneYet": "No runs yet",
        "latest": "Latest payroll run",
        "notFound": "Payroll run not found",
        "detailTitle": "Payroll run: {start} — {end}",
        "processedOn": "Processed {date}",
        "process": "Process",
        "processing": "Processing…",
        "processed": "Payroll run processed successfully",
        "cancelling": "Cancelling…",
        "cancelled": "Payroll run cancelled",
        "payslips": "Payslips",
        "payslipsIntro": "Individual payslips for this payroll run",
        "payslipsDraftHint": "Process the run to generate payslips",
        "payslipsEmpty": "No payslips found",
        "statusOption": {
          "draft": "Draft",
          "processing": "Processing",
          "completed": "Completed",
          "cancelled": "Cancelled"
        },
        "cancelRun": "Cancel run",
        "cancelDialog": {
          "title": "Cancel this payroll run?",
          "body": "All payslips in this run are deleted. This cannot be undone."
        }
      },
      "structure": {
        "entityPlural": "Salary structures",
        "intro": "Define salary structure templates for employees",
        "emptyList": "No salary structures found",
        "newTitle": "New salary structure",
        "newSubtitle": "Create a salary structure with components",
        "create": "Create structure",
        "created": "Structure created",
        "updated": "Structure updated",
        "deleted": "Structure deleted",
        "deleteTitle": "Delete structure",
        "deleteConfirm": "Are you sure you want to delete this salary structure? This action cannot be undone.",
        "notFound": "Structure not found",
        "namePlaceholder": "Standard Monthly",
        "items": "Items",
        "itemsIntro": "Earnings and deductions in this structure",
        "addItem": "Add item",
        "itemAdded": "Item added",
        "itemRemoved": "Item removed",
        "noItems": "No components added yet",
        "noItemsHint": "No components yet. Add items above.",
        "addComponent": "Add component",
        "addComponentSubtitle": "Add a salary component to this structure"
      },
      "assignment": {
        "entityPlural": "Employee assignments",
        "intro": "Employees assigned to this salary structure",
        "empty": "No employees assigned yet",
        "assign": "Assign employee",
        "subtitle": "Assign an employee to this salary structure",
        "assigning": "Assigning…",
        "created": "Employee assigned",
        "ended": "Assignment ended",
        "end": "End",
        "ongoing": "Ongoing",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to"
      }
    },
    "recruitment": {
      "applicant": {
        "coverLetter": "Cover letter",
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "notes": "Notes",
        "phone": "Phone",
        "rating": "Rating (1–5)",
        "referredBy": "Referred by",
        "resumeUrl": "Resume URL",
        "source": "Source",
        "sourceOption": {
          "agency": "Agency",
          "linkedin": "LinkedIn",
          "other": "Other",
          "referral": "Referral",
          "website": "Website"
        },
        "sourcePlaceholder": "Select source",
        "add": "Add applicant",
        "addDescription": "Add a new applicant to this job opening",
        "added": "Applicant added",
        "updated": "Applicant updated",
        "deleted": "Applicant deleted",
        "deleteTitle": "Delete applicant",
        "deleteConfirm": "Are you sure you want to delete this applicant? Their interviews and offer letters are removed too. This action cannot be undone.",
        "notFound": "Applicant not found",
        "applyingFor": "Applying for: {title}",
        "resume": "Resume",
        "hire": "Hire",
        "hiring": "Hiring…",
        "hired": "Applicant hired — employee {id} created.",
        "viewEmployee": "View employee",
        "firstNameRequired": "First name is required",
        "lastNameRequired": "Last name is required",
        "emailRequired": "A valid email address is required",
        "coverLetterPlaceholder": "The applicant's cover letter…",
        "statusOption": {
          "applied": "Applied",
          "screening": "Screening",
          "interview": "Interview",
          "offer": "Offer",
          "hired": "Hired",
          "rejected": "Rejected",
          "withdrawn": "Withdrawn"
        },
        "interviews": "Interviews",
        "noInterviews": "No interviews scheduled yet",
        "scheduleInterview": "Schedule interview",
        "scheduleInterviewDescription": "Set up an interview for this applicant",
        "schedule": "Schedule",
        "scheduling": "Scheduling…",
        "interviewScheduled": "Interview scheduled",
        "interviewUpdated": "Interview updated",
        "completeInterview": "Complete",
        "interviewer": "Interviewer",
        "interviewerPlaceholder": "Select interviewer",
        "interviewerRequired": "An interviewer is required",
        "interviewDate": "Date",
        "interviewDateTime": "Date & time",
        "interviewDateRequired": "A date and time is required",
        "duration": "Duration (min)",
        "durationValue": "{minutes} min",
        "interviewTypeOption": {
          "phone": "Phone",
          "video": "Video",
          "onsite": "On site",
          "technical": "Technical",
          "cultural": "Cultural"
        },
        "offerLetter": "Offer letter",
        "noOffer": "No offer letter yet",
        "createOffer": "Create offer",
        "createOfferTitle": "Create offer letter",
        "createOfferDescription": "Create an offer for this applicant",
        "offerCreated": "Offer letter created",
        "offerStatusUpdated": "Offer status updated",
        "sendOffer": "Send offer",
        "markAccepted": "Mark accepted",
        "markRejected": "Mark rejected",
        "salary": "Salary",
        "salaryRequired": "A salary is required",
        "startDateRequired": "A start date is required",
        "validUntil": "Valid until",
        "templateContent": "Template content",
        "templateContentPlaceholder": "Optional offer letter content…"
      },
      "opening": {
        "cardDescription": "Manage job openings, post positions, and track applicant pipelines",
        "closesAt": "Closes at",
        "employmentTypeOption": {
          "contract": "Contract",
          "full_time": "Full-time",
          "internship": "Internship",
          "part_time": "Part-time"
        },
        "emptyList": "No job openings found",
        "entityPlural": "Job openings",
        "positions": "Positions",
        "requirements": "Requirements",
        "salaryMax": "Salary max",
        "salaryMin": "Salary min",
        "statusOption": {
          "closed": "Closed",
          "draft": "Draft",
          "filled": "Filled",
          "on_hold": "On hold",
          "open": "Open"
        },
        "subtitle": "Manage open positions and track applicants",
        "title": "Title",
        "newTitle": "New job opening",
        "newSubtitle": "Create a new position to recruit for",
        "create": "Create opening",
        "created": "Job opening created",
        "updated": "Job opening updated",
        "deleted": "Job opening deleted",
        "deleteTitle": "Delete job opening",
        "deleteConfirm": "Are you sure you want to delete this job opening? Only draft openings without applicants can be deleted. This action cannot be undone.",
        "notFound": "Job opening not found",
        "pipeline": "Applicant pipeline"
      },
      "stats": {
        "interviewsThisWeek": "Interviews this week",
        "interviewsThisWeekDesc": "Scheduled interviews",
        "openPositions": "Open positions",
        "openPositionsDesc": "Active job openings",
        "pendingOffers": "Pending offers",
        "pendingOffersDesc": "Awaiting response",
        "pipeline": "Pipeline",
        "pipelineDesc": "Applicants in progress"
      }
    },
    "training": {
      "descriptionPlaceholder": "Training event description…",
      "emptyList": "No training events found",
      "endTime": "End time",
      "location": "Location",
      "locationPlaceholder": "Conference room A",
      "maxParticipants": "Max participants",
      "namePlaceholder": "Safety training 2026",
      "startTime": "Start time",
      "statusOption": {
        "cancelled": "Cancelled",
        "completed": "Completed",
        "in_progress": "In progress",
        "planned": "Planned"
      },
      "trainer": "Trainer",
      "trainerEmployee": "Trainer (employee)",
      "trainerPlaceholder": "John Smith",
      "typeOption": {
        "external": "External",
        "internal": "Internal",
        "online": "Online",
        "workshop": "Workshop"
      },
      "newTitle": "New training event",
      "newSubtitle": "Schedule a new training event",
      "create": "Create training event",
      "created": "Training event created",
      "updated": "Training event updated",
      "enrollments": "Enrollments",
      "enrollEmployee": "Enroll employee",
      "enrollDescription": "Select an employee to enroll in this training",
      "enrollAction": "Enroll",
      "enrolling": "Enrolling…",
      "noEnrollments": "No enrollments yet",
      "allEmployeesEnrolled": "All employees enrolled",
      "employeeEnrolled": "Employee enrolled",
      "enrollmentUpdated": "Enrollment updated",
      "enrollmentRemoved": "Enrollment removed",
      "removeEnrollment": "Remove enrollment",
      "feedback": "Feedback",
      "enrollmentStatus": {
        "enrolled": "Enrolled",
        "attended": "Attended",
        "absent": "Absent",
        "cancelled": "Cancelled"
      }
    },
    "timeRegistration": {
      "title": "Time registration",
      "empty": "No employees found.",
      "addRegistration": "Add registration",
      "editRegistration": "Edit registration",
      "kindLabel": "Type",
      "kind": {
        "on_site": "On site",
        "online": "Online"
      },
      "start": "In",
      "end": "Out",
      "endHint": "Empty = still open. A time before In falls on the next day.",
      "deleteConfirmTitle": "Delete registration?",
      "deleteConfirmDescription": "This registration will be removed permanently.",
      "notice": {
        "missed_checkout": "Not clocked out",
        "not_checked_in": "Not clocked in",
        "checked_in_on_leave": "Clocked in while absent",
        "late": "Came in late",
        "left_early": "Left early"
      },
      "unknownBadges": {
        "title": "Unknown badges",
        "description": "These badges were scanned but belong to no employee. Link a badge and its scans will still count.",
        "summary": "scanner {scanner}, last scan {lastScan}, {count} scans",
        "link": "Link",
        "linkTitle": "Link badge {badge}",
        "employee": "Employee",
        "linked": "{count} scans processed"
      },
      "settings": {
        "title": "Time registration",
        "autoCheckout": "Clock out automatically",
        "autoCheckoutHint": "Anything still open at this time is clocked out and marked as not clocked out.",
        "autoCheckoutTime": "Time",
        "firstSickDay": "First sick day costs leave",
        "firstSickDayHint": "The first day of a sick report is taken from leave, up to the maximum per year.",
        "firstSickDayMax": "Maximum per year",
        "timeRequired": "Enter a time.",
        "maxInvalid": "The maximum per year is a whole number of 0 or more.",
        "idleLogout": "Log out after inactivity (minutes)",
        "idleLogoutHint": "Anyone who does not click, type or scroll for this long is logged out. An orange registration then ends at the last activity. Empty = never log out.",
        "idleLogoutInvalid": "Log out after inactivity must be a whole number from 1 to 1440 minutes, or empty.",
        "badgeSymbology": "Code type on the badge",
        "badgeSymbologyHint": "Choose the type your scanners read. QR needs a 2D scanner."
      },
      "addLeave": "Add absence",
      "leave": "Absence",
      "stillOpen": "still open",
      "allRegistrations": "All registrations",
      "allKinds": "All kinds",
      "sourceLabel": "Source",
      "source": {
        "scanner": "Scanner",
        "browser": "Browser",
        "manual": "Manual"
      }
    },
    "leaveTypes": {
      "title": "Absence types",
      "subtitle": "The types HR picks from for an absence",
      "empty": "No absence types",
      "newTitle": "New absence type",
      "editTitle": "Absence type",
      "code": "Code",
      "codeHint": "Lowercase letters, digits and _; fixed once created",
      "label": "Name",
      "sortOrder": "Order",
      "properties": "Properties",
      "isAbsence": "Absent",
      "isAbsenceHint": "Raises the “Clocked in while absent” notice",
      "isSick": "Sick",
      "isSickHint": "May have no end date; the first day can cost leave",
      "activeHint": "An inactive type can no longer be picked; existing lines keep it"
    },
    "hoursAndLeave": {
      "tab": "Hours & leave",
      "year": "Year",
      "opening": "Opening balance",
      "taken": "Taken",
      "closing": "Closing balance",
      "special": "Special leave",
      "entitlement": "Annual entitlement",
      "entitlementTitle": "Annual entitlement {year}",
      "entitlementHours": "Entitlement in hours",
      "openingBalance": "Carried-over opening balance",
      "openingBalanceHint": "Empty = entitlement + last year’s closing balance. When filled in, it replaces the whole opening balance, for example at the switchover.",
      "registrations": "Registrations",
      "leave": "Absences",
      "noRegistrations": "No registrations this year",
      "date": "Date"
    }
  },
  "inventory": {
    "subtitle": "Track items, stock levels, and movements across locations",
    "locations": "Locations",
    "location": "Location",
    "supplier": "Supplier",
    "lots": "Lots",
    "lot": {
      "entity": "Lot",
      "new": "New lot",
      "subtitle": "Track batches of lot-tracked products.",
      "listEmpty": "No lots found.",
      "number": "Lot number",
      "manufactureDate": "Manufacture date",
      "expirationDate": "Expiration date",
      "notes": "Notes",
      "selectProduct": "Select a lot-tracked product",
      "noSupplier": "No supplier",
      "expired": "Expired",
      "totalQuantity": "Total qty",
      "stockByLocation": "Stock by location",
      "created": "Lot created",
      "duplicate": "A lot with that number already exists for this product.",
      "productNotLotTracked": "That product is not lot-tracked."
    },
    "serial": {
      "entityPlural": "Serials",
      "subtitle": "Track individual serialized units.",
      "listEmpty": "No serials found.",
      "newTitle": "New serial",
      "create": "Create serial",
      "created": "Serial created",
      "number": "Serial number",
      "product": "Product",
      "lot": "Lot",
      "location": "Location",
      "selectProduct": "Select a serial-tracked product",
      "locationHint": "With a location the serial is booked into stock there and counts towards the stock level.",
      "statusDerived": "Derived from the location when created.",
      "noLot": "No lot",
      "noLocation": "No location",
      "allProducts": "All products",
      "allLocations": "All locations",
      "allStatuses": "All statuses",
      "status": {
        "in_stock": "In stock",
        "sold": "Sold",
        "returned": "Returned",
        "disposed": "Disposed"
      },
      "notSerialTracked": "That product is not serial-tracked.",
      "duplicate": "A serial with that number already exists for this product.",
      "locationRequired": "A location is required to mark a serial in stock.",
      "locationOnlyWhenInStock": "Only a serial that is in stock can have a location.",
      "movements": "Stock movements",
      "noMovements": "No movements recorded yet.",
      "movementKind": "Kind",
      "movementQuantity": "Quantity",
      "movementDate": "Date",
      "movementKinds": {
        "adjustment": "Adjustment",
        "transfer_in": "Transfer in",
        "transfer_out": "Transfer out",
        "receipt": "Receipt",
        "shipment": "Shipment"
      },
      "bulkAdd": "Bulk add",
      "bulkTitle": "Bulk add serials",
      "bulkNumbers": "Serial numbers",
      "bulkNumbersPlaceholder": "One serial number per line",
      "bulkRequired": "Product and at least one serial number are required.",
      "bulkCreated": "Created {count} serial(s).",
      "bulkSkipped": "Skipped {count}: {numbers}",
      "bulkAdding": "Adding…",
      "bulkSubmit": "Add serials"
    },
    "name": "Name",
    "quantity": "Quantity",
    "newLocation": "New location",
    "active": "Active",
    "locationNotFound": "Location not found.",
    "stockByProduct": "Stock by product",
    "product": "Product",
    "noStockYet": "No stock recorded yet.",
    "archiveConfirmTitle": "Archive this location?",
    "archiveConfirmBody": "The location will be marked inactive and hidden from active lists. Existing stock records are preserved.",
    "transfer": {
      "title": "Transfer stock",
      "subtitle": "Move stock between locations.",
      "section": "Transfer",
      "fromLocation": "From location",
      "toLocation": "To location",
      "serialsHint": "In-stock serials at the source location.",
      "quantityPlaceholder": "e.g. 10",
      "recorded": "{count, plural, one {Transferred — recorded # movement.} other {Transferred — recorded # movements.}}",
      "chooseProduct": "Choose a product.",
      "chooseLocations": "Choose both locations.",
      "chooseLot": "Choose a lot.",
      "chooseSerial": "Select at least one serial.",
      "positiveQuantity": "Enter a positive quantity.",
      "pending": "Transferring…",
      "submit": "Transfer",
      "error": {
        "sameLocation": "Source and destination locations must differ.",
        "serialQuantityMismatch": "The number of selected serials must match the quantity.",
        "lotRequired": "This item is lot-tracked — choose a lot.",
        "serialRequired": "This item is serial-tracked — select serials."
      }
    },
    "code": "Code",
    "archived": "Archived",
    "archive": "Archive",
    "create": "Create",
    "movement": {
      "title": "Stock movements",
      "subtitle": "The full ledger of stock changes.",
      "subtitleNegative": "The full ledger of stock changes. Some rows reduced stock (negative quantity).",
      "listEmpty": "No movements found.",
      "date": "Date",
      "kind": "Kind",
      "reason": "Reason",
      "reference": "Reference",
      "createdBy": "Created by",
      "allProducts": "All products",
      "allLocations": "All locations",
      "allKinds": "All kinds",
      "clearFilters": "Clear filters",
      "kinds": {
        "adjustment": "Adjustment",
        "transfer_in": "Transfer in",
        "transfer_out": "Transfer out",
        "receipt": "Receipt",
        "shipment": "Shipment"
      },
      "referenceTypes": {
        "collo": "Collo",
        "purchase_line": "Purchase order line",
        "transfer": "Transfer"
      }
    },
    "adjust": {
      "title": "Adjust stock",
      "subtitle": "Manually correct stock levels.",
      "section": "Adjustment",
      "direction": "Direction",
      "directionIn": "In",
      "directionOut": "Out",
      "statusAfter": "Status after",
      "serialsOutHint": "In-stock serials at the chosen location.",
      "serialsInHint": "Registered serials not currently in stock.",
      "quantityChange": "Quantity change",
      "quantityChangePlaceholder": "e.g. 10 or -5",
      "quantityChangeHint": "Positive adds stock, negative removes it.",
      "recorded": "{count, plural, one {Recorded # movement.} other {Recorded # movements.}}",
      "chooseProduct": "Choose a product.",
      "chooseLocation": "Choose a location.",
      "chooseLot": "Choose a lot.",
      "chooseSerial": "Select at least one serial.",
      "nonZeroQuantity": "Enter a non-zero quantity.",
      "submit": "Apply adjustment",
      "error": {
        "serialQuantityMismatch": "The number of selected serials must match the quantity.",
        "zeroDelta": "The adjustment quantity cannot be zero.",
        "lotRequired": "This item is lot-tracked — choose a lot.",
        "serialRequired": "This item is serial-tracked — select serials."
      }
    },
    "position": {
      "title": "Stock position",
      "subtitle": "Physical, reserved and available alongside the economic stock.",
      "listEmpty": "No products with stock tracking.",
      "physical": "Physical",
      "reserved": "Reserved",
      "available": "Available",
      "expected": "Expected",
      "toDeliver": "To deliver",
      "economic": "Economic stock",
      "ownership": "Ownership",
      "own": "Ours",
      "custody": "In custody",
      "unknown": "Unknown",
      "age": "Age",
      "ageDays": "{days} d",
      "overstaying": "Overdue",
      "belowThreshold": "Replenish",
      "belowThresholdOnly": "Only to replenish"
    },
    "valuation": {
      "title": "Stock valuation",
      "subtitle": "The value of what is on hand, at the cost it came in at.",
      "listEmpty": "Nothing booked yet to value.",
      "value": "Value",
      "unvalued": "Not valued",
      "forbidden": "You do not have access to cost prices. Ask an administrator for access to stock valuation.",
      "reason": {
        "custody": "In custody",
        "unknown_ownership": "Ownership unknown",
        "unknown_cost": "Cost unknown",
        "mixed_currency": "Mixed currencies"
      }
    },
    "isExternal": "Held by a third party",
    "isExternalHint": "Stock at this location does not count as available for own production, for example a printing plate held by the printer.",
    "home": {
      "stockProducts": "Stock products",
      "lowStock": "To replenish",
      "noLowStock": "No items below their threshold.",
      "recentMovements": "Recent movements"
    },
    "webhooks": {
      "title": "Inbound webhooks",
      "subtitle": "Let another system adjust and transfer stock.",
      "create": "Create webhook",
      "empty": "No webhooks yet.",
      "label": "Name",
      "labelPlaceholder": "Warehouse scanner",
      "token": "Token",
      "secret": "Secret",
      "allowedActions": "Allowed actions",
      "rateLimit": "Limit per minute",
      "enabled": "On",
      "createDescription": "The token and secret are shown once, right after creation.",
      "created": "Webhook created",
      "rotate": "New secret",
      "rotated": "New secret created",
      "revealTitle": "Save these credentials",
      "revealDescription": "Copy the secret now: it won't be shown again.",
      "done": "Done",
      "copied": "{label} copied",
      "copyFailed": "Could not copy to the clipboard",
      "action": {
        "adjust": "Adjustment",
        "transfer": "Transfer"
      },
      "deliveries": {
        "title": "Recent messages ({count})",
        "empty": "No messages received yet.",
        "received": "Received",
        "action": "Action",
        "result": "Result",
        "movement": "Movement",
        "error": "Error"
      },
      "result": {
        "ok": "Booked",
        "pending": "In progress",
        "hmac_fail": "Invalid signature",
        "validation_error": "Invalid message",
        "server_error": "Not booked",
        "rate_limited": "Over the limit"
      }
    }
  },
  "settings": {
    "nav": {
      "access": "Access",
      "developer": "Developer"
    },
    "translations": {
      "title": "Translations",
      "subtitle": "Customize interface texts and manage languages for your workspace",
      "allNamespaces": "All categories",
      "noResults": "No matching translations.",
      "columns": {
        "key": "Key",
        "system": "System text",
        "override": "Your translation",
        "status": "Status"
      },
      "status": {
        "overridden": "Custom",
        "system": "System",
        "fallback": "Falls back to {locale}"
      },
      "actions": {
        "reset": "Reset to system text"
      },
      "toast": {
        "saved": "Translation saved",
        "reset": "Reset to system text",
        "localeAdded": "Language added",
        "localeRenamed": "Language renamed",
        "localeRemoved": "Language removed",
        "migrated": "Moved {moved} translations ({skipped} already existed)"
      },
      "locales": {
        "customBadge": "custom",
        "add": "Add language",
        "addTitle": "Add a language",
        "code": "Locale code",
        "codeHint": "Language and country, e.g. nl-BE, pl-PL or pt-BR",
        "label": "Display name",
        "rename": "Rename",
        "renameTitle": "Rename language",
        "migrate": "Migrate",
        "migrateTitle": "Migrate translations from {from}",
        "migrateHint": "Moves all translations of this language to another language code. Existing translations on the target are kept.",
        "migrateTarget": "Select target language",
        "remove": "Remove",
        "removeTitle": "Remove language {code}?",
        "removeHint": "The language disappears from the language picker. Its translations are kept and come back if you re-add the language."
      },
      "nsGroups": {
        "general": "General interface",
        "modules": "Modules",
        "settings": "Settings & administration",
        "other": "Other"
      }
    },
    "company": {
      "title": "Company",
      "subtitle": "Identity, branding, and contact details used across every module.",
      "savedToast": "Company settings saved",
      "sectionIdentity": "Identity",
      "sectionBranding": "Branding",
      "sectionContact": "Contact",
      "sectionAddresses": "Addresses",
      "sectionBanking": "Banking",
      "sectionNotes": "Notes",
      "sectionSales": "Sales",
      "defaultOfferValidity": "Default offer validity",
      "defaultDeliveryCondition": "Default delivery condition",
      "defaultDeliveryTime": "Default delivery time",
      "defaultLocale": "Default language",
      "defaultLocaleHint": "For customers, contacts and employees without a language of their own. Empty = English (UK).",
      "fscClaim": "FSC claim",
      "fscClaimDesc": "Your company's default (safe) FSC claim, picked from the list; a calculation or product may override it. Shown on the quote, order confirmation, packing slip, invoice and purchase order, after the number of each line flagged FSC. Leave blank if you make no claim — nothing is printed then.",
      "timelineRetentionDays": "Keep timeline entries (days)",
      "timelineRetentionDaysHint": "Timeline entries older than this are deleted every night, on all records. Between 30 and 3650 days; leave blank for 730 (two years).",
      "legalName": "Legal name",
      "tradingName": "Trading name",
      "tradingNameDesc": "What customers see. Shown in the sidebar.",
      "vatNumber": "VAT number",
      "registrationNumber": "Registration number",
      "registrationNumberDesc": "Chamber of Commerce, Handelsregister, Companies House, etc.",
      "founded": "Founded",
      "foundedDesc": "Drives \"years in business\" in reports",
      "yearsInBusiness": "{years} years in business",
      "website": "Website",
      "slogan": "Slogan",
      "emailGeneral": "Email — general",
      "phoneGeneral": "Phone — general",
      "emailSales": "Email — sales",
      "phoneSales": "Phone — sales",
      "emailPlanning": "Email — planning",
      "phonePlanning": "Phone — planning",
      "emailExpedition": "Email — expedition",
      "phoneExpedition": "Phone — expedition",
      "emailAdministration": "Email — administration",
      "phoneAdministration": "Phone — administration",
      "emailSupport": "Email — support",
      "phoneSupport": "Phone — support",
      "iban": "IBAN",
      "ibanDesc": "Encrypted at rest.",
      "ibanDecryptFailed": "Couldn't decrypt the stored IBAN. Leave blank to keep it, or type a new one to overwrite.",
      "bicSwift": "BIC / SWIFT",
      "bankName": "Bank name",
      "paymentInstructions": "Payment instructions",
      "paymentInstructionsDesc": "Shown on every invoice's PDF and email.",
      "internalNotes": "Note",
      "logoVignet": "Vignet",
      "logoVignetDesc": "Small mark, shown in the sidebar.",
      "logoVignetDark": "Vignet (dark)",
      "logoVignetDarkDesc": "Used on dark backgrounds; falls back to the light vignet.",
      "logoGeneral": "General logo",
      "logoGeneralDesc": "Full wordmark for emails and reports.",
      "logoGeneralDark": "General logo (dark)",
      "logoGeneralDarkDesc": "Used on dark backgrounds; falls back to the light general logo.",
      "addressGoodsReceipt": "Goods receipt",
      "logoSaveFirst": "Save your changes first to upload or remove a logo."
    },
    "email": {
      "title": "Outgoing email",
      "subtitle": "Choose how this workspace sends email. Use Microsoft 365 app access, or point at any SMTP server.",
      "badgeNotConfigured": "Not configured",
      "badgeSmtp": "SMTP active",
      "fromTitle": "From address",
      "fromDesc": "Shown as the sender on every email this workspace sends.",
      "fromName": "From name",
      "fromEmail": "From email",
      "smtpTitle": "SMTP server",
      "smtpDesc": "Use any SMTP provider — SES, Postmark, Mailgun, or your own server.",
      "host": "Host",
      "port": "Port",
      "portDesc": "587 for STARTTLS, 465 for implicit TLS",
      "implicitTls": "Use implicit TLS (port 465)",
      "username": "Username",
      "password": "Password",
      "passwordKeep": "Leave blank to keep the current password.",
      "storedEncrypted": "Stored encrypted at rest.",
      "savedMask": "••••••••  (saved)",
      "disconnect": "Disconnect",
      "disconnectConfirm": "Disconnect and clear email credentials?",
      "testTitle": "Send a test email",
      "testDesc": "Verify the configuration end-to-end. Save your settings first.",
      "send": "Send",
      "toastSmtpSaved": "SMTP settings saved",
      "toastSmtpSavedFallback": "SMTP settings saved. Email is sent through Microsoft 365; if that fails, through this SMTP server.",
      "toastDisconnected": "Email disconnected",
      "toastTestSent": "Test email sent",
      "toastTestFallback": "Sent through platform fallback",
      "entraTenantId": "Entra tenant ID",
      "clientId": "Application (client) ID",
      "clientSecret": "Client secret",
      "clientSecretKeep": "Leave blank to keep the current secret. Stored encrypted at rest.",
      "clientSecretPlaceholder": "Paste the secret value (not the secret ID)",
      "badgeMicrosoftApp": "Microsoft 365 (app)",
      "msAppTitle": "Microsoft 365 - app access",
      "msAppDesc": "Send as any mailbox in your organization using only the Entra tenant ID, application ID and client secret.",
      "msAppActiveBadge": "Active",
      "msAppPermissionHint": "Requires an Entra app registration with the APPLICATION permission Mail.Send and admin consent. No redirect URI and no mailbox connection - the app authenticates as itself and may send from any mailbox in the directory.",
      "msAppTenantIdDesc": "Directory (tenant) ID from your Entra app registration. 'common' does not work for app access.",
      "msAppNoCommon": "Use your directory's tenant ID - 'common' cannot issue app-only tokens",
      "senderMailbox": "Sender mailbox",
      "senderMailboxDesc": "The mailbox emails are sent from. Any mailbox in your organization works.",
      "msAppSaveActivate": "Save & activate",
      "toastMsAppOnlySaved": "Microsoft app access saved and activated"
    },
    "emailTemplates": {
      "name": "Name",
      "purpose": "Purpose",
      "locale": "Locale",
      "status": "Status",
      "statusDefault": "Default",
      "statusCustomized": "Customized",
      "filterAll": "All",
      "filterEntity": "Entity",
      "empty": "No templates found.",
      "source": "Source",
      "preview": "Preview",
      "subject": "Subject",
      "body": "Body",
      "variablesAndFilters": "Available variables and filters",
      "variables": "Variables",
      "filters": "Filters",
      "resetToDefault": "Reset to default",
      "resetTitle": "Reset to default?",
      "resetWarning": "This restores the system seed for this template. Your customisations will be lost.",
      "reset": "Reset",
      "resetDoneToast": "Template reset to the default",
      "rendering": "Rendering…",
      "renderErrors": "Render errors:",
      "bodyHint": "HTML + Liquid",
      "header": "Header",
      "footer": "Footer",
      "bandHint": "Supports the same Liquid variables as the body; plain text or a hosted logo image.",
      "emailPreview": "Email"
    },
    "quotas": {
      "title": "Quotas",
      "subtitle": "Per-tenant limits enforced by the API. Contact platform support if you need more headroom.",
      "usage": "Usage",
      "currentLimits": "Current limits",
      "entities": "Entities (across all modules)",
      "workflows": "Workflows",
      "webhooks": "Webhooks",
      "liveRecords": "Live records",
      "workflowRuns": "Workflow runs (last minute)",
      "recordsNote": "{count} active records (no per-tenant cap; only per-record size cap is enforced)",
      "maxEntities": "Max entities per module",
      "maxFields": "Max fields per entity",
      "maxRecordSize": "Max record size",
      "maxWorkflows": "Max workflows per module",
      "maxWebhooks": "Max webhooks per module",
      "maxWorkflowRuns": "Max workflow runs / minute"
    },
    "finance": {
      "approval": {
        "enabledLabel": "Approval on",
        "currency": "Currency",
        "documentTypePurchaseOrder": "Purchase order",
        "documentTypeApBill": "Purchase invoice",
        "documentTypeSalesOrder": "Sales order",
        "step": "Step {step}",
        "fromAmount": "From amount",
        "who": "Who",
        "kindUsers": "People",
        "kindRole": "Role",
        "kindBuyer": "The buyer",
        "mode": "One or all",
        "modeAny": "One",
        "modeAll": "All",
        "pickUsers": "Choose people",
        "pickRole": "Choose a role",
        "addStep": "Add step",
        "removeStep": "Remove step",
        "moveUp": "Move step up",
        "moveDown": "Move step down",
        "noSteps": "There are no steps, so this document type needs no approval.",
        "rankHelp": "The lower in the list, the higher the step. Whoever may approve a higher step may also approve the steps above it.",
        "messageTitle": "Message",
        "messageHelp": "Choose per person how they are notified when a document is waiting for approval. The bell always gets a notification.",
        "messageDirect": "An email right away",
        "messageDigest": "Daily summary",
        "messageBell": "Bell only",
        "messageEmpty": "Nobody is in a step yet.",
        "missingAmount": "Enter an amount, for example 1000 or 1000.50.",
        "missingUsers": "Choose at least one person.",
        "missingRole": "Choose a role.",
        "higherAbove": "This amount is lower than that of step {step}. Whoever approves this step may also approve step {step}, so for a large amount they approve both steps on their own. Put the step with the highest amount at the bottom.",
        "withoutRead": "Not counted, because they may not read this kind of document: {names}."
      },
      "paymentTerms": {
        "subtitle": "Manage payment terms and discounts.",
        "createTitle": "Add payment term",
        "daysOffset": "Days offset",
        "discountDays": "Discount days",
        "discountPercent": "Discount %",
        "discount": "Discount",
        "editTitle": "Edit {name}",
        "deleteTitle": "Delete {name}?",
        "deleteDescription": "Removes this payment term. Documents already issued under this term keep their snapshot.",
        "namePlaceholder": "Net 30"
      },
      "taxNotes": {
        "title": "VAT notices",
        "subtitle": "Manage legal VAT notices per treatment and country.",
        "createTitle": "Add VAT notice",
        "editTitle": "Edit {treatment}",
        "deleteTitle": "Delete {treatment}?",
        "deleteDescription": "Removes this VAT notice.",
        "treatment": "VAT treatment",
        "country": "Country",
        "text": "Text",
        "allCountries": "All countries"
      },
      "taxRates": {
        "subtitle": "Manage tax rates and treatments.",
        "createTitle": "Add tax rate",
        "treatment": "VAT treatment",
        "treatments": {
          "standard": "Standard",
          "reduced": "Reduced",
          "zero": "Zero-rated",
          "intra_community": "Intra-Community",
          "export": "Export",
          "reverse_charge": "Reverse charge",
          "exempt": "Exempt"
        },
        "percentage": "Percentage",
        "country": "Country",
        "default": "Default",
        "editTitle": "Edit {name}",
        "deleteTitle": "Delete {name}?",
        "deleteDescription": "This removes the tax rate. Documents already issued under this rate keep their snapshot.",
        "namePlaceholder": "Standard VAT"
      }
    }
  },
  "projects": {
    "common": {
      "status": {
        "planning": "Planning",
        "active": "Active",
        "on_hold": "On hold",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "taskStatus": {
        "todo": "To do",
        "in_progress": "In progress",
        "review": "Review",
        "done": "Done"
      },
      "priority": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "urgent": "Urgent"
      },
      "role": {
        "lead": "Lead",
        "member": "Member",
        "viewer": "Viewer"
      },
      "delete": "Delete",
      "edit": "Edit",
      "actions": "Actions",
      "loading": "Loading…",
      "search": "Search",
      "allProjects": "All projects",
      "project": "Project",
      "hours": "Hours",
      "dueDate": "Due date",
      "overdue": "Overdue",
      "noResults": "No results.",
      "assignee": "Assignee",
      "deleteConfirmTitle": "Delete?",
      "deleteConfirmBody": "This cannot be undone."
    },
    "list": {
      "title": "Projects",
      "subtitle": "Plan projects, track tasks, and log time.",
      "kpi": {
        "activeProjects": "Active projects",
        "openTasks": "Open tasks",
        "overdueMilestones": "Overdue milestones",
        "hoursLogged": "Hours logged"
      },
      "allStatuses": "All statuses",
      "columns": {
        "name": "Name",
        "status": "Status",
        "owner": "Owner",
        "start": "Start",
        "end": "End",
        "progress": "Progress",
        "members": "Members"
      },
      "toast": {
        "created": "Project created",
        "deleted": "Project deleted"
      }
    },
    "detail": {
      "notFound": "Project not found.",
      "tabs": {
        "overview": "Overview",
        "tasks": "Tasks",
        "milestones": "Milestones",
        "team": "Team",
        "time": "Time"
      },
      "edit": {
        "noOwner": "No owner"
      },
      "fields": {
        "name": "Name",
        "description": "Description",
        "status": "Status",
        "priority": "Priority",
        "startDate": "Start date",
        "endDate": "End date",
        "budget": "Budget",
        "owner": "Owner"
      },
      "overview": {
        "progress": "Progress",
        "tasksDone": "{done} of {total} tasks done",
        "upcomingMilestones": "Upcoming milestones",
        "noMilestones": "No open milestones."
      },
      "tasks": {
        "add": "Add task",
        "title": "Title",
        "searchPlaceholder": "Search tasks",
        "unassigned": "Unassigned",
        "estimatedHours": "Estimated hours"
      },
      "milestones": {
        "add": "Add milestone",
        "completed": "Completed"
      },
      "team": {
        "addMember": "Add member",
        "user": "User",
        "role": "Role",
        "capacity": "Capacity (h/week)",
        "selectUser": "Select user"
      },
      "time": {
        "date": "Date",
        "task": "Task",
        "user": "User",
        "billable": "Billable",
        "nonBillable": "Non-billable",
        "total": "Total: {n} h"
      },
      "toast": {
        "projectUpdated": "Project updated",
        "taskAdded": "Task added",
        "taskUpdated": "Task updated",
        "taskDeleted": "Task deleted",
        "milestoneAdded": "Milestone added",
        "milestoneUpdated": "Milestone updated",
        "milestoneDeleted": "Milestone deleted",
        "memberAdded": "Member added",
        "memberUpdated": "Member updated",
        "memberRemoved": "Member removed"
      },
      "newTitle": "New project",
      "newSubtitle": "Save the project first; tasks, milestones, team, time and files become available afterwards."
    },
    "boards": {
      "editor": {
        "layers": "Layers",
        "properties": "Properties",
        "emptyPage": "Nothing on this page yet. Pick a tool and draw.",
        "noSelection": "Select something to change it.",
        "selectedCount": "{n} selected",
        "align": "Align",
        "kinds": {
          "frame": "Frame",
          "rect": "Rectangle",
          "ellipse": "Ellipse",
          "line": "Line",
          "arrow": "Arrow",
          "text": "Text",
          "image": "Image",
          "sticky": "Sticky note",
          "pen": "Drawing",
          "group": "Group",
          "component": "Component",
          "instance": "Instance",
          "path": "Path"
        },
        "props": {
          "increase": "Increase",
          "decrease": "Decrease",
          "x": "X",
          "y": "Y",
          "width": "Width",
          "height": "Height",
          "rotation": "Rotation",
          "fill": "Fill",
          "stroke": "Stroke",
          "strokeWidth": "Stroke width",
          "radius": "Corner radius",
          "opacity": "Opacity (%)",
          "fontSize": "Font size",
          "fontWeight": "Weight",
          "color": "Colour",
          "none": "None",
          "font": "Font",
          "fontDefault": "App font",
          "lineHeight": "Line height (%)",
          "letterSpacing": "Letter spacing",
          "italic": "Italic"
        },
        "weights": {
          "400": "Regular",
          "500": "Medium",
          "600": "Semibold",
          "700": "Bold"
        },
        "actions": {
          "align": {
            "left": "Align left",
            "center": "Align centre",
            "right": "Align right",
            "top": "Align top",
            "middle": "Align middle",
            "bottom": "Align bottom"
          },
          "distributeHorizontal": "Distribute horizontally",
          "distributeVertical": "Distribute vertically",
          "bringToFront": "Bring to front",
          "bringForward": "Bring forward",
          "sendBackward": "Send backward",
          "sendToBack": "Send to back",
          "group": "Group",
          "ungroup": "Ungroup",
          "lock": "Lock",
          "unlock": "Unlock",
          "hide": "Hide",
          "show": "Show",
          "duplicate": "Duplicate",
          "delete": "Delete"
        },
        "image": {
          "type": "Only PNG, JPEG, WebP, GIF and SVG images can be added.",
          "size": "An image can be at most 10 MB.",
          "failed": "The image could not be uploaded."
        },
        "tools": {
          "image": "Image",
          "select": "Select",
          "hand": "Hand",
          "frame": "Frame",
          "rect": "Rectangle",
          "ellipse": "Ellipse",
          "line": "Line",
          "arrow": "Arrow",
          "text": "Text",
          "sticky": "Sticky note",
          "pen": "Pen",
          "comment": "Comment",
          "pencil": "Pencil"
        },
        "pages": "Pages",
        "addPage": "Add page",
        "pageName": "Page {n}",
        "undo": "Undo",
        "redo": "Redo",
        "zoomIn": "Zoom in",
        "zoomOut": "Zoom out",
        "zoomToFit": "Zoom to fit",
        "readOnly": "View only",
        "status": {
          "saved": "Saved",
          "unsaved": "Saving...",
          "offline": "No connection, reconnecting...",
          "tooLarge": "This board is too large to save",
          "outdated": "Reload needed"
        },
        "outdated": {
          "message": "This board was updated while it was open. Reload the page to keep working; until then you can only look.",
          "beforeOpen": "The app was updated. Reload the page to open this board.",
          "reload": "Reload"
        },
        "follow": "Follow {name}",
        "following": "Following {name}. Press Esc to stop.",
        "stopFollowing": "Stop following {name}",
        "export": {
          "title": "Export",
          "selection": "Export the selection",
          "firstFrame": "Export the first frame",
          "attach": "Attach to task: {task}",
          "attached": "Attached to the task",
          "colourList": "Colours used",
          "fontFallback": "Not in the PDF, shown in a standard font instead: {fonts}. The SVG export includes them.",
          "format": {
            "png": "PNG",
            "png2x": "PNG, double size",
            "svg": "SVG",
            "pdf": "PDF",
            "pdfColours": "PDF with colour list"
          }
        },
        "comments": {
          "title": "Comments",
          "thread": "Comment",
          "new": "New comment",
          "resolved": "Resolved",
          "placeholder": "Write a comment. Use @ to mention someone.",
          "replyPlaceholder": "Reply...",
          "send": "Send",
          "edit": "Edit",
          "delete": "Delete",
          "resolve": "Resolve",
          "reopen": "Reopen",
          "createTask": "Create a task from this",
          "openTask": "Open the task made from this",
          "replies": "{n} replies",
          "filter": {
            "open": "Open",
            "mentions": "Mentions",
            "resolved": "Resolved"
          },
          "empty": {
            "open": "No open comments. Pick the comment tool and click on the board.",
            "mentions": "Nobody has mentioned you here.",
            "resolved": "No resolved comments."
          }
        },
        "tasks": {
          "title": "Tasks",
          "link": "Link to task",
          "create": "Create task from this",
          "created": "Task created and linked",
          "unlink": "Remove link",
          "open": "Open task",
          "restricted": "Task you cannot view"
        },
        "history": {
          "title": "History",
          "save": "Save version",
          "saveTitle": "Save a version of this board",
          "name": "Name",
          "note": "Note (optional)",
          "saved": "Version saved.",
          "named": "Saved versions",
          "automatic": "Automatic",
          "beforeRestore": "Before restoring {name}",
          "emptyNamed": "No saved versions yet.",
          "emptyAutomatic": "Automatic versions appear after a few minutes of editing.",
          "preview": "Viewing: {name}",
          "restore": "Restore this version",
          "restoreConfirmTitle": "Restore {name}?",
          "restoreConfirmBody": "The whole board goes back to this version, for everyone who has it open. The current state is kept in the history first, and you can undo the restore.",
          "restored": "Restored: {name}",
          "copy": "Copy to new board",
          "copyName": "{board} ({name})",
          "back": "Back to current",
          "noSafetyCopy": "The board was too large to keep a copy in the history first. Undo still works in this tab."
        },
        "styles": {
          "assets": "Assets",
          "thisBoard": "This board",
          "colors": "Colours",
          "texts": "Text styles",
          "none": "No styles yet.",
          "newColor": "New colour style",
          "newText": "New text style",
          "edit": "Edit",
          "delete": "Delete",
          "detach": "Detach from library",
          "publish": "Publish to library",
          "republish": "Publish changes",
          "published": "Published",
          "fromLibrary": "Library",
          "removedFromLibrary": "No longer in the library",
          "actions": "Style actions",
          "library": "Library",
          "search": "Search the library",
          "libraryEmpty": "Nothing in the library yet.",
          "unknownSource": "Deleted board",
          "publishedToast": "Published to the library.",
          "newTitle": "New style",
          "editTitle": "Edit style",
          "name": "Name",
          "hex": "Screen colour",
          "cmyk": "CMYK (%)",
          "pantone": "Pantone",
          "invalidColor": "Use a screen colour like #D0021B, and CMYK from 0 to 100.",
          "invalidText": "Size 1 to 999, line height 50 to 500 %, letter spacing -50 to 200.",
          "fontFamily": "Font",
          "fontWeight": "Weight",
          "fontSize": "Size",
          "lineHeight": "Line height (%)",
          "letterSpacing": "Letter spacing",
          "italic": "Italic",
          "unlink": "Unlink from style",
          "style": "Style",
          "createFromThis": "New style from this",
          "create": "Create",
          "components": "Components",
          "noComponents": "No components yet. Select shapes and choose Create component.",
          "unnamedComponent": "Unnamed component",
          "componentActions": "Component actions",
          "libraryAllOnBoard": "Everything in the library is already on this board."
        },
        "library": {
          "available": "Library updates available ({n})",
          "review": "Review",
          "title": "Library updates",
          "accepted": "Library updates accepted.",
          "revision": "Revision {from} → {to}",
          "accept": "Accept",
          "acceptAll": "Accept all"
        },
        "components": {
          "create": "Create component",
          "detach": "Detach instance",
          "reset": "Reset overrides",
          "goToMain": "Go to main component",
          "editOnSource": "Edit on source board",
          "mainDeleted": "Main component deleted",
          "libraryMissing": "No longer on this board",
          "component": "Component",
          "unnamed": "Unnamed component",
          "instances": "Instances on this board: {n}",
          "partNote": "Part of an instance. Only its text, colours, image and visibility can differ from the main component.",
          "cycle": "Contains its own component, so it no longer follows it"
        },
        "layout": {
          "title": "Auto layout",
          "off": "No auto layout",
          "row": "Row",
          "column": "Column",
          "gap": "Gap",
          "padding": "Padding",
          "top": "Top",
          "right": "Right",
          "bottom": "Bottom",
          "left": "Left",
          "distribute": "Distribution",
          "align": "Alignment",
          "start": "Start",
          "center": "Centre",
          "end": "End",
          "between": "Space between",
          "resizing": "Resizing",
          "fixed": "Fixed",
          "hug": "Hug",
          "fill": "Fill"
        }
      },
      "title": "Boards",
      "subtitle": "Shared design canvases across your projects.",
      "new": "New board",
      "name": "Name",
      "namePlaceholder": "e.g. Homepage redesign",
      "description": "Description",
      "project": "Project",
      "selectProject": "Choose a project",
      "create": "Create board",
      "rename": "Rename",
      "save": "Save",
      "duplicate": "Duplicate",
      "copySuffix": "(copy)",
      "delete": "Delete",
      "deleteTitle": "Delete this board?",
      "deleteBody": "The board and everything drawn on it are removed. This cannot be undone.",
      "created": "Board created",
      "saved": "Board saved",
      "duplicated": "Board duplicated",
      "deleted": "Board deleted",
      "empty": "No boards yet.",
      "open": "Open board",
      "backToList": "All boards",
      "designs": {
        "tab": "Designs",
        "empty": "No designs are linked to this task yet. Link a frame to it from a board."
      },
      "notFound": "This board no longer exists.",
      "canvasComingSoon": "The canvas is not available yet.",
      "columns": {
        "name": "Name",
        "project": "Project",
        "updatedAt": "Last changed",
        "updatedBy": "Changed by"
      },
      "startFrom": "Start from",
      "blank": "Blank board",
      "templateSearch": "Search templates",
      "noTemplates": "No templates match.",
      "template": "Template",
      "markTemplate": "Mark as template",
      "unmarkTemplate": "Remove template mark",
      "templateMarked": "Marked as template.",
      "templateUnmarked": "Template mark removed.",
      "fromTemplate": "From template {name}"
    },
    "tasksPage": {
      "title": "Tasks",
      "subtitle": "All tasks across your projects.",
      "newTask": "New task",
      "detailsTab": "Details",
      "view": {
        "board": "Board",
        "list": "List"
      },
      "allAssignees": "All assignees",
      "allPriorities": "All priorities",
      "taskCount": "{n} tasks",
      "selectProject": "Select project",
      "unassigned": "Unassigned",
      "columns": {
        "title": "Title",
        "estimatedHours": "Est. hours"
      },
      "fields": {
        "title": "Title",
        "description": "Description",
        "status": "Status",
        "priority": "Priority",
        "estimatedHours": "Estimated hours"
      },
      "toast": {
        "created": "Task created",
        "updated": "Task updated",
        "deleted": "Task deleted"
      }
    },
    "timePage": {
      "title": "Time tracking",
      "subtitle": "Log and review hours across projects.",
      "kpi": {
        "myWeek": "My hours this week",
        "myMonth": "My hours this month",
        "teamWeek": "Team hours this week",
        "teamMonth": "Team hours this month"
      },
      "logTime": "Log time",
      "editEntry": "Edit time entry",
      "columns": {
        "date": "Date",
        "task": "Task",
        "user": "User",
        "description": "Description"
      },
      "billable": "Billable",
      "selectProject": "Select project",
      "selectTask": "Select task",
      "toast": {
        "logged": "Time logged",
        "updated": "Time entry updated",
        "deleted": "Time entry deleted"
      },
      "totalHours": "Total: {n}h"
    },
    "milestonesPage": {
      "title": "Milestones",
      "subtitle": "Track project milestones and due dates.",
      "openOnly": "Open only",
      "new": "New milestone",
      "createTitle": "New milestone",
      "editTitle": "Edit milestone",
      "selectProject": "Select a project",
      "fields": {
        "name": "Name"
      },
      "columns": {
        "done": "Done",
        "name": "Name",
        "completedOn": "Completed on"
      },
      "kpi": {
        "open": "Open milestones",
        "completedThisMonth": "Completed this month"
      },
      "toast": {
        "created": "Milestone created",
        "updated": "Milestone updated",
        "deleted": "Milestone deleted"
      }
    },
    "teamPage": {
      "title": "Team & workload",
      "subtitle": "Team capacity, assignments and project memberships.",
      "kpi": {
        "assignedMembers": "Members with assignments",
        "openTasks": "Open tasks",
        "overdueTasks": "Overdue tasks",
        "hoursThisWeek": "Hours this week"
      },
      "columns": {
        "member": "Member",
        "openTasks": "Open tasks",
        "hoursWeek": "Hours (week)",
        "hoursMonth": "Hours (month)",
        "capacity": "Capacity (h/week)",
        "utilization": "Utilization"
      },
      "detail": {
        "noMemberships": "No project memberships.",
        "openTasks": "{n} open tasks"
      },
      "members": {
        "title": "Project members",
        "subtitle": "Manage who belongs to a project, their role and weekly capacity.",
        "chooseProject": "Choose a project…",
        "chooseUser": "Choose a user…",
        "add": "Add member",
        "addTitle": "Add member",
        "user": "User",
        "role": "Role",
        "noMembers": "No members yet."
      },
      "toast": {
        "memberAdded": "Member added",
        "memberUpdated": "Member updated",
        "memberRemoved": "Member removed"
      }
    },
    "pollsPage": {
      "title": "Polls & Surveys",
      "subtitle": "Build multi-question surveys with any field type, schedule them, and share by link or email",
      "new": "New survey",
      "createTitle": "Create survey",
      "empty": "No surveys yet",
      "allStatuses": "All statuses",
      "backToList": "Back to surveys",
      "notFound": "Survey not found",
      "resultsHidden": "Results are hidden for this survey.",
      "resultsWithheld": {
        "notClosed": "This survey is anonymous: the results appear only once it is closed.",
        "tooFewResponses": "Too few responses to show anonymously: an anonymous survey shows its results from {count} responses."
      },
      "externalAudienceHint": "This survey is answered through its shared link or email invites. Use the Share or Invites tab.",
      "publicLink": "Public link",
      "publicLinkHint": "Anyone with this link can respond without signing in.",
      "qrHint": "Scan to open the survey",
      "openLink": "Open",
      "regenerate": "Regenerate link",
      "regenerateTitle": "Regenerate public link?",
      "regenerateBody": "The current link will stop working and a new one will be created.",
      "invite": "Invite",
      "noInvites": "No invitations sent yet.",
      "responded": "Responded",
      "pending": "Pending",
      "linkCopied": "Link copied",
      "deleteBody": "This permanently deletes the survey and all its responses.",
      "questionCount": "{count, plural, one {# question} other {# questions}}",
      "responseCount": "{count, plural, one {# response} other {# responses}}",
      "numericSummary": "Average {avg} · range {min}-{max} ({count} answers)",
      "noAnswers": "No answers yet.",
      "notInAudience": "You're not in the audience for this survey.",
      "youResponded": "You've already responded.",
      "anonymousNote": "Your response is anonymous: once sent, you can't view or change it.",
      "updateResponse": "Update my response",
      "submitResponse": "Submit response",
      "submitAnother": "Send another response",
      "columns": {
        "title": "Title",
        "questions": "Questions",
        "status": "Status",
        "responses": "Responses",
        "ends": "Ends"
      },
      "kpi": {
        "total": "Total surveys",
        "open": "Open now",
        "responses": "Total responses"
      },
      "status": {
        "draft": "Draft",
        "scheduled": "Scheduled",
        "open": "Open",
        "closed": "Closed"
      },
      "setStatus": {
        "draft": "Set draft",
        "open": "Open",
        "closed": "Close"
      },
      "tabs": {
        "respond": "Respond",
        "results": "Results",
        "share": "Share",
        "invites": "Invites",
        "settings": "Settings"
      },
      "toast": {
        "created": "Survey created",
        "updated": "Survey updated",
        "deleted": "Survey deleted",
        "responded": "Response recorded",
        "invitesSent": "Invitations sent"
      },
      "audience": {
        "workspace": "Everyone in workspace",
        "restricted": "Specific users / departments",
        "link": "Anyone with the link",
        "invite": "Email invitees"
      },
      "audienceHint": {
        "workspace": "Every signed-in member can respond.",
        "restricted": "Only the users and departments you choose can respond.",
        "link": "Generate an unguessable public link; no sign-in needed.",
        "invite": "Send each person a personal link by email."
      },
      "visibility": {
        "live": "Always visible",
        "after_vote": "After responding",
        "after_close": "After the survey closes",
        "creator_only": "Only the creator"
      },
      "qgroup": {
        "choice": "Choice",
        "rating": "Rating & numbers",
        "text": "Text",
        "other": "Other"
      },
      "qtype": {
        "single_choice": "Single choice",
        "multiple_choice": "Multiple choice",
        "dropdown": "Dropdown",
        "ranking": "Ranking",
        "rating": "Star rating",
        "scale": "Scale",
        "number": "Number",
        "short_text": "Short text",
        "long_text": "Paragraph",
        "email": "Email",
        "url": "URL",
        "phone": "Phone",
        "boolean": "Yes / No",
        "date": "Date",
        "datetime": "Date & time",
        "time": "Time"
      },
      "builder": {
        "title": "Title",
        "titlePlaceholder": "Survey title",
        "description": "Description",
        "descriptionPlaceholder": "Optional intro shown to respondents",
        "noProject": "No project",
        "questions": "Questions",
        "addQuestion": "Add question",
        "questionLabel": "Question",
        "helpText": "Help text (optional)",
        "option": "Option",
        "addOption": "Add option",
        "required": "Required",
        "removeQuestion": "Remove",
        "maxSelections": "Max selections",
        "min": "Min",
        "max": "Max",
        "step": "Step",
        "ratingMax": "Stars",
        "scaleMin": "From",
        "scaleMax": "To",
        "scaleMinLabel": "Low label",
        "scaleMaxLabel": "High label",
        "placeholder": "Placeholder",
        "schedule": "Schedule",
        "startsAt": "Opens at",
        "endsAt": "Closes at",
        "resultsVisibility": "Who can see results",
        "resultsVisibilityAnonymous": "Anonymous: nobody sees the results while the survey is open, not even the creator or an admin. Once it is closed they appear from {count} responses, and then this choice applies.",
        "anonymous": "Anonymous responses",
        "anonymousHint": "Don't store who submitted each response.",
        "allowMultiple": "Allow multiple responses",
        "allowMultipleHint": "Let the same person respond more than once.",
        "requireName": "Require respondent name",
        "requireNameHint": "Ask external respondents for their name.",
        "closingMessage": "Closing message",
        "closingMessagePlaceholder": "Shown after someone responds",
        "audience": "Audience",
        "addUser": "Add user",
        "selectUser": "Select a user",
        "addDepartment": "Add department",
        "selectDepartment": "Select a department",
        "noDepartments": "No departments available",
        "invitees": "Invitees",
        "inviteEmail": "Email",
        "inviteName": "Name (optional)",
        "addInvitee": "Add invitee",
        "invitesManagedHint": "Manage invitations from the Invites tab.",
        "noUsers": "No users available",
        "directoryLoading": "Loading…",
        "directoryError": "Couldn't load the directory. Try again."
      }
    },
    "library": {
      "tabs": {
        "styles": "Styles",
        "fonts": "Fonts",
        "components": "Components",
        "templates": "Templates"
      },
      "title": "Design library",
      "subtitle": "Colour and text styles published for every board in the company.",
      "emptyStyles": "Nothing published yet. Publish a style from a board's Assets tab.",
      "kinds": {
        "color_style": "Colour styles",
        "text_style": "Text styles"
      },
      "columns": {
        "name": "Name",
        "source": "Published from",
        "revision": "Revision",
        "publishedBy": "Published by",
        "publishedAt": "Published",
        "family": "Family",
        "weight": "Weight",
        "format": "Format",
        "uploadedBy": "Uploaded by",
        "uploadedAt": "Uploaded"
      },
      "unpublish": "Remove from library",
      "unpublished": "Removed from the library. Boards that use it keep their copy.",
      "fontsTitle": "Fonts",
      "fontsSubtitle": "Fonts uploaded for use on every board, next to the standard fonts.",
      "emptyFonts": "No fonts uploaded yet.",
      "upload": "Upload font",
      "uploadTitle": "Upload a font",
      "licenceNote": "Only upload fonts your licence allows you to use in this way. The uploader is responsible for the licence.",
      "file": "Font file (WOFF2, OTF or TTF)",
      "wrongType": "Choose a WOFF2, OTF or TTF file.",
      "familyInvalid": "Start with a letter; use only letters, digits, spaces, - and _.",
      "italic": "Italic",
      "fontUploaded": "Font uploaded.",
      "removeFont": "Remove",
      "fontRemoved": "Font removed. Boards that use it still show it.",
      "subtitleComponents": "Components published for every board in the company.",
      "emptyComponents": "Nothing published yet. Publish a component from a board's Assets tab.",
      "subtitleTemplates": "Boards offered as a starting point for a new board.",
      "emptyTemplates": "No templates yet. Mark a board as a template in the Boards list."
    }
  },
  "countries": {
    "title": "Countries",
    "validate": {
      "button": "Validate",
      "running": "Validating…",
      "title": "Reference data validation",
      "errors": "errors",
      "warnings": "warnings",
      "noIssues": "No issues — data matches ISO 3166-1 and ISO 3166-2.",
      "countries": "countries",
      "subdivisions": "subdivisions"
    },
    "loading": "Loading…",
    "notFound": "Country not found.",
    "saved": "Country saved.",
    "eu": "EU",
    "nonEu": "Non-EU",
    "sections": {
      "codes": "ISO codes",
      "names": "Names",
      "zone": "Region & locale",
      "subdivisions": "Subdivisions"
    },
    "fields": {
      "code": "ISO alpha-2",
      "codeA3": "ISO alpha-3",
      "codeNumeric": "ISO numeric",
      "nameEn": "Name (EN)",
      "nameNl": "Name (NL)",
      "nameDe": "Name (DE)",
      "nameFr": "Name (FR)",
      "dialingCode": "Dialing code",
      "defaultLocale": "Default locale",
      "isEu": "EU member",
      "useSubdivision": "Use subdivisions"
    },
    "hints": {
      "code": "2 uppercase letters, e.g. 'NL'",
      "codeA3": "3 uppercase letters, e.g. 'NLD'",
      "codeNumeric": "ISO 3166-1, e.g. 528",
      "dialingCode": "International, e.g. 31",
      "defaultLocale": "Format 'nl_NL'",
      "useSubdivision": "Use this country's states / provinces in addresses"
    },
    "subdivisionsList": {
      "title": "Subdivisions",
      "empty": "No subdivisions defined for this country yet.",
      "columns": {
        "code": "Code",
        "name": "Name"
      }
    }
  },
  "product": {
    "sku": "SKU",
    "customerArticleReference": "Customer article reference",
    "addPrint": "Printing",
    "addDiecut": "Die-cutting",
    "toolPrint1": "Printing plate 1",
    "toolPrint2": "Printing plate 2",
    "toolDiecut1": "Die 1",
    "toolDiecut2": "Die 2",
    "toolColor1": "Color 1",
    "toolColor2": "Color 2",
    "toolColor3": "Color 3",
    "toolColor4": "Color 4",
    "toolColor5": "Color 5",
    "toolColor6": "Color 6",
    "managedByCalc": "Managed via the calculation",
    "calcNewer": "The calculation has changed since the last sync.",
    "syncFromCalc": "Update from calculation",
    "kind": "Type",
    "kindProductie": "Production",
    "kindInkoop": "Purchasing",
    "kindOverige": "Other",
    "currency": "Currency",
    "commodityCode": "Commodity code (CN)",
    "taxRate": "VAT rate",
    "supplyKind": "Supply type",
    "supplyKindGoods": "Goods",
    "supplyKindService": "Service",
    "priceUnitPurchase": "Price unit (purchase)",
    "priceUnitSale": "Price unit (sale)",
    "weight": "Weight (kg)",
    "sectionStock": "Stock",
    "tracksStock": "Track stock",
    "tracksSerials": "Track serial numbers",
    "tracksLots": "Track lots",
    "barcode": "Barcode",
    "articleReferenceBarcode": "Customer Reference Barcode",
    "articleReferenceBarcodeSymbology": "Symbology",
    "barcodeSectionTitle": "Transport & Packages",
    "deliveryCondition": "Delivery condition",
    "deliveryConditionHint": "Empty = inherit the company default.",
    "barcodeInvalid": "Invalid value for this symbology",
    "unitOfMeasure": "Unit of measure (UoM)",
    "lowStockThreshold": "Low-stock threshold",
    "currentCost": "Current stock cost",
    "sectionNotes": "Notes",
    "notes": "Note",
    "productionNotes": "Production note",
    "uomKg": "Kilogram (kg)",
    "uomG": "Gram (g)",
    "uomT": "Tonne (t)",
    "uomM": "Metre (m)",
    "uomM2": "Square metre (m²)",
    "uomM3": "Cubic metre (m³)",
    "uomL": "Litre (L)",
    "uomH": "Hour (h)",
    "entityPlural": "Products",
    "new": "New product",
    "notFound": "Product not found.",
    "created": "Product created",
    "saved": "Product saved",
    "deleted": "Product deleted",
    "createAction": "Create product",
    "creating": "Creating…",
    "deleteTitle": "Delete product?",
    "deleteBody": "This permanently deletes the product. A product with stock history can't be deleted — deactivate it via the Active toggle instead.",
    "sectionData": "Details",
    "tiers": "Price tiers",
    "pricesUpdatedOn": "Selling prices updated on {date}",
    "tierFrom": "From quantity",
    "tierCost": "Cost",
    "tierPrice": "Price",
    "noTiers": "No price tiers.",
    "addTier": "Add tier",
    "customer": "Customer",
    "shipTo": "Ship-to",
    "ownCompany": "Own company",
    "uomStuk": "Piece (pcs)",
    "flagFsc": "FSC",
    "fscClaim": "FSC claim",
    "fscClaimHint": "Empty = the company claim (company setting)",
    "group": "Group",
    "groupSub": "Sub-group",
    "colloType": "Collo/pallet type",
    "palletSize": "Pallet size (cm)",
    "colloMaxHeight": "Max collo height (cm)",
    "colloLength": "Collo length (cm)",
    "colloWidth": "Collo width (cm)",
    "colloHeight": "Collo height (cm, incl. pallet)",
    "colloPieces": "Pieces per collo",
    "colloPiecesHint": "Determines how an order is split into colli. Empty = everything on one collo.",
    "palletsPerCollo": "Pallets per collo",
    "colloStackable": "Stackable",
    "tierMinQtyRequired": "Tier {row}: enter a \"from quantity\" (at least 1).",
    "tierMinQtyDuplicate": "Two tiers share the from-quantity {minQty}. Each quantity may appear only once.",
    "stockCategory": "Stock category",
    "stockCategoryOwn": "Own stock",
    "stockCategoryCustomer": "Customer stock",
    "stockCategoryCustomerTemporary": "Customer, temporary",
    "stockCategoryProductionSupply": "Production supplies",
    "stockCategoryMaintenance": "Maintenance stock",
    "stockSupplyMode": "Stock replenishment",
    "stockSupplyModeNone": "None",
    "stockSupplyModeByAgreement": "By agreement",
    "stockSupplyModeStanding": "Standing",
    "stockUnit": "Stock nature",
    "stockUnitCollo": "Colli",
    "stockUnitLoose": "Loose",
    "productionRunQuantity": "Production run quantity",
    "callOffQuantity": "Call-off quantity",
    "invoiceTrigger": "Invoicing",
    "invoiceTriggerOnCallOff": "Per call-off",
    "invoiceTriggerOnProduction": "Whole run on production",
    "maxStockMonths": "Max. months of stock",
    "stockAgreementSupplyModeRequiresStock": "Enable \"Track stock\" first: there can be no stock arrangement without stock administration.",
    "stockAgreementCallOffRequiresCustomer": "Call-off fields only apply to stock category \"Customer stock\". Clear them or change the category.",
    "sectionCreditors": "Creditors",
    "creditorN": "Creditor {n}",
    "creditorAccount": "Creditor",
    "creditorNone": "No creditor",
    "creditorReference": "Supplier article number",
    "creditorNote": "Note",
    "creditorLastModiDate": "Price updated on",
    "tierCreditorsForTier": "Creditors — tier {n}",
    "tierCreditorTotal": "Total creditors",
    "tierDropshipping": "Drop shipping",
    "tierUnitPrice": "Unit price",
    "dimensionLength": "Length (mm)",
    "dimensionWidth": "Width (mm)",
    "dimensionHeight": "Height (mm)",
    "color": "Colour",
    "m2PerUnit": "Flat size (m²)",
    "toolingSearchPlaceholder": "Search an article or type a number",
    "toolingTypedNumber": "Number only \"{number}\""
  },
  "reference": {
    "title": "Reference lists",
    "chooseList": "Choose a list",
    "tabs": {
      "identification": "Identification",
      "translations": "Translated values"
    },
    "fields": {
      "hexOuter": "Outer liner colour",
      "hexInner": "Inner liner colour"
    },
    "deleteConfirm": "This deletes the value permanently. If a record still uses it, it is not deleted and you see where it is used. To only take it out of the choices, switch off Active: records that already have it keep it.",
    "usage": {
      "company": "the company details",
      "accounts": "{count, plural, one {# account} other {# accounts}}",
      "visits": "{count, plural, one {# visit} other {# visits}}",
      "products": "{count, plural, one {# product} other {# products}}",
      "ppwrDeclarations": "{count, plural, one {# PPWR declaration} other {# PPWR declarations}}",
      "quotes": "{count, plural, one {# quote} other {# quotes}}",
      "salesOrders": "{count, plural, one {# sales order} other {# sales orders}}",
      "orderLines": "{count, plural, one {# order line} other {# order lines}}",
      "purchaseOrders": "{count, plural, one {# purchase order} other {# purchase orders}}",
      "productionOrders": "{count, plural, one {# production order} other {# production orders}}",
      "machineRunStops": "{count, plural, one {# stop on a machine run} other {# stops on machine runs}}",
      "calculations": "{count, plural, one {# calculation} other {# calculations}}",
      "machines": "{count, plural, one {# machine} other {# machines}}",
      "fefcos": "{count, plural, one {# Fefco code} other {# Fefco codes}}",
      "qualities": "{count, plural, one {# cardboard quality} other {# cardboard qualities}}"
    }
  },
  "colloTypes": {
    "title": "Collo types",
    "new": "New collo type",
    "delete": "Delete",
    "loading": "Loading…",
    "notFound": "Collo type not found.",
    "listEmpty": "No collo types yet.",
    "created": "Collo type created.",
    "saved": "Collo type saved.",
    "deleted": "Collo type deleted.",
    "yes": "Yes",
    "no": "No",
    "validationId": "An ID is required.",
    "deleteConfirmTitle": "Delete collo type?",
    "deleteConfirm": "This permanently removes the collo type. It cannot be deleted while it is used in saved calculations.",
    "fields": {
      "id": "ID",
      "sortOrder": "Sort order",
      "hasPallet": "On pallet",
      "labelNl": "Label NL",
      "labelEn": "Label EN",
      "labelDe": "Label DE",
      "labelFr": "Label FR"
    },
    "hints": {
      "id": "Unique identifier for the collo type",
      "sortOrder": "Display order (ascending)",
      "hasPallet": "Whether this collo type is shipped on a pallet"
    }
  },
  "palletSizes": {
    "title": "Collo pallet sizes",
    "new": "New pallet size",
    "delete": "Delete",
    "loading": "Loading…",
    "notFound": "Pallet size not found.",
    "listEmpty": "No pallet sizes yet.",
    "created": "Pallet size created.",
    "saved": "Pallet size saved.",
    "deleted": "Pallet size deleted.",
    "default": "Default",
    "notDefault": "Not default",
    "validationId": "An ID is required.",
    "deleteConfirmTitle": "Delete pallet size?",
    "deleteConfirm": "This permanently removes the pallet size. It cannot be deleted while a calculation, customer card, product, order line or collo still uses it.",
    "fields": {
      "id": "ID",
      "palletLength": "Length (mm)",
      "palletWidth": "Width (mm)",
      "palletHeight": "Height (mm)",
      "maxPallets": "Max pallets",
      "isDefault": "Default"
    },
    "hints": {
      "isDefault": "On auto, the calculation only picks from pallet sizes with Default on"
    }
  },
  "companyCertifications": {
    "title": "Certifications",
    "new": "New certification",
    "listEmpty": "No certifications of your company yet.",
    "loading": "Loading…",
    "notFound": "Certification not found.",
    "created": "Certification created",
    "deleted": "Certification deleted",
    "deleteConfirmTitle": "Delete certification?",
    "tabCertificate": "Certificate",
    "tabLogos": "Logos",
    "logoPromotion": "Promotional logo",
    "logoPromotionDesc": "For your website, brochures and other promotional material. Keep it here to download it.",
    "logoVignet": "Label (internal use)",
    "logoVignetDesc": "On an FSC certification, the label appears on the production slip of an FSC line."
  },
  "shiftTypes": {
    "title": "Shifts",
    "new": "New shift",
    "delete": "Delete",
    "loading": "Loading…",
    "notFound": "Shift not found.",
    "listEmpty": "No shifts yet.",
    "fields": {
      "startTime": "Start",
      "endTime": "End",
      "color": "Colour",
      "breaks": "Breaks",
      "breaksHint": "A break is a norm: the shop floor may shift it.",
      "breakStart": "Starts at",
      "breakMinutes": "Minutes"
    },
    "nightShift": "Night shift",
    "unreadableTime": "Unreadable time",
    "saved": "Shift saved",
    "created": "Shift created",
    "deleted": "Shift deleted",
    "deleteConfirm": "Delete this shift?",
    "deleteConfirmTitle": "Delete shift?"
  },
  "numbering": {
    "title": "Numbering",
    "subtitle": "Set the format and start number per type",
    "counterHeader": "Counter",
    "currentNumber": "Current number",
    "startNumber": "Start number",
    "format": "Format",
    "notStarted": "Not started yet",
    "empty": "No counters",
    "editConfig": "Edit format",
    "adjustNumber": "Adjust current number",
    "adjustWarning": "A higher number skips ahead; you cannot go lower than the current value.",
    "placeholderHelp": "Available codes:",
    "counterRequired": "The format must include the counter:",
    "counter": {
      "creditor": "Creditor number",
      "debtor": "Debtor number",
      "shipment": "Shipment number",
      "calculation": "Calculation number",
      "quote": "Quote",
      "salesOrder": "Sales order",
      "collo": "Package number (ID)",
      "stockOrder": "Stock order",
      "purchaseOrder": "Purchase order"
    }
  },
  "sales": {
    "quote": {
      "title": "Quote",
      "newTitle": "New quote",
      "entityPlural": "Quotes",
      "draftLabel": "Draft",
      "status": {
        "draft": "Draft",
        "sent": "Final",
        "converted": "Converted"
      },
      "sentToast": "Final:",
      "sendConfirmTitle": "Finalise quote?",
      "sendConfirmBody": "The quote is marked final and the PDF is archived. The quote stays editable, but the number and the final PDF are locked.",
      "finalize": "Finalise",
      "finalizing": "Finalising…",
      "email": "Send",
      "emailDateDialog": {
        "title": "Adjust issue date?",
        "body": "The issue date is not today. Do you want to set it to today before sending the quote?",
        "keep": "Keep date",
        "adjust": "Set to today"
      },
      "incomplete": {
        "title": "Quote is not complete yet",
        "body": "Please resolve the points below before sending the quote.",
        "noLines": "The quote has no lines yet.",
        "missingProduct": "Line {lineNumber}: no product selected",
        "missingCalculation": "Line {lineNumber}: no calculation selected",
        "missingQuotePrice": "Line {lineNumber}: no quote price for {quantities}",
        "missingQuotePriceAll": "Line {lineNumber}: the calculation has no quote prices yet",
        "missingDescription": "Line {lineNumber}: description is missing",
        "taxMissing": "Line {lineNumber} has no VAT rate. Check the rate on the article or the VAT settings."
      },
      "convertToOrder": "Convert to order",
      "convertedToast": "Sales order created:",
      "convert": {
        "title": "Convert quote to order",
        "body": "Pick the lines being ordered and the quantity per line. The quantity determines the price tier and therefore the price.",
        "noLines": "This quote has no saved lines yet.",
        "unnamedArticle": "Unnamed article",
        "manualNotConvertible": "A free-text line has no article and cannot go on an order.",
        "willBecomeArticle": "Becomes article: {name}",
        "promote": "Promote",
        "promoteFirst": "First promote {count} calculation line(s) to an article.",
        "create": "Create order"
      },
      "previewPdf": "Preview",
      "previewingPdf": "Generating preview…"
    },
    "order": {
      "entity": "Sales order",
      "entityPlural": "Sales orders",
      "type": {
        "normal": "Order",
        "contract": "Contract order",
        "stock": "Stock order"
      },
      "status": {
        "draft": "Draft",
        "pending_approval": "Awaiting approval",
        "confirmed": "Running",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "route": {
        "production": "Production",
        "purchase": "Purchasing",
        "stock": "Stock",
        "dropship": "Dropshipping",
        "internal": "Internal"
      },
      "confirm": "Start",
      "cancel": "Cancel order",
      "refreshSnapshot": "Refresh from master data",
      "changedAfterConfirm": "This order changed after it was started — a new order confirmation must be sent.",
      "toolingMissing": "New article: die-cut or printing plate has not been recorded yet.",
      "lines": {
        "title": "Lines",
        "add": "Add line",
        "addDialog": {
          "search": "Search by name or article number",
          "searchHint": "Type at least 2 characters to search.",
          "noResults": "No articles found",
          "pickProductFirst": "Pick an article first."
        },
        "quantity": "Ordered quantity",
        "unitPrice": "Price",
        "tierHint": "Tier from {minQty}",
        "noTier": "No price tier for this quantity",
        "manualPrice": "Manual price",
        "margin": "Margin",
        "route": "Route",
        "empty": "No lines yet",
        "product": "Product",
        "discount": "Discount %",
        "requestedDelivery": "Requested delivery date",
        "subtotal": "Subtotal",
        "orderDiscount": "Order discount",
        "total": "Total",
        "costIncomplete": "Margin incomplete — not every line has a cost price",
        "cancelled": "Cancelled",
        "quantityConfirmed": "Confirmed quantity",
        "confirmedDelivery": "Confirmed delivery date",
        "removeDialog": {
          "title": "Delete line?",
          "body": "This order line is permanently deleted. That is possible as long as nothing has been produced, loaded or invoiced for it."
        },
        "invoiced": "Invoiced",
        "cancel": "Cancel line",
        "cancelDialog": {
          "title": "Cancel line?",
          "body": "The line stays on the order as a record of fact, but no longer counts towards the amounts and drops out of planning."
        },
        "fsc": "FSC",
        "fscClaim": "FSC claim",
        "fscClaimPlaceholder": "Company claim (default)"
      },
      "lineList": {
        "title": "Order lines",
        "number": "Line number",
        "confirmed": "Confirmed quantity",
        "allRoutes": "All routes",
        "empty": "No order lines yet",
        "status": "Status"
      },
      "list": {
        "number": "Number",
        "customer": "Customer",
        "orderDate": "Order date",
        "deliveryDate": "Delivery date",
        "status": "Status",
        "type": "Type",
        "lineCount": "Lines",
        "empty": "No sales orders yet",
        "typeFilter": {
          "sales": "Sales orders",
          "all": "All types"
        }
      },
      "newTitle": "New sales order",
      "field": {
        "orderType": "Order type",
        "onBehalfOf": "On behalf of",
        "neutralDelivery": "Neutral delivery",
        "orderDate": "Order date",
        "requestedDeliveryDate": "Requested delivery date",
        "confirmedDeliveryDate": "Confirmed delivery date",
        "orderDiscount": "Order discount %",
        "terms": "Terms",
        "customerReference": "Customer order reference"
      },
      "confirmDialog": {
        "title": "Start order?",
        "body": "Every line gets the promised delivery date. If the order amount is above an approval step, the order goes for approval first."
      },
      "cancelDialog": {
        "title": "Cancel order?",
        "body": "The order is kept with status Cancelled, so it remains part of the record of facts."
      },
      "refreshDialog": {
        "title": "Refresh from master data?",
        "body": "All lines that have not been invoiced take over price, cost price, route and article data again from the calculation and the product. Manually entered prices and VAT are overwritten."
      },
      "deleteDialog": {
        "title": "Delete sales order?",
        "body": "This permanently deletes the draft order and its lines. Cancel a running order instead."
      },
      "toast": {
        "saved": "Sales order saved",
        "deleted": "Sales order deleted",
        "confirmed": "The order is running",
        "cancelled": "Order cancelled",
        "refreshed": "{count, plural, one {# line refreshed from master data} other {# lines refreshed from master data}}",
        "lineCancelled": "Order line cancelled",
        "pricesKept": "No price tier for this quantity — price unchanged (line {lines})"
      },
      "incomplete": {
        "title": "Order is not complete yet",
        "bodyConfirm": "Please resolve the points below before starting the order.",
        "noLines": "The order has no lines yet.",
        "missingProduct": "Line {lineNumber}: no product selected",
        "missingDescription": "Line {lineNumber}: description is missing",
        "taxMissing": "Line {lineNumber} has no VAT rate. Check the rate on the article or the VAT settings.",
        "deliveryDateMissing": "Line {lineNumber}: no delivery date",
        "priceMissing": "Line {lineNumber} has no tier price for this quantity. Enter a price yourself or adjust the quantity.",
        "quantityMissing": "Line {lineNumber}: no confirmed quantity",
        "quantityNotWhole": "Line {lineNumber}: the confirmed quantity must be a whole number"
      },
      "email": "Send",
      "previewPdf": "Preview",
      "previewingPdf": "Generating preview…",
      "invoiceRelease": {
        "action": "Release for invoicing",
        "withdraw": "Withdraw release",
        "done": "{count} line(s) released",
        "partial": "{released} released, {skipped} skipped"
      },
      "invoiceBundle": {
        "action": "Create invoices",
        "done": "{count} draft(s) created",
        "partial": "{documents} draft(s) created, {skipped} line(s) skipped"
      },
      "documentsLocked": "All lines are invoiced. No new documents can be created; sent documents are under Sent orders."
    },
    "field": {
      "customer": "Customer",
      "shipTo": "Delivery address",
      "shipToOwnCompany": "Own company (ex works)",
      "currency": "Currency",
      "issueDate": "Issue date",
      "offerValidity": "Validity",
      "priceExclusion": "Prices excluding",
      "deliveryTime": "Delivery time",
      "paymentTerm": "Payment term",
      "extraText": "Extra text",
      "notes": "Notes",
      "salesRep": "Salesperson",
      "contact1": "Contact",
      "contact2": "Contact 2"
    },
    "line": {
      "type": {
        "manual": "Free line",
        "product": "Product",
        "calculation": "Calculation"
      },
      "column": {
        "type": "Type",
        "product": "Product",
        "description": "Description",
        "discount": "Discount %",
        "tax": "VAT",
        "customerReference": "Customer quote reference"
      },
      "staffel": {
        "qty": "Quantity",
        "price": "Price",
        "quotePrice": "Quote price"
      },
      "pickProduct": "Select product",
      "pickCalc": "Select calculation",
      "noStaffels": "No tiers",
      "addLine": "Add line",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "taxDerived": "Follows from the delivery"
    },
    "lines": {
      "title": "Lines"
    },
    "list": {
      "number": "Number",
      "customer": "Name",
      "issueDate": "Issue date",
      "status": "Status",
      "empty": "No quotes yet.",
      "deleteDialog": {
        "title": "Delete quote?",
        "body": "This permanently deletes the quote and its lines."
      }
    },
    "toast": {
      "saved": "Quote saved",
      "deleted": "Quote deleted"
    },
    "section": {
      "general": "Details",
      "notes": "Notes",
      "sentPdfs": "Sent Quotes",
      "sentOrders": "Sent orders"
    },
    "tax": {
      "groupRow": "{percent}% on {base}",
      "total": "VAT",
      "totalInclusive": "Total incl. VAT"
    },
    "orderLine": {
      "new": "New order line",
      "create": "Create line",
      "created": "Line created",
      "notFound": "This order line does not exist (anymore).",
      "missingOrder": "An order line belongs to an order — open it from an order.",
      "order": "Order",
      "description": "Description",
      "deleted": "Line deleted",
      "section": {
        "line": "Line",
        "spec": "Specification",
        "production": "Production",
        "delivery": "Delivery",
        "invoicing": "Invoicing",
        "blocks": "Blocks"
      },
      "product": {
        "locked": "The article is fixed once the line is saved."
      },
      "spec": {
        "empty": "No frozen production route on this line."
      },
      "production": {
        "empty": "This line has no production order."
      },
      "delivery": {
        "empty": "This line has no shipment.",
        "colli": "Cases",
        "plannedDelivery": "Planned delivery"
      },
      "invoicing": {
        "empty": "Not invoiced yet.",
        "document": "Document",
        "quantity": "Quantity",
        "status": "Status"
      },
      "blocks": {
        "empty": "No blocks.",
        "open": "Open block",
        "kind": "Kind",
        "reason": "Reason",
        "opened": "Opened",
        "closed": "Lifted",
        "verdict": "Verdict",
        "released": "Released",
        "rejected": "Rejected",
        "close": "Lift",
        "closeTitle": "Lift block?",
        "closeBody": "The line may proceed again, unless another block holds it.",
        "verdictRequired": "This kind ends in a verdict.",
        "gates": {
          "production": "production",
          "loading": "loading",
          "invoicing": "invoicing",
          "holds": "Holds: {gates}"
        },
        "automatic": "Automatic",
        "disappearsWhenBooked": "Disappears once the tooling is booked in"
      },
      "planning": {
        "column": "Planning",
        "all": "All plannings",
        "lateFilter": "Late",
        "unknown": "Planning unknown",
        "adopt": "Feasible {date} — adopt",
        "adoptTitle": "Adopt feasible date",
        "adoptBody": "The confirmed delivery date becomes {date}. If the order confirmation was already sent, send a new one.",
        "adoptAction": "Adopt",
        "adopted": "Delivery date adopted",
        "provisional": "The planning is being updated"
      },
      "feasible": {
        "label": "Feasible: {date}",
        "adopt": "Adopt",
        "provisional": "provisional",
        "noCalendar": "Feasible date unknown: no work calendar has been set up.",
        "unknown": "Feasible date unknown: production cannot be scheduled or the lead time is unknown."
      }
    },
    "stockOrder": {
      "create": "Create stock order",
      "product": "Item",
      "customer": "For",
      "quantity": "Quantity",
      "date": "In stock on",
      "created": "Stock order {number} created",
      "headerReadonly": "A stock order has no header to edit: customer and delivery follow the item. Work with the line.",
      "quantityInvalid": "Whole numbers only, without a point or comma.",
      "availableFrom": "In stock from {date}"
    },
    "home": {
      "intro": "Quotes, sales orders and purchasing carton.",
      "cards": {
        "quotes": "Create and send quotes and turn them into orders",
        "salesOrders": "Your customers’ orders",
        "orderLines": "Every order line, with its production, stock and shipment",
        "purchaseOrders": "Purchase orders with your suppliers",
        "cartonToOrder": "Carton the production orders need that still has to be ordered",
        "coproduction": "Production orders a creditor does an operation on that still have to be ordered",
        "cartonDeliveries": "Announced loads from carton suppliers"
      }
    }
  },
  "production": {
    "orders": {
      "title": "Production orders",
      "entity": "Production order",
      "number": "Production order number",
      "orderLine": "Order line",
      "product": "Product",
      "plannedQuantity": "Planned quantity",
      "qtyPerCollo": "Quantity per collo",
      "materialDueDate": "Material needed by",
      "actualQuantity": "Actual quantity",
      "status": "Status",
      "completedAt": "Completed at",
      "approve": "Approve",
      "approvedAt": "Approved at",
      "approved": "Approved",
      "notApprovable": "This production order has been completed or cancelled and can no longer be approved.",
      "location": "Location",
      "notes": "Notes",
      "complete": "Report complete",
      "completeConfirm": "Are you sure? This yields the pallets and cannot be undone.",
      "statusPlanned": "Planned",
      "statusInProgress": "In progress",
      "statusCompleted": "Completed",
      "statusCancelled": "Cancelled",
      "notFound": "No production order with this number.",
      "emptyState": "No production orders yet.",
      "deleteDialog": {
        "title": "Delete production order?",
        "body": "This permanently deletes the production order. A completed order stays."
      },
      "section": {
        "general": "Details",
        "routeCardboard": "Route & board"
      },
      "printSlip": "Production slip",
      "printingSlip": "Generating slip…",
      "palletCards": "Pallet cards",
      "routeCardboard": {
        "route": "Route",
        "plano": "Sheet size",
        "cardboard": "Board",
        "sheetScores": "Scores",
        "diecutPlate": "Die-cut plate",
        "sheet": "Sheet",
        "planoSource": "Blank",
        "stockSheet": "Stock sheet",
        "pieces": "pcs",
        "up": "up",
        "empty": "No route known — this order did not come from a calculation or predates 2026-09-24."
      },
      "supplyStep": "Material status"
    },
    "machineRuns": {
      "title": "Machine runs",
      "empty": "No machine runs yet.",
      "product": "Product",
      "seq": "Sequence",
      "status": "Status",
      "open": "Open",
      "closedAt": "Closed at",
      "machine": "Machine",
      "plannedDate": "Production day",
      "quantityPlanned": "Planned",
      "quantityActual": "Actual",
      "timeForecast": "Time forecast",
      "timePlanned": "Time planned",
      "timeNormAtActual": "Norm at actual",
      "timeActual": "Time actual",
      "delta": "Deviation",
      "scrap": "Scrap",
      "scrapSupplier": "Supplier",
      "scrapMachine": "Machine",
      "scrapInternal": "Internal",
      "close": "Close",
      "closed": "Closed",
      "closeConfirm": "Record the actual quantity, times and scrap for this run. This cannot be undone.",
      "actualQuantity": "Actual quantity",
      "actualSheets": "Sheets",
      "actualQuantityFromSheets": "Actual quantity (from sheets)",
      "inSheets": "{label} (sheets)",
      "machineCost": "Machine cost",
      "startedAt": "Started",
      "stoppedAt": "Stopped",
      "pauseMinutes": "Break (minutes)",
      "minutesValue": "{minutes} min",
      "hoursValue": "{hours} h",
      "plannedTotal": "Total planned time",
      "section": {
        "general": "General",
        "actual": "Actual",
        "stops": "Stops",
        "operators": "Operators"
      },
      "notFound": "Machine run not found.",
      "forecastQuantity": "Forecast quantity",
      "plannedQuantity": "Planned quantity",
      "plannedSetupMinutes": "Planned setup (minutes)",
      "plannedRunMinutes": "Planned run time (minutes)",
      "plannedCleanupMinutes": "Planned cleanup (minutes)",
      "plannedDownMinutes": "Planned downtime (minutes)",
      "notes": "Notes",
      "setupMinutes": "Setup (minutes)",
      "printSetupMinutes": "Print setup (minutes)",
      "diecutSetupMinutes": "Die-cut setup (minutes)",
      "runMinutes": "Run time (minutes)",
      "handworkMinutes": "Handwork (minutes)",
      "cleanupMinutes": "Cleanup (minutes)",
      "stopReason": "Reason",
      "stopMinutes": "Minutes",
      "stopNotes": "Note",
      "operator": "Operator",
      "sharePercent": "Share (%)",
      "earlierRunOpen": "An earlier run of this order is still open.",
      "orderNotOpen": "The production order of this run has been cancelled or completed; the run can no longer be edited or closed.",
      "invalidIntegers": "Enter a whole number of 0 or more: {fields}",
      "result": "Result",
      "time": "Time",
      "quantity": "Quantity",
      "scrapTotal": "Total",
      "followUpQuestion": "Is there a follow-up?",
      "followUpYes": "Yes, follow-up",
      "followUpNo": "No, run done",
      "parts": "Parts",
      "partNo": "Part",
      "approvedBy": "Approved by",
      "partClosed": "Part {partNo} closed"
    },
    "supplyStep": {
      "0": "New",
      "1": "Ready to order",
      "2": "Carton ordered",
      "3": "Carton confirmed",
      "4": "Carton announced",
      "5": "Carton delivered",
      "6": "All in"
    },
    "home": {
      "intro": "Production orders, machine runs, planning and maintenance.",
      "cards": {
        "productionOrders": "What needs to be produced, per order line",
        "machineRuns": "What the operator records per machine: times, quantities and waste",
        "machineCalendar": "Opening hours and exceptions per machine",
        "machinePlanning": "The production orders scheduled on the machines",
        "maintenance": "Plan and complete machine maintenance"
      }
    }
  },
  "purchasing": {
    "order": {
      "title": "Purchase orders",
      "entity": "Purchase order",
      "newTitle": "New purchase order",
      "emptyState": "No purchase orders yet.",
      "notFound": "No purchase order with this number.",
      "lineIncomplete": "Line {lineNumber}: pick a product or enter a description, and a quantity greater than zero.",
      "section": {
        "general": "Details",
        "notes": "Notes"
      },
      "status": {
        "draft": "Draft",
        "pending_approval": "Awaiting approval",
        "confirmed": "Running",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "field": {
        "number": "Number",
        "supplier": "Supplier",
        "deliverTo": "Delivery address",
        "deliverToOwnCompany": "Own company",
        "buyer": "Buyer",
        "currency": "Currency",
        "orderDate": "Order date",
        "requestedDeliveryDate": "Requested delivery date",
        "confirmedDeliveryDate": "Confirmed delivery date",
        "paymentTerm": "Payment term",
        "deliveryCondition": "Delivery terms",
        "neutralDelivery": "Neutral delivery",
        "neutralDeliveryHint": "Our name does not appear on the shipment.",
        "extraText": "Additional text",
        "terms": "Terms",
        "notes": "Notes"
      },
      "lines": {
        "title": "Lines",
        "add": "Add line",
        "empty": "No lines yet",
        "product": "Product",
        "description": "Description",
        "quantity": "Ordered quantity",
        "quantityConfirmed": "Confirmed quantity",
        "unitPrice": "Price",
        "tierHint": "Tier from {minQty}",
        "noTier": "No price tier for this quantity",
        "manualPrice": "Manual price",
        "discount": "Discount %",
        "requestedDelivery": "Requested delivery date",
        "confirmedDelivery": "Confirmed delivery date",
        "amount": "Line amount",
        "subtotal": "Subtotal",
        "orderDiscount": "Order discount",
        "total": "Total",
        "removeDialog": {
          "title": "Delete line?",
          "body": "This purchase order line is permanently deleted."
        },
        "supplierArticleNumber": "Supplier article no.",
        "unitOfMeasure": "Unit",
        "addDialog": {
          "title": "Add line",
          "body": "Find the article and pick the tier you are ordering at. The price follows on save, from the tier that matches the quantity.",
          "search": "Search by article number or description",
          "searchHint": "Type at least two characters to search.",
          "noResults": "No articles found.",
          "pickProductFirst": "Pick an article first.",
          "notACreditor": "This supplier is not a creditor on this article; the tiers show the total purchase price."
        },
        "supplierReference": "Supplier order reference"
      },
      "deleteDialog": {
        "title": "Delete purchase order?",
        "body": "This permanently deletes the purchase order and its lines."
      },
      "receive": {
        "action": "Receive",
        "title": "Record receipt",
        "description": "Enter the TOTAL received per line. Stock is updated with the difference.",
        "location": "Receiving location",
        "lines": "Lines",
        "all": "Receive all",
        "ordered": "Ordered",
        "confirm": "Book"
      },
      "action": {
        "confirm": "Start",
        "previewPdf": "View PDF",
        "send": "Send",
        "cancel": "Cancel purchase order",
        "previewingPdf": "Rendering preview…",
        "markOrdered": "Mark as ordered"
      },
      "confirmed": "The purchase order is running",
      "cancelDialog": {
        "title": "Cancel purchase order?",
        "body": "The purchase order is kept with status Cancelled, so it remains part of the record of facts. Anything already received stays booked."
      },
      "cancelled": "Purchase order cancelled",
      "incomplete": {
        "title": "This purchase order is not complete yet",
        "body": "Every line needs an article, a quantity, a price, a VAT rate and a requested delivery date before the order can go out.",
        "noLines": "This purchase order has no lines.",
        "product": "Line {lineNumber}: no article selected",
        "quantity": "Line {lineNumber}: no quantity",
        "price": "Line {lineNumber}: no price",
        "tax": "Line {lineNumber}: no VAT rate",
        "deliveryDate": "Line {lineNumber}: no requested delivery date"
      },
      "markedOrdered": "Marked as ordered",
      "datePending": "Still to pass on"
    },
    "cartonDemand": {
      "title": "Carton to order",
      "createOrders": "Create purchase order",
      "created": "{count} purchase order(s) created",
      "emptyState": "There is no carton to order.",
      "blocker": {
        "no_supplier": "No supplier",
        "refresh_snapshot": "Refresh the order line",
        "draft_order": "In draft purchase order"
      },
      "field": {
        "productionOrder": "Production order",
        "supplier": "Supplier",
        "quality": "Quality",
        "format": "Format",
        "pieces": "Pieces",
        "materialDueDate": "Required"
      }
    },
    "coproduction": {
      "title": "Coproduction",
      "createOrders": "Create purchase order",
      "created": "{count, plural, one {# purchase order created} other {# purchase orders created}}",
      "emptyState": "There is no coproduction to order.",
      "noSupplier": "Choose a supplier for every row.",
      "dropship": "Delivers to the customer",
      "field": {
        "productionOrder": "Production order",
        "product": "Product",
        "quantity": "Quantity",
        "dueDate": "Delivery date",
        "supplier": "Supplier"
      },
      "handoverDate": "Hand over on",
      "productionOrder": "Production order",
      "link": "Link",
      "unlink": "Unlink",
      "linkTitle": "Link to a production order",
      "linkHint": "Production orders with coproduction for this product that have no creditor line yet.",
      "linkEmpty": "No production order to link to.",
      "linked": "Linked",
      "unlinked": "Unlinked",
      "summary": {
        "title": "Creditor",
        "supplier": "Supplier",
        "purchaseOrder": "Purchase order",
        "date": "Creditor date",
        "delivered": "Delivered"
      }
    },
    "cartonLine": {
      "title": "Carton",
      "confirm": "Record confirmation",
      "confirmDescription": "What the supplier commits to. If it differs from the order, the line stays at ordered until you accept the deviation.",
      "confirmIncomplete": "Enter quantity, delivery date and price",
      "confirmedQuantity": "Confirmed quantity",
      "confirmedDate": "Confirmed delivery date",
      "confirmedPrice": "Confirmed price",
      "priceUnit": "Per",
      "per1000": "1000 m²",
      "per100": "100 m²",
      "supplierReference": "Supplier line number",
      "qualityOk": "Quality as ordered",
      "deviations": "Deviations",
      "deviation": {
        "date_earlier": "Earlier",
        "date_later": "Later",
        "quantity_more": "More",
        "quantity_less": "Less",
        "quality": "Quality",
        "price": "Price"
      },
      "acceptDeviation": "Accept deviation",
      "completeDelivery": "Delivery complete",
      "completeDeliveryConfirm": "The line will be closed, even if less has arrived than confirmed.",
      "cancel": "Cancel carton line",
      "cancelConfirm": "The carton line will be cancelled and the production order returns to Carton to order. Cancel the order with the supplier as well.",
      "productionOrderCancelled": "Production order cancelled",
      "completed": "Complete",
      "format": "Format",
      "scores": "Scoring",
      "ordered": "Ordered",
      "confirmedShort": "Confirmed",
      "received": "Received",
      "remark": "Remark",
      "proceed": "Continue",
      "datePending": "New date {date}, still to pass on",
      "passedOn": "Passed on",
      "priceList": "Price list {number}"
    },
    "inboundDelivery": {
      "title": "Carton deliveries",
      "entity": "Carton delivery",
      "deleteDialog": {
        "title": "Delete carton delivery?",
        "body": "This permanently deletes the carton delivery and its announced pallets. The material status of the production orders waiting for it is recalculated."
      },
      "newTitle": "New carton delivery",
      "notFound": "Carton delivery not found",
      "emptyState": "No carton deliveries have been announced yet.",
      "saved": "Carton delivery saved",
      "noLines": "Add at least one line with a production order number",
      "noPallets": "No pallets announced",
      "pieces": "pcs",
      "pallets": "Pallets",
      "received": "Received",
      "open": "Open",
      "addLine": "Add line",
      "addPallet": "Add pallet",
      "section": {
        "general": "Delivery note",
        "lines": "Lines"
      },
      "field": {
        "supplier": "Supplier",
        "deliveryNoteNumber": "Delivery note number",
        "loadedAt": "Loaded on",
        "expectedDate": "Expected on",
        "timeSlot": "Time slot",
        "carrierName": "Carrier",
        "vehiclePlate": "Licence plate",
        "tripReference": "Trip",
        "notes": "Notes",
        "ourReference": "Production order (our reference)",
        "announcedQuantity": "Announced quantity",
        "palletRef": "Supplier pallet number",
        "barcode": "Barcode"
      }
    }
  },
  "delete": {
    "blocked": {
      "produced": "{count} produced",
      "loaded": "{count} loaded",
      "received": "{count} received",
      "invoiced": "{count} invoiced",
      "cartonOrdered": "{count, plural, one {# carton order} other {# carton orders}}",
      "creditorOrdered": "{count, plural, one {# creditor order} other {# creditor orders}}",
      "stock": "{count, plural, one {# stock record} other {# stock records}}",
      "salesOrder": "{count, plural, one {# sales order line} other {# sales order lines}}",
      "productionOrder": "{count, plural, one {# production order} other {# production orders}}",
      "purchaseOrder": "{count, plural, one {# purchase order line} other {# purchase order lines}}",
      "tooling": "{count, plural, one {# article uses this as tooling or ink} other {# articles use this as tooling or ink}}"
    }
  },
  "attachments": {
    "frozen": {
      "product": "Item",
      "print": "Printing plate {number}",
      "diecut": "Die {number}",
      "noOrderLine": "No order line",
      "notRecorded": "Not recorded",
      "none": "No drawings recorded"
    },
    "revision": "rev. {revision}",
    "newRevision": "New revision",
    "olderRevisions": "Older revisions ({count})",
    "deleteRevision": "Delete revision {revision}",
    "deleteDrawing": "Delete whole drawing",
    "deleteRevisionConfirm": "Do you want to delete only revision {revision} (a wrong upload), or the whole drawing with all its revisions?",
    "csv": {
      "truncated": "The first {shown} of {total} rows.",
      "unreadable": "The file could not be read."
    },
    "dropHere": "Drop a file here",
    "oneAtATime": "One file at a time",
    "tooLarge": "File is larger than 100 MB",
    "uploadFailed": "Upload failed",
    "uploaded": "{fileName} uploaded",
    "choosePlaceholder": "Drag or choose a file to upload…",
    "saveFirst": "Save this record first; then you can add files.",
    "deleteConfirm": "Delete this file? This action cannot be undone.",
    "noFiles": "No files yet.",
    "mail": {
      "from": "From",
      "to": "To",
      "cc": "Cc",
      "date": "Date",
      "attachments": "Attachments",
      "noSubject": "(no subject)",
      "noBody": "This e-mail has no text.",
      "imagesBlocked": "Images from the internet are blocked.",
      "showImages": "Show images"
    }
  },
  "logistics": {
    "deliveryMethods": "Delivery methods",
    "deliveryMethod": {
      "entity": "Delivery method",
      "new": "New delivery method",
      "create": "Create",
      "created": "Delivery method created",
      "listEmpty": "No delivery methods yet",
      "kind": "Kind",
      "label": "Name",
      "target": "Who",
      "sortOrder": "Order",
      "active": "Active",
      "account": "Carrier (creditor)",
      "employee": "Employee",
      "selectEmployee": "Pick an employee…",
      "none": "No deliverer",
      "labelHint": "The name of the METHOD, not of the party — so \"Veenstra\" and \"Veenstra - TMS\" can sit side by side.",
      "carrierNeedsAccount": "Pick a carrier for the kind \"Carrier\".",
      "employeeNeedsEmployee": "Pick an employee for the kind \"Employee\".",
      "kinds": {
        "carrier": "Carrier",
        "own_fleet": "Own fleet",
        "employee": "Employee"
      }
    },
    "houseDeliveryMethod": "House deliverer",
    "houseDeliveryMethodHint": "Copied onto a new shipment when we deliver (DAP) and it is not dropshipping.",
    "transportZone": {
      "title": "Transport zones",
      "new": "New transport zone",
      "loading": "Loading…",
      "listEmpty": "No transport zones found.",
      "notFound": "Transport zone not found.",
      "saved": "Transport zone saved",
      "delete": "Delete",
      "deleted": "Transport zone deleted",
      "deleteTitle": "Delete transport zone?",
      "deleteConfirm": "This permanently removes the transport zone and all of its freight rates. Zones used by calculations cannot be deleted. This action cannot be undone.",
      "validationRequired": "Carrier, country, zone and at least one postal code are required.",
      "sections": {
        "carrier": "Carrier"
      },
      "fields": {
        "countryCode": "Country code",
        "zone": "Zone",
        "postalCodes": "Postal codes",
        "recordName": "Record name",
        "additionTransport": "Transport surcharge (%)"
      },
      "placeholders": {
        "countryCode": "Search country code…",
        "postalCodes": "1000-1099, 2000, 3500…"
      },
      "hints": {
        "postalCodes": "Comma-separated",
        "additionTransport": "The surcharge this zone's working prices were last calculated with: when the freight rates were saved, or with \"Apply transport surcharge\" under Settings → Logistics → Settings."
      },
      "rates": {
        "title": "Freight rates",
        "subtitle": "Rate per loading metre for this zone. Cloud ERP calculates the working price when you save: the cost plus the transport surcharge from the settings.",
        "empty": "No freight rates for this zone.",
        "incomplete": "Enter the loading metres and the cost on every freight rate.",
        "loadingMeter": "Loading metres",
        "cost": "Cost",
        "workingPrice": "Working price",
        "pallet120x80": "Pallets 120×80",
        "pallet120x100": "Pallets 120×100"
      }
    },
    "shipments": {
      "title": "Shipping",
      "number": "Shipment",
      "plannedDeliveryDate": "Planned delivery date",
      "plannedQuantity": "Planned qty",
      "loadedQuantity": "Loaded qty",
      "colloCount": "Packages",
      "derivedStatus": "Status",
      "isRush": "Rush",
      "productName": "Product",
      "orderNumber": "Order",
      "customerName": "Customer",
      "shipToName": "Ship-to",
      "palletCards": "Pallet cards",
      "palletCard": "Pallet card",
      "paper": "Paper",
      "markLoaded": "Mark loaded",
      "collo": "Collo",
      "confirmedDeliveryDate": "Confirmed delivery date",
      "plannedLoadingDate": "Planned loading date",
      "actualDeliveryDate": "Actual delivery date",
      "loadedAt": "Loaded at",
      "colloNumber": "Collo ID",
      "entity": "Shipment",
      "new": "New shipment",
      "create": "Create",
      "created": "Shipment created",
      "orderLine": "Order line",
      "selectOrderLine": "Search an order, customer or product…",
      "alreadyExists": "This order line already has an active shipment.",
      "noConfirmedQuantity": "This order line has no confirmed quantity yet, so there is nothing to ship.",
      "noCollos": "No collos yet",
      "deliveryMethod": "Deliverer",
      "packingSlip": "Packing slip"
    },
    "packingSlips": {
      "title": "Packing slips",
      "entity": "Packing slip",
      "column": {
        "account": "Account",
        "deliveryDate": "Delivery day",
        "deliveryMethod": "Deliverer",
        "shipToName": "Delivery address",
        "shipments": "Shipments",
        "colli": "Colli",
        "state": "Status",
        "sentAt": "Sent"
      },
      "state": {
        "open": "Open",
        "closed": "Closed"
      },
      "notSent": "Not sent yet",
      "bundle": "Bundle into packing slip",
      "bundled": "Shipments bundled onto a packing slip",
      "deliveryDateFilter": "Delivery date",
      "error": {
        "unknown": "Bundling failed",
        "showFailed": "Showing the packing slip failed",
        "removeFailed": "Removing from the packing slip failed"
      },
      "show": "Show packing slip",
      "showService": "Show reseller packing slip",
      "unbundle": "Remove from packing slip",
      "removed": "Shipments removed from the packing slip",
      "recipients": "Recipients",
      "noRecipients": "No recipients found",
      "shipmentsOnSlip": "Shipments on this slip",
      "documentsLocked": "All lines on this packing slip are invoiced. No new packing slips can be created; sent ones are listed below."
    },
    "collo": {
      "actualQuantity": "Actual quantity",
      "palletSize": "Pallet size",
      "noPalletSize": "No pallet size",
      "netWeight": "Net weight (kg)",
      "loadingMetres": "Loading metres",
      "lengthMm": "Length (mm)",
      "widthMm": "Width (mm)",
      "heightMm": "Height (mm)",
      "stackable": "Stackable",
      "writeOff": "Write off",
      "writeOffReason": "Reason",
      "split": "Split",
      "splitHint": "The part taken off becomes a new collo with its own number and pallet card. This pallet keeps its number and its quantity goes down.",
      "splitAction": "Split",
      "splitDone": "New collo {number} created.",
      "undoLoaded": "Undo loading",
      "unloaded": "Loading undone.",
      "progressStep": "Status"
    },
    "callOff": {
      "title": "Stock call-off",
      "reserve": "Reserve",
      "release": "Release",
      "refresh": "Propose again",
      "partial": "Partial",
      "empty": "No free colli for this article.",
      "summary": {
        "empty": "No free colli for this article — only production helps here.",
        "short": "{colli} colli, {missing} units short.",
        "exact": "{colli} colli, exactly the quantity requested.",
        "surplus": "{colli} colli, {surplus} units more than requested."
      },
      "skippedPartial": "Partial collo {number} stays behind and keeps a pallet space occupied.",
      "notColloStock": "This article is picked per unit; a collo call-off does not apply here.",
      "noProduct": "This shipment belongs to an order line without an article.",
      "alreadyReserved": "Collo {number} has since been reserved for another shipment.",
      "unavailable": "Collo {number} is no longer available."
    },
    "scan": {
      "title": "Scan pallets",
      "placeholder": "Scan or type a collo number",
      "loaded": "Loaded",
      "undo": "Undo",
      "notFound": "No collo with this number",
      "alreadyLoaded": "Already loaded",
      "writtenOff": "Written off",
      "colloOf": "collo {n} of {total}"
    },
    "settings": {
      "title": "Logistics",
      "subtitle": "Freight and delivery preferences",
      "saved": "Settings updated.",
      "loading": "Loading…",
      "applyTransport": "Apply transport surcharge",
      "applyTransportConfirm": "Recalculate all transport zones and rates with the saved transport surcharge of {percentage}%? Working prices will be overwritten.",
      "applyTransportDirty": "Save your changes first — applying uses the saved surcharge.",
      "transportApplied": "{percentage}% applied to {zones} zones / {rates} rates.",
      "fields": {
        "transportSurchargePercent": "Transport surcharge %",
        "transportSurchargePercentHelp": "Markup on the purchase price of freight. Apply it to recalculate the working price of every rate.",
        "note": "Note"
      }
    },
    "inboundScan": {
      "title": "Receive carton",
      "placeholder": "Scan the pallet label",
      "received": "Received",
      "alreadyReceived": "Already received",
      "unknown": "Unknown pallet — enter production order and pieces",
      "pieces": "pcs",
      "undo": "Undo",
      "openDeliveries": "Open deliveries",
      "noOpen": "No open deliveries",
      "receiveAll": "Receive all",
      "receiveOne": "Receive",
      "supplier": "Supplier",
      "ourReference": "Production order on the label"
    },
    "home": {
      "intro": "Shipments, packing slips and scanning pallets and carton.",
      "cards": {
        "shipments": "Plan and complete shipments",
        "packingSlips": "Packing slips, bundled per customer, delivery day and delivery address",
        "scanPallets": "Scan pallets while loading",
        "receiveCarton": "Scan and receive incoming carton",
        "transportZones": "Transport zones with their rate per loading metre"
      }
    }
  },
  "ppwr": {
    "declaration": {
      "tab": "PPWR declaration",
      "hint": "This declaration is printed in English on the EU Declaration of Conformity, whatever language you work in.",
      "fields": {
        "flag": "Covered by PPWR",
        "kind": "Statement kind",
        "kindOwnProduction": "Own (co-)production",
        "kindTrade": "Trade and packaging materials",
        "kindTradeNonFood": "Packaging materials (non-food)",
        "type": "Packaging type",
        "baseMaterial": "Base material",
        "closure": "Closure",
        "ink": "Ink",
        "recyclability": "Recyclability",
        "recycledPercent": "Recycled content (%)",
        "countryOrigin": "Country of origin",
        "note": "Note"
      },
      "needsRevision": "This declaration was seeded from an older version of the calculation. Check it before the next order confirmation goes out.",
      "preview": "Preview declaration"
    },
    "settings": {
      "title": "PPWR settings",
      "subtitle": "The three static statements that get appended to a generated EU Declaration of Conformity.",
      "loading": "Loading settings…",
      "saved": "Settings saved",
      "noteField": "Note",
      "ownProduction": "Own (co-)production",
      "trade": "Trade and packaging materials",
      "tradeNonFood": "Packaging materials (non-food)",
      "uploaded": "Uploaded",
      "notUploaded": "Not uploaded yet",
      "upload": "Upload PDF",
      "replace": "Replace",
      "view": "View",
      "uploading": "Uploading…",
      "uploadFailed": "Upload failed",
      "uploadSucceeded": "Statement uploaded",
      "pdfOnly": "PDF only — the statement is appended to the generated page as-is."
    },
    "issued": {
      "title": "Issued EU declarations",
      "empty": "No declarations issued yet; they are created when the order confirmation is sent."
    },
    "warnings": {
      "declarationMissing": "{label}: fill in the PPWR declaration tab on the article, otherwise none will be included.",
      "declarationStale": "{label}: open the article, PPWR declaration tab, and update the fields against the current calculation.",
      "statementMissing": "Upload the static declaration for {kind} in the PPWR settings, otherwise the DoC will go out without the legal text."
    }
  },
  "approval": {
    "digest": {
      "subject": "Waiting for your approval ({count})",
      "intro": "<p>Hello,</p><p>These are waiting for your approval:</p>",
      "kind": {
        "purchase_order": "Purchase order",
        "ap_bill": "Purchase invoice",
        "sales_order": "Sales order"
      }
    },
    "mail": {
      "rejected": {
        "subject": "Rejected: {label}",
        "body": "<p>Hello,</p><p>{label} was rejected.</p><p>Reason: {reason}</p><p><a href=\"{link}\">Open</a></p><p>Kind regards</p>"
      },
      "completed": {
        "subject": "Approved: {label}",
        "body": "<p>Hello,</p><p>{label} was approved.</p><p><a href=\"{link}\">Open</a></p><p>Kind regards</p>",
        "body_purchase_order": "<p>Hello,</p><p>{label} was approved. You can send it now.</p><p><a href=\"{link}\">Open</a></p><p>Kind regards</p>",
        "body_sales_order": "<p>Hello,</p><p>{label} was approved and is now running.</p><p><a href=\"{link}\">Open</a></p><p>Kind regards</p>"
      }
    },
    "panel": {
      "title": "Approval",
      "notRequired": "This document does not need approval.",
      "waitingForYou": "This document is waiting for your approval.",
      "waitingFor": "This document is waiting for approval.",
      "approvedBy": "Approved by {name} on {when}",
      "rejectedBy": "Rejected by {name}",
      "rejectedReason": "reason: {reason}",
      "amount": "Amount excl. VAT: {amount}",
      "step": "Step {step}",
      "stepFrom": "from {amount}",
      "open": "Up now",
      "decided": "{name}, {when}",
      "decidedStandIn": "{name} as stand-in, {when}",
      "waitingOnAny": "Waiting for one of: {names}",
      "waitingOnAll": "Still waiting for: {names}",
      "laterAny": "Then one of: {names}",
      "laterAll": "Then all of: {names}",
      "nobody": "Nobody can approve this step right now"
    },
    "status": {
      "notRequired": "No approval needed",
      "pending": "Pending approval",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "action": {
      "submit": "Submit for approval",
      "approve": "Approve",
      "reject": "Reject",
      "withdraw": "Back to draft",
      "withdrawRequest": "Withdraw request"
    },
    "toast": {
      "submitted": "Submitted for approval",
      "notRequired": "No approval needed: you can issue the document now",
      "recorded": "Your approval has been recorded",
      "stepDone": "Step approved, the next step is up",
      "approved": "Approved",
      "rejected": "Rejected, the document is a draft again",
      "withdrawn": "Back to draft: you can edit the document again"
    },
    "rejectDialog": {
      "title": "Reject",
      "description": "The document goes back to draft. The submitter will see your reason.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Why are you rejecting this?"
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread": "Unread notifications: {n}",
    "empty": "No notifications yet",
    "markAllRead": "Mark all read",
    "kind": {
      "board_mention": "{actor} mentioned you on {board}",
      "approval_requested": "{label} is waiting for your approval",
      "approval_rejected": "{actor} rejected {label}: {reason}",
      "approval_completed": "{label} was approved",
      "approval_completed_purchase_order": "{label} was approved: you can send it now",
      "approval_completed_sales_order": "{label} was approved and is now running",
      "approval_buyer_missing": "{label} stays a draft: no buyer is filled in, or the buyer has been disabled"
    }
  },
  "twoFactor": {
    "title": "Two-factor sign-in",
    "short": "2FA",
    "status": {
      "on": "On",
      "off": "Off",
      "missing": "Required, not set up"
    },
    "reason": {
      "admin": "Administrators always use two-factor sign-in.",
      "user": "Your administrator requires two-factor sign-in for your account.",
      "role": "One of your roles requires two-factor sign-in."
    },
    "setup": {
      "titleSetup": "Set up two-factor sign-in",
      "titleReplace": "Switch to a new phone",
      "intro": "Besides your password, you'll enter a six-digit code from an app on your phone when you sign in. Setting it up takes about two minutes.",
      "replaceWarning": "As soon as you confirm your password, the app on your old phone stops working. Finish all the steps to keep signing in.",
      "signOut": "Sign out",
      "cancel": "Cancel",
      "back": "Back",
      "continue": "Continue",
      "finish": "Finish",
      "stepOf": "Step {n} of {total}",
      "steps": {
        "app": "Get the app",
        "password": "Confirm it's you",
        "scan": "Scan the code",
        "verify": "Enter a code",
        "backup": "Save backup codes"
      },
      "app": {
        "heading": "Install an authenticator app",
        "body": "If you don't have one yet, install one of these free apps on your phone:",
        "note": "Any app that shows authenticator codes works."
      },
      "password": {
        "heading": "Confirm it's you",
        "body": "Enter your password to start.",
        "label": "Password"
      },
      "scan": {
        "heading": "Scan this code with the app",
        "body": "Open the app, tap the plus sign or Add account, and point your camera at the code.",
        "manual": "Can't scan it? Type this key into the app instead:",
        "copy": "Copy key",
        "copied": "Copied"
      },
      "verify": {
        "heading": "Enter the code from the app",
        "body": "The app now shows a six-digit code for this account. Enter it to check that everything works.",
        "wrong": "That code is not right. Check that the time on your phone is correct, then try the code it shows now."
      },
      "backup": {
        "heading": "Save your backup codes",
        "body": "If you lose your phone, each of these codes lets you sign in once. Keep them somewhere safe, such as a password manager. You won't see them again.",
        "copyAll": "Copy all",
        "download": "Download",
        "copied": "Backup codes copied",
        "saved": "I have saved my backup codes"
      },
      "done": "Two-factor sign-in is on."
    },
    "signIn": {
      "trustDevice": "Trust this device for 30 days",
      "useBackup": "Use a backup code instead",
      "useApp": "Use a code from the app instead",
      "backupLabel": "Backup code",
      "backupHelp": "Each backup code works once."
    },
    "security": {
      "title": "Security",
      "subtitle": "How you sign in to your account.",
      "on": "Two-factor sign-in is on.",
      "off": "Two-factor sign-in is off.",
      "offAdvice": "Turn it on, so a stolen password alone is not enough to get into your account.",
      "turnOn": "Turn on",
      "newPhone": "Switch to a new phone",
      "newPhoneHelp": "Set up the app on another phone. The old one stops working.",
      "newCodes": "New backup codes",
      "newCodesHelp": "Makes a fresh set. Your current backup codes stop working.",
      "turnOff": "Turn off",
      "turnOffTitle": "Turn off two-factor sign-in?",
      "turnOffBody": "Your account will then be protected by your password only.",
      "passwordLabel": "Password",
      "passwordPrompt": "Enter your password to continue.",
      "turnedOff": "Two-factor sign-in is off.",
      "codesTitle": "Your new backup codes",
      "close": "Close"
    },
    "stepUp": {
      "title": "Confirm with a code",
      "body": "Enter the six-digit code from your authenticator app to continue.",
      "confirm": "Confirm",
      "cancel": "Cancel"
    },
    "admin": {
      "policy": "Two-factor sign-in",
      "policyRoles": "Follow roles",
      "policyRequired": "Always required",
      "policyExempt": "Not required",
      "adminNote": "Administrators always use two-factor sign-in.",
      "status": "Status",
      "reset": "Reset two-factor sign-in",
      "resetTitle": "Reset two-factor sign-in for {name}?",
      "resetBody": "Their authenticator app and backup codes stop working, and they are signed out everywhere. If they must use two-factor sign-in, they set it up again at their next sign-in. They get an email about it.",
      "resetDone": "Two-factor sign-in was reset.",
      "filter": "Two-factor sign-in",
      "filterAll": "All"
    },
    "role": {
      "label": "Require two-factor sign-in",
      "help": "Everyone with this role must use two-factor sign-in, unless their own setting says otherwise.",
      "adminLocked": "Always on for administrators.",
      "saved": "Saved",
      "required": "Required"
    }
  },
  "timeline": {
    "tab": "Timeline",
    "empty": "No events yet.",
    "system": "automatic",
    "changed": "Changed: {fields}",
    "changedBy": "Changed by",
    "changedBySystem": "Changed automatically",
    "viewChanges": "View changes",
    "hideChanges": "Hide changes",
    "emptyValue": "empty",
    "hiddenValue": "hidden",
    "yes": "Yes",
    "no": "No",
    "action": {
      "created": "Created",
      "confirmed": "Started",
      "cancelled": "Cancelled",
      "snapshot_refreshed": "Refreshed from master data",
      "sent": "Sent",
      "line_deleted": "Line {lineNumber} deleted",
      "block_opened": "Block {code} opened",
      "block_closed": "Block {code} lifted",
      "released_for_invoicing": "Released for invoicing",
      "release_withdrawn": "Release withdrawn",
      "invoiced": "Invoiced",
      "status": "Status {from} → {to}",
      "approved": "Approved",
      "completed": "Completed",
      "closed": "Closed",
      "part_closed": "Part {partNo} closed",
      "stops_changed": "Stops changed",
      "operators_changed": "Operators changed",
      "collo_changed": "Collo {colloNumber} changed",
      "collo_split": "Collo {colloNumber} split",
      "loaded": "{count} collo(s) loaded",
      "called_off": "Called off",
      "call_off_released": "Call-off released",
      "added_to_packing_slip": "Added to packing slip",
      "shipments_added": "Shipments added",
      "shipments_removed": "Shipments removed",
      "ordered": "Ordered",
      "carton_date_passed_on": "New board date passed on",
      "received": "Received",
      "pallet_received": "{count} pallet(s) received",
      "pallet_undone": "Receipt of {count} pallet(s) undone",
      "production_order_deleted": "Production order {number} deleted",
      "lines_changed": "Lines changed",
      "rejected": "Rejected",
      "activated": "Activated",
      "terminated": "Terminated",
      "submitted": "Submitted",
      "paid": "Paid",
      "acknowledged": "Acknowledged",
      "hired": "Hired",
      "interviews_changed": "Interviews changed",
      "offers_changed": "Offers changed",
      "attendees_changed": "Participants changed",
      "task_linked": "Task linked: {title}",
      "task_unlinked": "Task unlinked: {title}",
      "design_linked": "Design linked: {board}",
      "design_unlinked": "Design unlinked: {board}",
      "task_linked_hidden": "Task linked",
      "task_unlinked_hidden": "Task unlinked",
      "design_linked_hidden": "Design linked",
      "design_unlinked_hidden": "Design unlinked",
      "version_named": "Version saved: {name}",
      "version_restored": "Version restored: {name}",
      "version_restored_hidden": "Automatic version restored",
      "library_published": "Published to the library: {name}",
      "library_unpublished": "Removed from the library: {name}",
      "library_updates_accepted": "Library updates accepted: {names}",
      "template_marked": "Marked as template",
      "template_unmarked": "Template mark removed",
      "registration_added": "Registration {kind} {period} added",
      "registration_changed": "Registration {fromKind} {from} changed to {kind} {to}",
      "registration_deleted": "Registration {kind} {period} deleted",
      "approval_submitted": "Submitted for approval ({amount} excl. VAT)",
      "approval_submitted_hidden": "Submitted for approval",
      "approval_not_required": "Submitted, no approval needed ({amount} excl. VAT)",
      "approval_not_required_hidden": "Submitted, no approval needed",
      "approval_completed": "Approval completed: whoever had not approved yet is no longer in the step ({amount} excl. VAT)",
      "approval_completed_hidden": "Approval completed: whoever had not approved yet is no longer in the step",
      "approval_approved": "Step {step} approved ({amount} excl. VAT)",
      "approval_approved_hidden": "Step {step} approved",
      "approval_approved_stand_in": "Step {step} approved as stand-in ({amount} excl. VAT)",
      "approval_approved_stand_in_hidden": "Step {step} approved as stand-in",
      "approval_rejected": "Rejected: {reason}",
      "approval_withdrawn": "Withdrawn from approval",
      "approval_closed": "Approval lapsed, the document was cancelled",
      "issued": "Issued as {number}",
      "lines_changed_amount": "Lines changed: {amountBefore} → {amountAfter}",
      "lines_changed_amount_hidden": "Lines changed",
      "amount_changed": "Amount changed: {amountBefore} → {amountAfter}",
      "amount_changed_hidden": "Amount changed"
    },
    "field": {
      "accountId": "account",
      "accountKind": "account kind",
      "accountManagerUserId": "account manager",
      "accountTypeId": "account type",
      "activeSince": "active since",
      "activityId": "activity",
      "actualCloseDate": "actual close date",
      "actualDeliveryDate": "actual delivery date",
      "actualQuantity": "actual quantity",
      "actualSheets": "actual sheets",
      "addressJson": "address",
      "alwaysFsc": "always FSC",
      "alwaysPrintCode": "always print code",
      "alwaysPrintResy": "always print RESY",
      "pricesTwoDecimals": "prices in 2 decimals",
      "sendPriceList": "send price list on price change",
      "lastPriceListDate": "last price list sent",
      "amount": "amount",
      "apBankName": "bank (payables)",
      "apBic": "BIC (payables)",
      "apIbanEncrypted": "IBAN (payables)",
      "approvedAt": "approved at",
      "approvedByUserId": "approved by",
      "articleTaxRateId": "article VAT rate",
      "assignedToUserId": "assigned to",
      "badgeNumber": "badge number",
      "billingAddressJson": "billing address",
      "birthday": "birthday",
      "body": "body",
      "buyerUserId": "buyer",
      "calculationId": "calculation",
      "calculationTierId": "price tier",
      "calculationTierMachineId": "tier machine",
      "campaignId": "campaign",
      "cancelledAt": "cancelled at",
      "checkedInAt": "checked in at",
      "checkedOutAt": "checked out at",
      "cleanupMinutes": "clean-up time",
      "closeReasonId": "close reason",
      "closedAt": "closed at",
      "closedByUserId": "closed by",
      "colloMaxHeight": "max collo height",
      "colloStackable": "collo stackable",
      "colloTypeId": "collo type",
      "company": "company",
      "companyName": "company name",
      "competitorId": "competitor",
      "completedAt": "completed at",
      "confirmedAt": "confirmed at",
      "confirmedDeliveryDate": "confirmed delivery date",
      "contact1Email": "contact email",
      "contact1Id": "contact",
      "contact1Name": "contact name",
      "contact2Id": "second contact",
      "contactType": "contact type",
      "convertedAt": "converted at",
      "convertedToAccountId": "converted to account",
      "convertedToContactId": "converted to contact",
      "convertedToOpportunityId": "converted to opportunity",
      "creditHold": "credit hold",
      "creditLimit": "credit limit",
      "supplierCreditLimit": "credit with this supplier",
      "creditorNumber": "creditor number",
      "currency": "currency",
      "currencyExchangeRate": "exchange rate",
      "customerAccountId": "customer",
      "customerName": "customer name",
      "customerNumber": "customer number",
      "customerReference": "customer reference",
      "dealTypeId": "deal type",
      "debtorNumber": "debtor number",
      "lastArticleSeq": "last article sequence",
      "defaultPaymentTermId": "default payment term",
      "deliverToAccountId": "deliver to",
      "deliverToName": "delivery name",
      "deliveryAddress": "delivery address",
      "deliveryCondition": "delivery terms",
      "deliveryCountryCode": "delivery country",
      "deliveryDate": "delivery date",
      "deliveryHours": "delivery hours",
      "deliveryMethodId": "delivery method",
      "deliveryPostalCode": "delivery postal code",
      "deliveryRestriction1Id": "delivery restriction",
      "deliveryRestriction2Id": "second delivery restriction",
      "deliveryTxtForTransporter": "note for carrier",
      "department": "department",
      "description": "description",
      "diecutSetupMinutes": "die-cut set-up time",
      "discountPercent": "discount",
      "doNotContact": "do not contact",
      "dueAt": "due at",
      "durationMinutes": "duration",
      "effectiveSpeed": "effective speed",
      "email": "email",
      "emailGeneral": "general email",
      "emailOptIn": "mailings",
      "expectedAt": "expected at",
      "expectedCloseDate": "expected close date",
      "expectedDurationMinutes": "expected duration",
      "extraText": "extra text",
      "firstName": "first name",
      "flagFsc": "FSC",
      "forecastCategoryId": "forecast category",
      "forecastQuantity": "forecast quantity",
      "fscClaim": "FSC claim",
      "fulfilmentRoute": "route",
      "handworkMinutes": "manual work time",
      "hostEmployeeId": "host",
      "hostEmployeeIds": "hosts",
      "hourlyCostPrice": "hourly cost",
      "idMachine": "machine",
      "industryId": "industry",
      "subIndustryId": "sub-industry",
      "openingHours": "opening hours",
      "invoiceBundling": "invoice bundling",
      "isClosed": "closed",
      "isCustomer": "customer",
      "isOnSite": "on site",
      "isRush": "rush",
      "isSupplier": "supplier",
      "isDeliveryAddress": "delivery address",
      "isTrader": "trader",
      "isWon": "won",
      "jobTitle": "job title",
      "languageCode": "language",
      "lastActivityDate": "last activity",
      "lastContactedAt": "last contacted",
      "lastName": "last name",
      "leadSourceId": "lead source",
      "leadSourceDetail": "acquired via (name)",
      "legalName": "legal name",
      "lifecycleStageId": "lifecycle stage",
      "lineNumber": "line number",
      "linkedinUrl": "LinkedIn",
      "loadedQuantity": "loaded quantity",
      "location": "location",
      "locationId": "location",
      "locationReferenceId": "location",
      "logo": "logo",
      "m2PerUnit": "m² per unit",
      "machineId": "machine",
      "machineShortcode": "machine code",
      "mailingAddressJson": "mailing address",
      "materialDueDate": "material due",
      "maxOverDelivery": "max over-delivery",
      "maxOversupplyPct": "max over-supply %",
      "maxUnderDelivery": "max under-delivery",
      "maxUndersupplyPct": "max under-supply %",
      "meetingUrl": "meeting link",
      "middleName": "middle name",
      "mobilePhone": "mobile",
      "multipleUp": "number up",
      "name": "name",
      "neutralDelivery": "neutral delivery",
      "nextStep": "next step",
      "notes": "notes",
      "productionNotes": "production note",
      "notesDelivery": "delivery notes",
      "number": "number",
      "numberOfParts": "number of parts",
      "onBehalfOfAccountId": "on behalf of",
      "orderDate": "order date",
      "orderDiscountPercent": "order discount",
      "orderId": "order",
      "orderLineId": "order line",
      "orderType": "order type",
      "orderedAt": "ordered at",
      "orderedByUserId": "ordered by",
      "outcome": "outcome",
      "packingSlipId": "packing slip",
      "palletLabelPlacement": "pallet label position",
      "palletSizeId": "pallet size",
      "palletStacking": "pallet stacking",
      "palletsPerCollo": "pallets per collo",
      "parentAccountId": "parent account",
      "pauseMinutes": "break",
      "paymentTermId": "payment term",
      "paymentTermLabel": "payment term",
      "phone": "phone",
      "phoneMain": "main phone",
      "phoneMobile": "mobile",
      "phoneWork": "work phone",
      "pipelineId": "pipeline",
      "plannedCleanupMinutes": "planned clean-up time",
      "plannedDate": "planned date",
      "plannedDeliveryDate": "planned delivery date",
      "plannedDownMinutes": "planned downtime",
      "plannedLoadingDate": "planned loading date",
      "plannedQuantity": "planned quantity",
      "plannedRunMinutes": "planned run time",
      "plannedSetupMinutes": "planned set-up time",
      "plannedSheets": "planned sheets",
      "preferredCurrency": "preferred currency",
      "preferredName": "preferred name",
      "priceSource": "price source",
      "priceTierMinQty": "tier from",
      "priceUnit": "price unit",
      "primaryAddressJson": "main address",
      "primaryContactId": "main contact",
      "primaryCurrency": "main currency",
      "printSetupMinutes": "print set-up time",
      "priority": "priority",
      "probability": "probability",
      "productId": "article",
      "productName": "article name",
      "productSku": "article number",
      "purpose": "purpose",
      "qtyPerCollo": "quantity per collo",
      "quantityConfirmed": "confirmed quantity",
      "quantityOrdered": "ordered quantity",
      "quoteId": "quote",
      "recurrenceRule": "recurrence",
      "registrationNumber": "registration number",
      "relatedToId": "related to",
      "relatedToType": "related type",
      "reminderAt": "reminder",
      "reminderSent": "reminder sent",
      "reportsToContactId": "reports to",
      "requestedDeliveryDate": "requested delivery date",
      "runMinutes": "run time",
      "salesRepUserId": "sales rep",
      "salutation": "salutation",
      "score": "score",
      "scrapInternal": "internal scrap",
      "scrapMachine": "machine scrap",
      "scrapSupplier": "supplier scrap",
      "sentAt": "sent at",
      "seq": "sequence",
      "setupMinutes": "set-up time",
      "shipToAccountId": "ship-to",
      "shipToName": "ship-to name",
      "shippingAddressJson": "shipping address",
      "sizeCategory": "size category",
      "smsOptIn": "SMS opt-in",
      "sourceId": "source",
      "sourceDetail": "source (name)",
      "sourceLeadId": "source lead",
      "sourceQuoteLineId": "quote line",
      "speedSurchargeFactor": "speed surcharge",
      "stageId": "stage",
      "startedAt": "started at",
      "status": "status",
      "stockUnit": "stock unit",
      "stoppedAt": "stopped at",
      "subject": "subject",
      "supplierAccountId": "supplier",
      "supplierName": "supplier name",
      "supplierNumber": "supplier number",
      "supplyKind": "supply kind",
      "supplyStep": "material status",
      "taxId": "VAT number",
      "taxRateId": "VAT rate",
      "terms": "terms",
      "timeZone": "time zone",
      "tracksStock": "tracks stock",
      "traderAccountId": "trader",
      "twitterHandle": "X/Twitter",
      "type": "type",
      "unitCost": "unit cost",
      "unitPrice": "price",
      "vatCheckedAt": "VAT checked at",
      "vatConsultationNumber": "VAT consultation number",
      "vatStatus": "VAT status",
      "vatStatusReason": "VAT status reason",
      "vatVerifiedAddress": "VAT-verified address",
      "vatVerifiedName": "VAT-verified name",
      "visibility": "visibility",
      "visitorName": "visitor name",
      "website": "website",
      "weightPerUnit": "weight per unit",
      "ownerUserId": "owner",
      "userId": "linked account",
      "initials": "initials",
      "dateOfBirth": "date of birth",
      "showBirthday": "show birthday",
      "gender": "gender",
      "nationalIdEncrypted": "national ID",
      "ibanEncrypted": "IBAN",
      "phoneNumber": "phone",
      "mobileNumber": "mobile",
      "companyEmail": "company email",
      "companyPhoneNumber": "company phone",
      "employeeNumber": "employee number",
      "employeeType": "employee type",
      "dateInService": "start date",
      "dateOutService": "end date",
      "hoursPerWeek": "hours per week",
      "commuteDistanceKm": "commute distance",
      "employmentType": "employment type",
      "managerId": "manager",
      "salary": "salary",
      "departmentId": "department",
      "confirmationDate": "confirmation date",
      "noticePeriodDays": "notice period",
      "finalWorkingDay": "final working day",
      "relievingDate": "relieving date",
      "emergencyContact": "emergency contact",
      "employeeImageId": "photo",
      "employeeAdditionalImage1": "additional photo 1",
      "employeeAdditionalImage2": "additional photo 2",
      "notesHours": "hours notes",
      "employeeId": "employee",
      "title": "title",
      "startDate": "start date",
      "startTime": "start time",
      "endDate": "end date",
      "endTime": "end time",
      "approvedBy": "approved by",
      "date": "date",
      "shiftTypeId": "shift type",
      "source": "source",
      "templateId": "template",
      "signedAt": "signed on",
      "generatedContent": "generated content",
      "fileUrl": "file",
      "isActive": "active",
      "documentType": "document type",
      "fileSize": "file size",
      "mimeType": "file type",
      "issuedDate": "issue date",
      "expiryDate": "expiry date",
      "uploadedBy": "uploaded by",
      "totalAmount": "total amount",
      "submittedAt": "submitted on",
      "rejectedReason": "rejection reason",
      "paidAt": "paid on",
      "leaveType": "absence type",
      "totalDays": "total days",
      "reason": "reason",
      "rejectionReason": "rejection reason",
      "effectiveDate": "effective date",
      "oldValues": "previous values",
      "newValues": "new values",
      "letterFileUrl": "letter",
      "periodStart": "period start",
      "periodEnd": "period end",
      "runBy": "run by",
      "runAt": "run on",
      "totalGross": "total gross",
      "totalDeductions": "total deductions",
      "totalNet": "total net",
      "employeeCount": "employees",
      "reviewerId": "reviewer",
      "reviewCycle": "review cycle",
      "reviewPeriodStart": "review period start",
      "reviewPeriodEnd": "review period end",
      "overallRating": "overall rating",
      "goals": "goals",
      "strengths": "strengths",
      "areasOfImprovement": "areas of improvement",
      "comments": "comments",
      "openingId": "job opening",
      "resumeUrl": "resume",
      "coverLetter": "cover letter",
      "rating": "rating",
      "referredBy": "referred by",
      "requirements": "requirements",
      "salaryRangeMin": "salary range minimum",
      "salaryRangeMax": "salary range maximum",
      "positionsCount": "positions",
      "publishedAt": "published on",
      "closesAt": "closes on",
      "weekdays": "weekdays",
      "trainerName": "trainer",
      "trainerEmployeeId": "trainer (employee)",
      "maxParticipants": "maximum participants",
      "assigneeUserId": "Assignee",
      "dueDate": "Due date",
      "estimatedHours": "Estimated hours",
      "projectId": "Project",
      "needsPrintTooling": "prints (printing plate and ink needed)",
      "needsDiecutTooling": "die-cuts (die needed)",
      "isExternal": "held by a third party",
      "customerId": "customer",
      "noteCalculation": "note",
      "articleType": "article type",
      "articleDescription": "article description",
      "customerArticleReference": "customer article reference",
      "articleExtraInfo": "extra article information for the quote",
      "fefcoId": "FEFCO code",
      "dimensionLength": "length (L)",
      "dimensionWidth": "width (W)",
      "dimensionHeight": "height (H)",
      "closureType": "closure",
      "flapStack": "variant",
      "glCode": "GL position",
      "verlengdGl": "extended glue flap",
      "printOptions": "print",
      "dieOptions": "die-cut",
      "dimE": "E",
      "dimO": "overlap (O)",
      "dimH1": "H1",
      "qualityId": "quality",
      "planoRotated": "flute rotated",
      "multiUpWidth": "number up W",
      "multiUpLength": "number up L",
      "isDiecutPackaging": "die-cut packaging",
      "diecutMultipleUpWidth": "die-cut sheet number up W",
      "diecutMultipleUpLength": "die-cut sheet number up L",
      "diecutPlateLength": "die-cut sheet length",
      "diecutPlateWidth": "die-cut sheet width",
      "priceListDate": "calculate with price list from",
      "creditorId1": "creditor 1",
      "creditorReference1": "creditor 1 reference",
      "creditorNote1": "creditor 1 note",
      "creditorId2": "creditor 2",
      "creditorReference2": "creditor 2 reference",
      "creditorNote2": "creditor 2 note",
      "creditorId3": "creditor 3",
      "creditorReference3": "creditor 3 reference",
      "creditorNote3": "creditor 3 note",
      "quantity": "quantity",
      "priceQuote": "quote price",
      "priceArticle": "article price",
      "staffel1": "tier 1",
      "staffel2": "tier 2",
      "staffel3": "tier 3",
      "staffel4": "tier 4",
      "staffel5": "tier 5",
      "staffel6": "tier 6",
      "sku": "SKU",
      "articleReferenceBarcode": "customer Reference Barcode",
      "articleReferenceBarcodeSymbology": "symbology",
      "kind": "type",
      "colloLength": "collo length (cm)",
      "colloWidth": "collo width (cm)",
      "colloHeight": "collo height (cm, incl. pallet)",
      "colloPieces": "pieces per collo",
      "currentCost": "current stock cost",
      "priceUnitPurchase": "price unit (purchase)",
      "priceUnitSale": "price unit (sale)",
      "weight": "weight (kg)",
      "colorId": "colour",
      "commodityCode": "commodity code (CN)",
      "tracksLots": "track lots",
      "tracksSerials": "track serial numbers",
      "barcode": "barcode",
      "unitOfMeasure": "unit of measure (UoM)",
      "lowStockThreshold": "low-stock threshold",
      "stockCategory": "stock category",
      "stockSupplyMode": "stock replenishment",
      "productionRunQuantity": "production run quantity",
      "callOffQuantity": "call-off quantity",
      "invoiceTrigger": "invoicing",
      "maxStockMonths": "max. months of stock",
      "addPrint": "printing",
      "addDiecut": "die-cutting",
      "groupId": "group",
      "groupSubId": "sub-group",
      "minQty": "from quantity",
      "toolPrint1": "printing plate 1 (number)",
      "toolPrint1ProductId": "printing plate 1 (article)",
      "toolPrint2": "printing plate 2 (number)",
      "toolPrint2ProductId": "printing plate 2 (article)",
      "toolDiecut1": "die 1 (number)",
      "toolDiecut1ProductId": "die 1 (article)",
      "toolDiecut2": "die 2 (number)",
      "toolDiecut2ProductId": "die 2 (article)",
      "toolColor1": "color 1 (number)",
      "toolColor1ProductId": "color 1 (article)",
      "toolColor2": "color 2 (number)",
      "toolColor2ProductId": "color 2 (article)",
      "toolColor3": "color 3 (number)",
      "toolColor3ProductId": "color 3 (article)",
      "toolColor4": "color 4 (number)",
      "toolColor4ProductId": "color 4 (article)",
      "toolColor5": "color 5 (number)",
      "toolColor5ProductId": "color 5 (article)",
      "toolColor6": "color 6 (number)",
      "toolColor6ProductId": "color 6 (article)",
      "creditorLastModiDate1": "price updated on (creditor 1)",
      "creditorLastModiDate2": "price updated on (creditor 2)",
      "creditorLastModiDate3": "price updated on (creditor 3)",
      "supplierId": "supplier",
      "sourceType": "source",
      "sourceCalculationId": "source calculation",
      "staffel7": "tier 7",
      "staffel8": "tier 8",
      "staffel9": "tier 9",
      "staffel10": "tier 10",
      "staffel11": "tier 11",
      "staffel12": "tier 12",
      "priceGuideline": "guideline price",
      "customerCity": "customer city",
      "isTemplate": "template",
      "leaveTypeId": "absence type",
      "normalHours": "normal hours",
      "specialHours": "special hours",
      "agendaText": "agenda text",
      "partnerId": "relation",
      "externalReference": "external reference",
      "issueDate": "issue date",
      "fxRate": "exchange rate",
      "fxBaseCurrency": "base currency",
      "approvalStatus": "approval status",
      "subtotal": "subtotal",
      "discountTotal": "total discount",
      "shippingAmount": "shipping costs",
      "shippingTaxRateId": "shipping VAT rate",
      "taxTotal": "VAT",
      "total": "total",
      "amountPaid": "paid",
      "amountDue": "amount due",
      "recurringDocumentId": "recurring schedule",
      "convertedFromDocumentId": "converted from",
      "appliedToDocumentId": "applied to",
      "bankTransactionId": "bank transaction"
    }
  },
  "errors": {
    "generic": {
      "INTERNAL": "Something went wrong. Please try again.",
      "INVALID_INPUT": "Please check the input.",
      "NOT_FOUND": "Not found.",
      "FORBIDDEN": "You are not allowed to do this.",
      "CONFLICT": "This conflicts with a recent change.",
      "BAD_REQUEST": "This request is not valid.",
      "UNAUTHORIZED": "Please sign in again."
    },
    "PERMISSION_DENIED": "You don't have permission for this.",
    "FIELD_WRITE_DENIED": "You may not change: {fields}",
    "PACKING_SLIP_LOADED": "The packing slip has already been loaded; this shipment can no longer change",
    "NO_SERVICE_IDENTITY": "This packing slip goes out under our own name; there is no reseller copy",
    "SHIPMENT_NOT_FOUND": "One of the selected shipments no longer exists",
    "ALREADY_BUNDLED": "One of the selected shipments is already on a packing slip",
    "ALREADY_LOADED": "One of the selected shipments has already been loaded",
    "EMPTY_SELECTION": "Select at least one shipment first",
    "KEY_MISMATCH": "These shipments don't share the same customer, delivery date, delivery address and deliverer",
    "NO_DELIVERY_DATE": "One of the selected shipments has no confirmed delivery date yet",
    "NOT_READY": "One of the selected shipments is not yet ready for shipping",
    "CANCELLED": "One of the selected shipments belongs to a cancelled order line or order",
    "DOCUMENTS_LOCKED": "All lines are invoiced. No new documents can be created; documents sent earlier can still be downloaded and sent again.",
    "WRITE_OFF_REASON_REQUIRED": "Enter a reason when writing off.",
    "SPLIT_WRITTEN_OFF": "A written-off collo cannot be split.",
    "COLLO_WRITTEN_OFF": "A written-off collo cannot be loaded.",
    "SPLIT_LOADED": "A loaded collo cannot be split.",
    "SPLIT_AFTER_COUNT": "This collo has already been counted. Correct the actual quantity first, then split.",
    "SPLIT_QUANTITY_TOO_LARGE": "The quantity taken off must be smaller than what is on the pallet.",
    "CARRIER_NEEDS_ACCOUNT": "Pick a carrier for the kind \"Carrier\".",
    "EMPLOYEE_NEEDS_EMPLOYEE": "Pick an employee for the kind \"Employee\".",
    "NO_CONFIRMED_QUANTITY": "This order line has no confirmed quantity yet, so there is nothing to ship.",
    "VERSION_CONFLICT": "Someone else changed this in the meantime. Reload and try again.",
    "MACHINE_RUN_CLOSED": "This machine run has already been closed; changes can no longer be saved.",
    "PRODUCTION_ORDER_NOT_OPEN": "The production order of this run has been cancelled or completed; the run can no longer be edited or closed.",
    "EMAIL_TAKEN": "This email address is already in use, or has a pending invitation.",
    "ADMIN_REQUIRED": "Only an administrator can make someone Administrator or turn Administrator off.",
    "ADMIN_PROTECTED": "Only an administrator can change an administrator's account.",
    "SELF_DEMOTE": "You cannot turn off your own administrator role.",
    "UNKNOWN_ROLE": "One of the selected roles no longer exists.",
    "QUOTE_INCOMPLETE": "The quote is not complete yet.",
    "QUOTE_NOT_ISSUED": "Issue the quote before e-mailing it.",
    "ORDER_NOT_CONFIRMED": "Start the order before e-mailing it.",
    "ORDER_INCOMPLETE": "The order is not complete yet.",
    "PURCHASE_ORDER_NOT_CONFIRMED": "Start the purchase order before e-mailing it.",
    "INCOMPLETE_LINES": "These lines are not complete yet: {lineNumbers}",
    "MACHINE_RUN_SHEETS_REQUIRED": "This machine counts in sheets: enter the number of sheets.",
    "MACHINE_RUN_QUANTITY_REQUIRED": "Enter the actual quantity.",
    "COMPLETE_LOCATION_REQUIRED": "Choose a location: this item keeps stock per pallet.",
    "ORDER_LINE_PRODUCT_MISMATCH": "The item does not belong to this sales order line.",
    "ORDER_LINE_CANCELLED": "This order line has been cancelled.",
    "ORDER_NOT_EDITABLE": "This order is cancelled or closed; its lines can no longer be changed.",
    "ORDER_LINE_INVOICED": "Line {lineNumber} has been invoiced; {fields} can no longer be changed.",
    "ORDER_LINE_NOT_DELETABLE": "Line {lineNumber} cannot be deleted.",
    "VIES_DISABLED": "The VAT number check (VIES) is switched off.",
    "SEND_WARNINGS_UNACKNOWLEDGED": "Confirm the warnings before sending.",
    "SENT_HISTORY_PROTECTED": "The sent history of this document cannot be deleted.",
    "SEND_IN_PROGRESS": "This message is still queued; sending it again would send it twice.",
    "DUPLICATE_CODE": "A location with this code already exists.",
    "ITEM_NOT_LOT_TRACKED": "This item does not exist or is not tracked by lot.",
    "DUPLICATE_LOT": "This lot already exists for this item.",
    "LOCATION_REQUIRED_FOR_IN_STOCK": "A location is required to put a serial number in stock.",
    "LOCATION_ONLY_WHEN_IN_STOCK": "Only a serial number in stock can have a location.",
    "ITEM_NOT_SERIAL_TRACKED": "This item does not exist or is not tracked by serial number.",
    "DUPLICATE_SERIAL": "This serial number already exists for this item.",
    "ZERO_DELTA": "The adjustment cannot be zero.",
    "SERIAL_QUANTITY_MISMATCH": "The number of serial numbers must equal the quantity.",
    "SAME_LOCATION": "The source and destination locations must differ.",
    "COST_READ_FORBIDDEN": "You may not view the stock valuation.",
    "CALL_OFF_NO_PRODUCT": "This call-off has no item.",
    "CALL_OFF_NOT_COLLO_STOCK": "This item does not keep stock per pallet, so it cannot be called off.",
    "INBOUND_UNDO_PRODUCTION_RUNNING": "Production has already started; the receipt stays in place.",
    "SHIPMENT_EXISTS": "This order line already has a shipment.",
    "CALCULATION_IN_USE": "This calculation is still in use and cannot be deleted.",
    "UNSUPPORTED_FEFCO": "The plano engine does not support this FEFCO code.",
    "MACHINE_CHANGE_NOT_SUPPORTED": "A machine run cannot switch machines.",
    "DUPLICATE_OPERATOR": "An operator is listed twice on this machine run.",
    "PRODUCTION_ORDER_NOT_EDITABLE": "A completed or cancelled production order can no longer be edited.",
    "PRODUCTION_ORDER_NOT_APPROVABLE": "A completed or cancelled production order can no longer be approved.",
    "ORDER_NOT_DELETABLE": "This order cannot be deleted.",
    "INVALID_BARCODE": "This barcode is not valid for {label}.",
    "DUPLICATE_SKU": "A product with this SKU already exists.",
    "PRODUCT_NOT_DELETABLE": "This product cannot be deleted.",
    "CARTON_ALREADY_ORDERED": "Board has already been ordered for this production order.",
    "CREDITOR_LINE_ALREADY_LINKED": "This production order already has a creditor line.",
    "CREDITOR_LINE_NOT_COPRODUCTION": "This production order is not a co-production order.",
    "CREDITOR_LINE_NOT_PRODUCT": "Only an active product line can become a creditor line.",
    "CREDITOR_LINE_ORDER_CLOSED": "This production order is already completed or cancelled.",
    "CREDITOR_LINE_OTHER_PRODUCT": "This line is for a different product than the production order.",
    "CREDITOR_LINE_LOCKED": "The product of a creditor line is fixed. Unlink the line first.",
    "CREDITOR_LINE_RECEIVED": "Something was already received on this line; it can no longer be linked or unlinked.",
    "CREDITOR_LINE_DUPLICATE_ORDER": "The same production order is in the selection twice.",
    "CARTON_NOT_ORDERABLE": "Board cannot be ordered for this production order.",
    "CARTON_LINE_CANCELLED": "This board line has been cancelled.",
    "CARTON_LINE_HAS_RECEIPTS": "Pallets have already been received; close the line with Delivery complete.",
    "INBOUND_UNKNOWN_REFERENCE": "No open board line {reference} for this supplier.",
    "INBOUND_DUPLICATE_PALLET": "This pallet is already known.",
    "INBOUND_DELIVERY_HAS_RECEIPTS": "Pallets from this delivery have already been received.",
    "NO_LINES": "A purchase order without lines cannot be started.",
    "RECEIVE_LINE_NOT_ON_ORDER": "This line does not belong to this purchase order.",
    "RECEIVE_CARTON_LINE": "A board line is received through the incoming pallets, not here.",
    "ORDER_INVOICED": "This order has been invoiced and can no longer be changed or cancelled.",
    "INVALID_ROLE": "This role does not exist.",
    "MARKETING_INVITE_PENDING": "This e-mail address has a pending workspace-manager invitation. Wait until it is accepted, or revoke it.",
    "ALREADY_MEMBER": "This person already has access to this workspace.",
    "PENDING_CAP": "Too many open invitations. Revoke some first.",
    "SELF_DISABLE": "You can't disable yourself.",
    "IS_WORKSPACE_MANAGER": "This user is a workspace manager; that is managed at platform level.",
    "SELF_PASSWORD_RESET": "Change your own password in your account settings.",
    "BLOCK_ALREADY_CLOSED": "This block has already been lifted.",
    "BLOCK_VERDICT_REQUIRED": "This block needs a verdict before it can be lifted.",
    "BLOCK_NOT_FOUND": "Block not found.",
    "APPROVAL_STEP_INVALID": "Step {step} of the chain is not valid: choose who approves and enter a valid amount.",
    "APPROVAL_NOT_PENDING": "This document is no longer waiting for approval. Refresh the page.",
    "APPROVAL_ALREADY_PENDING": "This document is already waiting for approval.",
    "APPROVAL_BUYER_MISSING": "A step of the chain is approved by the buyer, but this document has no buyer, or its buyer has been disabled or may not read the document. Choose a buyer first.",
    "APPROVAL_ALREADY_DECIDED": "You have already approved this step. We are now waiting for the others.",
    "INSERT_FAILED": "Saving failed. Please try again.",
    "QUOTE_NOT_FOUND": "Quote not found.",
    "TENANT_MISSING": "Something went wrong. Please try again.",
    "STORAGE_NOT_CONFIGURED": "File storage is not set up for this workspace.",
    "QUOTE_ALREADY_SENT": "This quote has already been sent.",
    "ORDER_LINE_NOT_FOUND": "Order line not found.",
    "QUOTE_LINE_NOT_ON_QUOTE": "A quote line does not belong to this quote.",
    "PRODUCT_NOT_FOUND": "Item not found.",
    "QUOTE_LINE_PRODUCT_MISMATCH": "Quote line {lineNumber} is for a different item than the one ordered.",
    "QUOTE_LINE_CALCULATION_MISMATCH": "The item for quote line {lineNumber} does not come from that line’s calculation.",
    "ORDER_TRANSITION_NOT_ALLOWED": "This status change is not allowed.",
    "ORDER_NOT_FOUND": "Sales order not found.",
    "SNAPSHOT_REFRESH_NOT_ALLOWED": "Refreshing from master data is only possible on a draft or running order.",
    "UPLOAD_URL_FAILED": "The upload could not be prepared. Please try again.",
    "ATTACHMENT_KEY_MISMATCH": "This file does not belong to this record.",
    "ATTACHMENT_NOT_FOUND": "Attachment not found.",
    "DRAWING_ON_ORDER_LINE": "This drawing is on an order line and cannot be deleted.",
    "DRAWING_REVISION_NOT_LATEST": "Only the newest revision can be deleted.",
    "DRAWING_FIRST_REVISION": "Revision 1 is deleted together with the whole drawing.",
    "ORDER_LINE_PRODUCT_REQUIRED": "An order line needs an item.",
    "PRODUCTION_ORDER_NOT_FOUND": "Production order not found.",
    "MACHINE_RUN_NOT_FOUND": "Machine run not found.",
    "EARLIER_RUN_OPEN": "Machine run {seq} is still open; runs are closed in route order.",
    "PRODUCTION_ORDER_NUMBER_EXHAUSTED": "No free production order number is left for this line.",
    "PRODUCTION_ORDER_NOT_COMPLETABLE": "Production order {number} is already completed or cancelled.",
    "PRODUCTION_ORDER_HAS_MACHINE_RUNS": "Production order {number} has machine runs; complete it by closing the last machine run.",
    "ORDER_LINE_NO_COLLI": "This order line has no pallets to complete.",
    "COLLO_ALREADY_CLAIMED": "A pallet was just claimed by another production order.",
    "COLLO_NOT_FOUND": "Pallet not found.",
    "DELIVERY_METHOD_NOT_FOUND": "Delivery method not found.",
    "PACKING_SLIP_NOT_FOUND": "Packing slip not found.",
    "TRANSPORT_SURCHARGE_NOT_SET": "The transport surcharge has not been set yet.",
    "TRANSPORT_ZONE_NOT_FOUND": "Transport zone not found.",
    "TRANSPORT_ZONE_EXISTS": "This country and zone combination already exists.",
    "TRANSPORT_ZONE_POSTAL_CODE_OVERLAP": "{postalCode} overlaps {otherPostalCode} in the zone {zone}. Put each postal code in one zone of the country.",
    "TRANSPORT_RATE_NOT_FOUND": "This freight rate no longer exists. Reload the zone.",
    "TRANSPORT_RATE_DUPLICATE_LOADING_METER": "There are two freight rates for {loadingMeter} loading metres. Give each line its own number of loading metres.",
    "TRANSPORT_RATE_COST_REQUIRED": "Enter the cost on every new freight rate.",
    "NOTHING_TO_UPDATE": "There is nothing to save.",
    "TRANSPORT_ZONE_IN_USE": "This zone is used by {count, plural, one {# calculation} other {# calculations}} and cannot be deleted.",
    "INBOUND_PALLET_NOT_FOUND": "Inbound pallet not found.",
    "SUPPLIER_NOT_FOUND": "Supplier not found.",
    "CARTON_LINE_NOT_FOUND": "Board line not found.",
    "PURCHASE_ORDER_NOT_FOUND": "Purchase order not found.",
    "PURCHASE_ORDER_PENDING_APPROVAL": "This purchase order is awaiting approval and cannot be changed now. To change it, move it back to draft first.",
    "INBOUND_DELIVERY_NOT_FOUND": "Board delivery not found.",
    "LOCATION_NOT_FOUND": "Location not found.",
    "SERIAL_NOT_FOUND": "Serial number not found.",
    "LOT_NOT_FOUND": "Lot not found.",
    "WEBHOOK_SOURCE_NOT_FOUND": "Webhook source not found.",
    "LOT_REQUIRED": "This item is tracked by lot: choose a lot.",
    "LOT_WRONG_PRODUCT": "This lot belongs to another item.",
    "SERIAL_REQUIRED": "This item is tracked by serial number: choose a serial number.",
    "PURCHASE_LINE_NOT_FOUND": "Purchase order line not found.",
    "RECEIPT_LOCATION_REQUIRED": "Choose a location to receive into stock.",
    "INVITE_NOT_FOUND": "This invitation no longer exists or has already been accepted.",
    "USER_NOT_FOUND": "User not found.",
    "CALL_OFF_ALREADY_RESERVED": "Collo {number} has since been reserved for another shipment.",
    "CALL_OFF_UNAVAILABLE": "Collo {number} is no longer available.",
    "BLOCK_KIND_NOT_FOUND": "Block kind not found.",
    "ALREADY_ENROLLED": "This employee is already enrolled in this training.",
    "APPLICANT_EMAIL_TAKEN": "An applicant with this email address already exists for this job opening.",
    "APPLICANT_NOT_FOUND": "Applicant not found.",
    "CONTRACT_NOT_FOUND": "Contract not found.",
    "CONTRACT_TEMPLATE_NOT_FOUND": "Contract template not found.",
    "DEPARTMENT_NOT_FOUND": "Department not found.",
    "EMPLOYEE_DOCUMENT_NOT_FOUND": "Document not found.",
    "EMPLOYEE_EMAIL_TAKEN": "This email address already belongs to an employee who is not set to Terminated. An employee set to Inactive keeps their email address too.",
    "EMPLOYEE_NOT_FOUND": "Employee not found.",
    "END_DATE_BEFORE_START": "The end date must be after the start date.",
    "EXPENSE_CLAIM_NOT_EDITABLE": "Only a draft expense claim can be changed.",
    "EXPENSE_CLAIM_NOT_FOUND": "Expense claim not found.",
    "INSUFFICIENT_LEAVE_BALANCE": "Not enough leave balance: {available, plural, one {# day} other {# days}} available, {requested, plural, one {# day} other {# days}} requested.",
    "INTERVIEW_NOT_DELETABLE": "Only a scheduled interview can be deleted.",
    "INTERVIEW_NOT_FOUND": "Interview not found.",
    "JOB_OPENING_HAS_APPLICANTS": "This job opening has applicants and cannot be deleted.",
    "JOB_OPENING_NOT_DELETABLE": "Only a draft job opening can be deleted.",
    "JOB_OPENING_NOT_FOUND": "Job opening not found.",
    "JOB_OPENING_NOT_OPEN": "This job opening is not accepting applications.",
    "LEAVE_REQUEST_NOT_FOUND": "Absence not found.",
    "LIFECYCLE_CHANGES_INVALID": "A change in this event has an invalid value, for example a salary that is not an amount. Correct the changes, save and complete again.",
    "LIFECYCLE_COMPLETE_VIA_ACTION": "You don't choose Completed yourself: complete an approved event with Complete, which applies the changes to the employee.",
    "LIFECYCLE_EVENT_COMPLETED": "This event is completed: its status, effective date and changes are fixed.",
    "LIFECYCLE_EVENT_NOT_FOUND": "Lifecycle event not found.",
    "LOAD_FAILED": "Loading failed. Please try again.",
    "NO_EMPLOYEE_RECORD": "Your account is not linked to an employee.",
    "NO_FILE_ATTACHED": "No file has been attached yet.",
    "OFFER_LETTER_NOT_FOUND": "Offer letter not found.",
    "OFFER_NOT_ACCEPTED": "An applicant can only be hired after accepting an offer for this opening.",
    "ONBOARDING_TASK_NOT_FOUND": "Onboarding task not found.",
    "PAYROLL_RUN_NOT_FOUND": "Payroll run not found.",
    "PAYSLIP_FINALIZED": "This payslip has already been finalized.",
    "PAYSLIP_NOT_FOUND": "Payslip not found.",
    "PAYSLIP_PDF_NOT_GENERATED": "No PDF has been generated for this payslip yet.",
    "PERFORMANCE_REVIEW_NOT_FOUND": "Performance review not found.",
    "SALARY_ASSIGNMENT_NOT_FOUND": "Salary assignment not found.",
    "SALARY_COMPONENT_NOT_FOUND": "Salary component not found.",
    "SALARY_STRUCTURE_ITEM_NOT_FOUND": "Salary structure line not found.",
    "SALARY_STRUCTURE_NOT_FOUND": "Salary structure not found.",
    "SALARY_STRUCTURE_INACTIVE": "This salary structure is not active; nobody can be assigned to it.",
    "SHIFT_ASSIGNMENT_NOT_FOUND": "Shift assignment not found.",
    "SHIFT_TYPE_NOT_FOUND": "Shift type not found.",
    "STATUS_TRANSITION_NOT_ALLOWED": "This action is not possible in the current status.",
    "TRAINING_ENROLLMENT_NOT_FOUND": "Enrollment not found.",
    "TRAINING_EVENT_ENROLLMENT_CLOSED": "Enrollment is only possible for a planned or ongoing training.",
    "TRAINING_EVENT_FULL": "This training is full.",
    "TRAINING_EVENT_HAS_ENROLLMENTS": "This training has enrollments and cannot be deleted.",
    "TRAINING_EVENT_NOT_DELETABLE": "Only a planned training can be deleted.",
    "TRAINING_EVENT_NOT_FOUND": "Training not found.",
    "USER_ALREADY_LINKED": "This user is already linked to another employee. Unlink them first.",
    "ALLOWANCE_TIER_EXISTS": "This supplier already has an allowance tier with this number.",
    "ALLOWANCE_TIER_NOT_FOUND": "Allowance tier not found.",
    "BUNDLE_STACKING_EXISTS": "Bundle stacking {bundleStacking} already exists.",
    "BUNDLE_STACKING_NOT_FOUND": "Bundle stacking not found.",
    "CALCULATION_ALREADY_PROMOTED": "This calculation has already been turned into a product.",
    "CALCULATION_ARTICLE_PRICE_MISSING": "These tiers have no article price: {quantities}. Enter the article price on the calculation and save it.",
    "CALCULATION_CHANGED": "The calculation was changed in the meantime. Reload it and try again.",
    "CALCULATION_FAILED": "The calculation could not be saved. Please try again.",
    "CALCULATION_HAS_NO_PRODUCT": "This calculation has no product to update.",
    "CALCULATION_HAS_NO_TIERS": "This calculation has no tiers yet. Calculate it first.",
    "CALCULATION_INVALID": "The calculation contains errors. Check the marked fields.",
    "CALCULATION_NOT_FOUND": "Calculation not found.",
    "FEFCO_EXISTS": "FEFCO code {fefco} already exists.",
    "FEFCO_NOT_FOUND": "FEFCO code not found.",
    "GL_VARIANT_EXISTS": "GL variant {glCode} already exists for this FEFCO code.",
    "GL_VARIANT_NOT_FOUND": "GL variant not found.",
    "IMAGE_NOT_PNG": "The drawing must be a PNG image.",
    "INVALID_DIMENSION": "Length, width and height must be positive numbers.",
    "IN_USE_BY_CALCULATIONS": "This record is used by {count, plural, one {# calculation} other {# calculations}} and cannot be deleted.",
    "IN_USE_BY_CALCULATION_TIERS": "This record is used by {count, plural, one {# calculation tier} other {# calculation tiers}} and cannot be deleted.",
    "IN_USE_BY_MACHINES": "This record is used by {count, plural, one {# machine} other {# machines}} and cannot be deleted.",
    "IN_USE_BY_PRICE_LISTS": "This record is used by {count, plural, one {# price list} other {# price lists}} and cannot be deleted.",
    "IN_USE_BY_STOCK_SHEETS": "This record is used by {count, plural, one {# stock sheet} other {# stock sheets}} and cannot be deleted.",
    "IN_USE_BY_SUPPLIER_LINKS": "This record is used by {count, plural, one {# quality–supplier link} other {# quality–supplier links}} and cannot be deleted.",
    "LAST_QUALITY_SUPPLIER": "This is the last supplier of this quality; without it, calculations using the quality can no longer be recalculated. Deactivate the quality instead.",
    "MACHINE_EXISTS": "Machine {machine} already exists.",
    "MACHINE_IN_USE": "This machine is used in {calculationLines, plural, one {# calculation line} other {# calculation lines}} and {machineRuns, plural, one {# machine run} other {# machine runs}} and cannot be deleted.",
    "MACHINE_NOT_FOUND": "Machine not found.",
    "MACHINE_OPERATION_TYPE_TAKEN": "This machine type is already in another operation of this machine.",
    "MACHINE_EXCEPTION_NOT_FOUND": "Exception not found.",
    "NO_PALLET_CONFIGURATION": "No valid pallet configuration was found for these dimensions.",
    "QUALITY_EXISTS": "Board quality {quality} already exists.",
    "QUALITY_NOT_FOUND": "Board quality not found.",
    "STOCK_SHEET_NOT_FOUND": "Stock sheet not found.",
    "STOCK_SHEET_ALREADY_LINKED": "This stock sheet already has a calculation.",
    "STOCK_SHEET_NO_SUPPLIER": "Choose a quality supplier for this stock sheet first.",
    "STOCK_SHEET_PRODUCT_NOT_ELIGIBLE": "This product cannot become a stock sheet: choose a product from an F0110 calculation with one tier and a fixed supplier that is not a stock sheet yet.",
    "SUPPLIER_ALREADY_LINKED": "This supplier is already linked to this quality.",
    "SUPPLIER_EXISTS": "This supplier already exists.",
    "SUPPLIER_LINK_IN_USE": "This supplier link is used by {stockSheets, plural, one {# stock sheet} other {# stock sheets}} and {calculationTiers, plural, one {# calculation tier} other {# calculation tiers}} and cannot be deleted.",
    "SUPPLIER_LINK_NOT_FOUND": "Supplier link not found.",
    "DOCUMENT_NOT_FOUND": "Document not found.",
    "DEFAULT_TAX_RATE_EXISTS": "A default VAT rate already exists for {country}.",
    "TAX_RATE_NOT_FOUND": "VAT rate not found.",
    "PAYMENT_TERM_NOT_FOUND": "Payment term not found.",
    "NEXT_NUMBER_TOO_LOW": "The next number cannot be lower than the current value ({current}).",
    "ALLOCATIONS_EXCEED_PAYMENT": "The allocated amounts exceed the payment amount.",
    "PAYMENT_ALLOCATION_KIND_MISMATCH": "This payment cannot be allocated to this kind of document.",
    "PAYMENT_CURRENCY_MISMATCH": "The payment is in {paymentCurrency}, but the document is in {documentCurrency}.",
    "ALLOCATION_AMOUNT_NOT_POSITIVE": "An allocated amount must be greater than zero.",
    "ALLOCATION_EXCEEDS_AMOUNT_DUE": "The allocated amount {amountApplied} is more than the amount due ({amountDue}).",
    "PAYMENT_NOT_FOUND": "Payment not found.",
    "CREDIT_NOTE_NOT_FOUND": "Credit note not found.",
    "CREDIT_NOTE_NOT_APPLICABLE": "Only a customer credit note can be applied.",
    "CREDIT_NOTE_NOT_OPEN": "Only an issued or partly applied credit note can be applied.",
    "ALLOCATIONS_EXCEED_CREDIT_NOTE": "The allocations ({amount}) exceed what remains on the credit note ({remaining}).",
    "ALLOCATION_REQUIRED": "Allocate a positive amount to at least one document.",
    "RECURRING_SCHEDULE_NOT_FOUND": "Recurring schedule not found.",
    "RECURRING_SCHEDULE_NOT_ACTIVE": "Only an active schedule can be paused or resumed.",
    "DOCUMENT_NOT_DRAFT": "Only a draft document can be changed or deleted.",
    "TAX_NOTE_EXISTS": "A VAT note for this treatment and country already exists.",
    "DEFAULT_LOCALE_TEXT_REQUIRED": "The text in the default language is required.",
    "TAX_NOTE_NOT_FOUND": "VAT note not found.",
    "LINE_TOTALS_MISSING": "Something went wrong while calculating the totals. Please try again.",
    "NOT_A_SUPPLIER_BILL": "Only a supplier bill goes through approval.",
    "BILL_NOT_DRAFT": "Only a draft bill can be submitted for approval.",
    "BILL_APPROVAL_REQUIRED": "Submit this bill for approval first; then you can issue it.",
    "NOT_AN_APPROVER": "You are not an approver in this workspace.",
    "DOCUMENT_TRANSITION_NOT_ALLOWED": "This status change is not allowed for this document.",
    "CLIENT_SECRET_REQUIRED": "Enter the client secret.",
    "EMAIL_NOT_CONFIGURED": "Outgoing email has not been set up yet.",
    "TEST_EMAIL_FAILED": "The test email could not be sent. {detail}",
    "COMPANY_VAT_NUMBER_MISSING": "The company has no VAT number to verify.",
    "VISIT_NOT_FOUND": "Visit not found.",
    "VISIT_ALREADY_CHECKED_IN": "This visitor is already checked in.",
    "VISIT_NOT_ON_SITE": "This visitor is not on site.",
    "VISITOR_STILL_ON_SITE": "The visitor is still checked in. Check them out before deleting this visit.",
    "VISIT_TITLE_REQUIRED": "Enter a description or a visitor.",
    "UNKNOWN_TIMEZONE": "Unknown time zone: {timezone}.",
    "END_OF_DAY_TIME_REQUIRED": "Enter a time for the end-of-day checkout.",
    "STAGE_NOT_FOUND": "Stage not found.",
    "STAGE_NOT_IN_PIPELINE": "This stage does not belong to the opportunity’s pipeline.",
    "STAGE_NOT_EDITABLE": "The stage cannot be changed here; use the stage change instead.",
    "CERTIFICATION_NOT_FOUND": "Certification not found.",
    "CERTIFICATION_LOGO_COMPANY_ONLY": "Only a certification of your own company can have a logo.",
    "CERTIFICATION_LOGO_KEY_INVALID": "This logo file does not belong to this certification.",
    "CERTIFICATION_LOGO_NOT_PNG": "This file is not a valid PNG. Save it again as PNG and upload it then.",
    "OPPORTUNITY_NOT_FOUND": "Opportunity not found.",
    "CONTACT_NOT_FOUND": "Contact not found.",
    "CARRIER_CONTACT_EMAIL_REQUIRED": "A contact who receives freight notices for the carrier needs an e-mail address.",
    "ACTIVITY_NOT_FOUND": "Activity not found.",
    "LOOKUP_LABEL_REQUIRED": "Enter the English label.",
    "LOOKUP_NOT_FOUND": "List value not found.",
    "ACCOUNT_NOT_FOUND": "Account not found.",
    "ACCOUNT_OWN_TRADER": "An account cannot be its own protecting trader.",
    "ACCOUNT_OWN_PARENT": "An account cannot be its own parent company.",
    "ACCOUNT_PARENT_LOOP": "The chosen parent company is itself a subsidiary of this account.",
    "ACCOUNT_PARENT_NOT_FOUND": "The chosen parent company does not exist.",
    "TAG_NOT_FOUND": "Tag not found.",
    "PIPELINE_NOT_FOUND": "Pipeline not found.",
    "COMMENT_NOT_FOUND": "Comment not found.",
    "COMMENT_AUTHOR_ONLY": "Only the author can change or delete this comment.",
    "CURRENCY_SETTINGS_MISSING": "The currency settings have not been set up yet.",
    "CURRENCY_RATE_NOT_FOUND": "Exchange rate not found.",
    "CURRENCY_PROVIDER_NOT_CONFIGURED": "No exchange-rate provider has been set up.",
    "CURRENCY_PROVIDER_KEY_MISSING": "Enter the API key for this exchange-rate provider.",
    "CURRENCY_PROVIDER_FETCH_FAILED": "The exchange-rate provider returned an error: {reason}",
    "LEAD_NOT_FOUND": "Lead not found.",
    "PREVIEW_RECORD_REQUIRED": "Choose a record to preview.",
    "LEAD_STATUS_CONVERTED": "You can't set the status Converted by hand: a lead gets it when you convert it, and keeps it after that.",
    "LEAD_CONVERSION_NEEDS_ACCOUNT": "An opportunity belongs to an account: give the lead a company name, or link an existing account.",
    "TEMPLATE_SUBJECT_INVALID": "The subject contains an error: {reason}",
    "TEMPLATE_BODY_INVALID": "The message text contains an error: {reason}",
    "TEMPLATE_HEADER_INVALID": "The header contains an error: {reason}",
    "TEMPLATE_FOOTER_INVALID": "The footer contains an error: {reason}",
    "TEMPLATE_NOT_FOUND": "E-mail template not found.",
    "EMAIL_TEMPLATES_ADMIN_ONLY": "Only an administrator can manage e-mail templates across modules.",
    "TEMPLATE_NO_DEFAULT": "This template has no system default to restore.",
    "SENT_PDF_NOT_FOUND": "The sent PDF could not be found.",
    "SENT_MESSAGE_NOT_FOUND": "This sent message no longer exists.",
    "ENTITY_NOT_SENDABLE": "This kind of document cannot be e-mailed.",
    "POLL_NOT_FOUND": "Poll not found.",
    "POLL_CLOSED": "This poll is not open for responses.",
    "POLL_NOT_IN_AUDIENCE": "You are not in the audience for this poll.",
    "POLL_ANSWER_INVALID": "An answer is not valid: {reason}",
    "POLL_ALREADY_RESPONDED": "You have already responded to this anonymous poll. An anonymous response is no longer linked to you, so you can't change it.",
    "POLL_ANONYMITY_LOCKED": "You can't turn anonymous responses on or off any more: this poll already has responses.",
    "TASK_NOT_FOUND": "Task not found.",
    "MILESTONE_NOT_FOUND": "Milestone not found.",
    "TIME_ENTRY_NOT_FOUND": "Time entry not found.",
    "PROJECT_MEMBER_NOT_FOUND": "Project member not found.",
    "PROJECT_NOT_FOUND": "Project not found.",
    "BOARD_NOT_FOUND": "Board not found.",
    "TWO_FACTOR_CODE_REQUIRED": "Enter a code from your authenticator app to continue.",
    "TWO_FACTOR_CODE_INVALID": "That code is not right, or it has expired. Try the code your app shows now.",
    "SELF_TWO_FACTOR_RESET": "You change your own two-factor sign-in on your Security page.",
    "ROLE_ADMIN_ALWAYS_TWO_FACTOR": "Administrators always use two-factor sign-in.",
    "TWO_FACTOR_REQUIRED_BY_POLICY": "Two-factor sign-in is required for your account, so it cannot be turned off.",
    "BOARD_COMMENT_NOT_FOUND": "Comment not found.",
    "BOARD_COMMENT_NOT_AUTHOR": "Only the author can change this comment.",
    "BOARD_COMMENT_PARENT_INVALID": "A reply must answer the first comment of a thread on the same board.",
    "BOARD_TOO_LARGE": "This board has become too large to save. Remove some content, large images first.",
    "MODULE_NOT_FOUND": "Module not found.",
    "FORMULA_INVALID": "A formula contains an error.",
    "DUPLICATE_FIELD_KEY": "A field key is used more than once.",
    "ENTITY_NOT_FOUND": "Entity not found.",
    "ENTITY_QUOTA_EXCEEDED": "A module can hold at most {max} entities.",
    "FIELD_QUOTA_EXCEEDED": "An entity can have at most {max} fields.",
    "ENTITY_EXISTS": "An entity with this key already exists in this module.",
    "UPDATE_FAILED": "Saving failed. Please try again.",
    "MARKETPLACE_NOT_CONFIGURED": "The module marketplace is not available.",
    "MARKETPLACE_MODULE_NOT_FOUND": "This module is not in the marketplace catalogue.",
    "MARKETPLACE_NO_VERSION": "This module has no published version yet.",
    "BUNDLE_INVALID": "This module package is not valid.",
    "MODULE_EXISTS": "A module with this key already exists.",
    "WEBHOOK_NOT_FOUND": "Webhook not found.",
    "WEBHOOK_URL_INVALID": "This webhook URL is not valid or not allowed.",
    "WORKFLOW_STEP_UNKNOWN_TYPE": "A workflow step has an unknown or unavailable type.",
    "WORKFLOW_NOT_FOUND": "Workflow not found.",
    "WORKFLOW_EXISTS": "A workflow with this key already exists in this module.",
    "ROLE_NOT_FOUND": "Role not found.",
    "ROLE_EXISTS": "A role with this key already exists.",
    "SYSTEM_ROLE_NOT_DELETABLE": "A system role cannot be deleted.",
    "NAV_ENTITY_REQUIRED": "Choose an entity for this menu item.",
    "NAV_ITEM_NOT_FOUND": "Menu item not found.",
    "MODULE_DISABLED": "This module is not enabled for your workspace.",
    "MODULE_PAUSED": "This module is paused; changes are not allowed.",
    "RECORD_NOT_FOUND": "Record not found.",
    "RECORD_INVALID": "Some fields of this record are not valid.",
    "RECORD_TOO_LARGE": "This record is too large (at most {maxBytes} bytes).",
    "LAYOUT_NOT_FOUND": "Layout not found.",
    "ENTITY_NOT_LAYOUTABLE": "The layout of this entity cannot be changed.",
    "LAYOUT_INVALID": "This layout is not valid.",
    "ENTITY_NOT_EXTENSIBLE": "Custom fields cannot be added to this entity.",
    "FIELD_KEY_TAKEN": "A field with this key already exists. Choose a different key.",
    "EXTENSION_FIELD_NOT_FOUND": "Custom field not found.",
    "VIEW_NOT_FOUND": "View not found.",
    "VIEW_EXISTS": "A view with this key already exists.",
    "EXTENSION_CALCULATION_INVALID": "This calculation contains an error.",
    "EXTENSION_CALCULATION_NOT_FOUND": "Calculation not found.",
    "EXTENSION_CALCULATION_EXISTS": "A calculation with this key already exists.",
    "EXTENSION_CALCULATION_INPUT_INVALID": "The inputs for this calculation are not valid.",
    "CONNECTION_NOT_FOUND": "Connection not found.",
    "CONNECTION_DISABLED": "This connection is switched off or not connected.",
    "EXTERNAL_PAGE_NOT_FOUND": "This connection does not offer this page.",
    "MANIFEST_MODULE_KEY_MISSING": "Something went wrong with this connection. Refresh it and try again.",
    "OIDC_CLIENT_NOT_FOUND": "Client not found or inactive.",
    "REDIRECT_URI_INVALID": "The redirect URI {uri} is not valid: use an HTTPS address (or localhost).",
    "OIDC_CLIENT_ID_TAKEN": "This client ID is already registered.",
    "NOT_AUTHENTICATED": "Your session has expired. Please sign in again.",
    "ADMIN_ONLY": "Only an administrator can do this.",
    "DATABASE_UNAVAILABLE": "Something went wrong. Please try again.",
    "MODULE_CONTEXT_MISSING": "Something went wrong. Please try again.",
    "FEATURE_DISABLED": "This feature is not enabled for your workspace.",
    "MODULE_MANAGEMENT_UNAVAILABLE": "Modules are managed centrally for this workspace. Please contact support.",
    "CORE_MODULE_REQUIRED": "This is a core module and cannot be switched off.",
    "FEATURE_NOT_FOUND": "Feature not found.",
    "MODULE_NOT_ACTIVE": "Activate the module before enabling its features.",
    "AGENDA_RANGE_INVALID": "Choose a period of 1 to 62 days.",
    "FORM_HISTORY_NOT_FOUND": "This form version no longer exists.",
    "FORM_SCHEMA_NOT_FOUND": "Form not found.",
    "INVALID_ICU_MESSAGE": "The translation contains invalid placeholder syntax.",
    "INVALID_LOCALE_CODE": "“{locale}” is not a valid language code.",
    "LOCALE_IS_SYSTEM": "“{locale}” is already a built-in language.",
    "LOCALE_NOT_FOUND": "Language not found.",
    "SYSTEM_LOCALE_PROTECTED": "A built-in language cannot be removed or moved.",
    "SAME_LOCALE": "The source and target languages must differ.",
    "UNKNOWN_TRANSLATION_KEY": "Unknown translation key: {key}",
    "CONFIG_NOT_FOUND": "Configuration not found.",
    "FILE_NOT_PDF": "The uploaded file is not a PDF.",
    "PPWR_STATEMENT_MISSING": "No statement has been uploaded yet.",
    "DOWNLOAD_URL_FAILED": "The download could not be prepared. Please try again.",
    "DECLARATION_NOT_ISSUED": "This declaration has not been issued yet.",
    "REFERENCE_LABEL_REQUIRED": "Enter an English name.",
    "REFERENCE_NOT_FOUND": "This list value no longer exists.",
    "REFERENCE_IN_USE": "This value is still used by {usage}, so it cannot be deleted. To take it out of the choices, switch off Active.",
    "PALLET_SIZE_NOT_FOUND": "Pallet size not found.",
    "PALLET_SIZE_EXISTS": "Pallet size {id} already exists.",
    "PALLET_SIZE_IN_USE": "This pallet size is still in use and cannot be deleted.",
    "COLLO_TYPE_NOT_FOUND": "Collo type not found.",
    "COLLO_TYPE_EXISTS": "Collo type {id} already exists.",
    "COLLO_TYPE_IN_USE": "This collo type is still in use and cannot be deleted.",
    "COUNTRY_NOT_FOUND": "Country not found.",
    "NUMBER_BELOW_CURRENT": "The next number cannot be lower than the current value ({current}).",
    "SYSTEM_ROLE_PROTECTED": "System roles cannot be changed or deleted. Make a copy to customise it.",
    "TEAM_NOT_FOUND": "Team not found.",
    "TEAM_NAME_TAKEN": "A team with this name already exists.",
    "API_KEYS_DISABLED_FOR_USER": "API keys are disabled for your account. Contact an administrator.",
    "API_KEY_NOT_FOUND": "API key not found.",
    "API_KEY_NOT_OWN": "You can only revoke your own API keys.",
    "SALARY_COMPONENT_EXISTS": "A salary component with code {componentCode} already exists.",
    "ORDER_LINE_INVOICED_NOT_CANCELLABLE": "Line {lineNumber} has been invoiced and can no longer be cancelled.",
    "INVALID_EMAIL_OR_PASSWORD": "Invalid email address or password.",
    "INVALID_EMAIL": "Please enter a valid email address.",
    "BANNED_USER": "This account has been disabled.",
    "INVALID_CODE": "Invalid code. Please try again.",
    "TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE": "Too many attempts. Sign in again to get a new code.",
    "INVALID_TWO_FACTOR_COOKIE": "Your sign-in has expired. Please sign in again.",
    "INVALID_PASSWORD": "Incorrect password.",
    "INVALID_TOKEN": "This link is invalid or has expired. Request a new one.",
    "PASSWORD_TOO_SHORT": "The password must be at least 8 characters.",
    "PASSWORD_TOO_LONG": "The password is too long.",
    "PASSWORD_COMPROMISED": "This password has appeared in a data breach. Choose a different password.",
    "TOO_MANY_REQUESTS": "Too many attempts. Please try again in a few minutes.",
    "WORKSPACE_NOT_FOUND": "This workspace is not available.",
    "WORKSPACE_READ_ONLY": "This workspace is currently read-only.",
    "INVITE_ALREADY_ACCEPTED": "This invite has already been accepted. Sign in instead.",
    "INVITE_EXPIRED": "This invite has expired. Ask for a new one.",
    "INTEGRATION_CONNECTION_NOT_FOUND": "Connection not found.",
    "INTEGRATION_CONNECTION_EXISTS": "A connection with this name already exists.",
    "INTEGRATION_CONNECTION_IN_USE": "This connection still has {count} task(s).",
    "INTEGRATION_BASE_URL_REQUIRED": "An address (URL) is required for HTTP.",
    "INTEGRATION_BASE_URL_INVALID": "A base URL may not contain a query (?) or fragment (#).",
    "INTEGRATION_HOST_REQUIRED": "A host is required for file transfer.",
    "INTEGRATION_AUTH_TYPE_INVALID": "This authentication type does not fit the protocol.",
    "INTEGRATION_URL_NOT_ALLOWED": "This address is not allowed (internal or private network).",
    "INTEGRATION_AUTH_FAILED": "The partner rejected the login. Check the credentials.",
    "INTEGRATION_HTTP_ERROR": "The partner answered with status {status}.",
    "INTEGRATION_TIMEOUT": "The partner did not answer in time.",
    "INTEGRATION_NETWORK_ERROR": "The partner could not be reached.",
    "INTEGRATION_RATE_LIMITED": "Too many requests to the partner; retried later.",
    "INTEGRATION_PARSE_FAILED": "The response is not valid {format}.",
    "INTEGRATION_FIELD_INVALID": "Field {field} ({path}) has an invalid value: {value}.",
    "INTEGRATION_KEY_MISSING": "A record has no key.",
    "INTEGRATION_KEY_DUPLICATE": "The key {key} occurs twice in one response.",
    "INTEGRATION_FILE_TRANSFER_FAILED": "The file transfer failed.",
    "INTEGRATION_CONNECTION_INACTIVE": "The connection or task is inactive.",
    "INTEGRATION_EMPTY_RESPONSE": "The response contained no records; the dataset was left unchanged.",
    "INTEGRATION_RESPONSE_TOO_LARGE": "The response is too large.",
    "INTEGRATION_RECORDS_PATH_NOT_LIST": "The records path does not point to a list.",
    "INTEGRATION_TEMPLATE_FAILED": "The template could not be rendered.",
    "INTEGRATION_INTERNAL": "The run failed unexpectedly.",
    "INTEGRATION_HEADER_SECRET_MISSING": "Secret header {name} needs a value.",
    "INTEGRATION_PARTNER_NOT_FOUND": "Partner account not found.",
    "INTEGRATION_URL_CREDENTIALS_NOT_ALLOWED": "Put credentials in the authentication settings, not in the URL.",
    "INTEGRATION_CRON_INVALID": "The schedule is not a valid cron expression or time zone.",
    "INTEGRATION_KIND_PROTOCOL_MISMATCH": "This task kind does not fit the connection's protocol ({protocol}).",
    "INTEGRATION_PATH_INVALID": "Field {field} has an invalid path: {path}.",
    "INTEGRATION_LOOKUP_UNKNOWN": "Unknown link target.",
    "INTEGRATION_LOOKUP_PARAMS_INVALID": "The link on field {field} is missing a setting.",
    "INTEGRATION_TASK_BUSY": "This task is already running.",
    "INTEGRATION_QUEUE_UNAVAILABLE": "The run queue is not available.",
    "INTEGRATION_TASK_NOT_FOUND": "Task not found.",
    "INTEGRATION_INBOUND_SECRET_MISSING": "Inbound basic auth needs a password.",
    "INTEGRATION_TASK_EXISTS": "This connection already has a task with this name.",
    "INTEGRATION_FIELD_DUPLICATE": "Field name {field} occurs more than once.",
    "INTEGRATION_FIELD_NAME_RESERVED": "Field name {field} is reserved.",
    "INTEGRATION_MENU_MODULE_UNKNOWN": "Unknown module for the menu.",
    "INTEGRATION_LOOKUP_MODULE_INACTIVE": "This link target is not available: its module is not active.",
    "INTEGRATION_SORT_COLUMN_INVALID": "This column cannot be sorted.",
    "INTEGRATION_RUN_NOT_FOUND": "Message not found.",
    "INTEGRATION_RECORD_NOT_FOUND": "Record not found.",
    "INTEGRATION_BODY_NOT_AVAILABLE": "This message body is not available.",
    "INTEGRATION_HOST_KEY_MISMATCH": "The server presented a different host key than the recorded one. Check with the partner that the key was really replaced, then clear the recorded key on the connection.",
    "INTEGRATION_SECRET_REQUIRED": "A different address or sign-in method needs a new secret: the old one does not travel to another destination.",
    "INTEGRATION_HEADER_NAME_INVALID": "Header name \"{name}\" is invalid: use only letters, digits and - _ . without spaces.",
    "INTEGRATION_TASK_INBOUND_ONLY": "An inbound task runs on a push from the partner, not on request.",
    "INTEGRATION_LEASE_LOST": "This run took too long; a newer run has taken over the task.",
    "INTEGRATION_RUN_ABANDONED": "This run never finished and has been closed.",
    "INTEGRATION_CRON_NEVER_RUNS": "The schedule is valid but matches no date (for example 30 February), so the task would never run.",
    "CLOCK_TIME_INVALID": "Invalid time: use HH:MM.",
    "MAINTENANCE_NOT_FOUND": "Maintenance not found.",
    "MAINTENANCE_SERIES_NOT_FOUND": "Maintenance series not found.",
    "MAINTENANCE_SERIES_INVALID": "This series is incomplete: choose the pattern with its day, and a valid time and period.",
    "MAINTENANCE_SKIP_INSTEAD": "Maintenance from a series is skipped rather than deleted.",
    "BREAK_OUTSIDE_SHIFT": "A break falls outside the shift.",
    "BREAKS_OVERLAP": "Breaks overlap.",
    "CALENDAR_EXCEPTION_INVALID": "This combination of date, times and kind is not valid.",
    "HOLIDAY_COUNTRY_UNKNOWN": "No public holidays are known for country \"{country}\".",
    "CALENDAR_EXCEPTION_NOT_FOUND": "Calendar exception not found.",
    "CALENDAR_RANGE_TOO_LARGE": "Choose a period of at most 400 days.",
    "SHIFT_TYPE_IN_USE": "This shift is used by a machine calendar or an exception and cannot be deleted.",
    "MACHINE_QUALIFICATION_EXISTS": "This employee is already qualified for this machine.",
    "MACHINE_QUALIFICATION_NOT_FOUND": "Qualification not found.",
    "STOCK_ORDER_ACTION_NOT_ALLOWED": "This is not available on a stock order.",
    "STOCK_ORDER_ITEM_NOT_STOCKED": "This item does not keep stock; a stock order is only possible for a stock item.",
    "STOCK_ORDER_CUSTOMER_MISSING": "The customer of this item no longer exists. Update the customer on the item and try again.",
    "IBAN_INVALID": "This is not a valid IBAN",
    "CARTON_DATE_NOT_PENDING": "There is no new board date to pass on.",
    "INTEGRATION_PLANNING_ROLE_TYPE": "The planning role of field {field} does not fit the field type.",
    "INTEGRATION_PLANNING_ROLE_DUPLICATE": "The planning role of field {field} is already used by another field.",
    "INTEGRATION_PLANNING_ROLE_NO_LOOKUP": "A planning role needs a quality lookup in the same task.",
    "INTEGRATION_PLANNING_ROLE_NO_DATASET": "A planning role needs a dataset (key path).",
    "PLANNING_NOT_CURRENT": "The planning is still being updated; try again shortly.",
    "FEASIBLE_DATE_NOT_LATE": "This line is not late; there is nothing to adopt.",
    "FEASIBLE_DATE_CHANGED": "The feasible date has changed in the meantime; please review it.",
    "FEASIBLE_DATE_RATE_LIMITED": "Too many delivery date checks; please wait a moment.",
    "FEASIBLE_DATE_UNCERTAIN": "The feasible date is uncertain: the carton or tooling lead time is unknown, or our own runs are too late for the creditor. Do not promise it.",
    "ACCOUNT_IN_USE": "This account is still in use (opportunities, quotes, orders, purchase orders, deliveries or packing slips) and cannot be deleted.",
    "ACCOUNT_HAS_PAPERBOARD_QUALITIES": "This relation is still a supplier of paperboard qualities or a price list. Remove it from there first; then you can delete it.",
    "DOCUMENT_HAS_PAYMENTS": "This document has payments allocated. It cannot be voided; correct it with a credit note, or delete the payment first.",
    "ORDER_LINE_BLOCKED_PRODUCTION": "This order line has a block that stops production ({kinds}). Lift the block first.",
    "ORDER_LINE_BLOCKED_LOADING": "This order line has a block that stops loading ({kinds}). Lift the block first.",
    "ORDER_LINE_NOT_RUNNING": "Line {lineNumber} is not running yet: the order has not been put into force or is awaiting approval.",
    "SALES_ORDER_PENDING_APPROVAL": "This sales order is awaiting approval. Withdraw the request to change or email it.",
    "SALES_ORDER_AWAITS_RELEASE": "This order has a change that has not been approved yet. Start it to send the change for approval, or undo the change, before you email it.",
    "ORDER_CUSTOMER_CURRENCY_LOCKED": "A running order keeps its customer and currency. Cancel it and create a new one if that needs to change.",
    "TOOLING_PRODUCT_INVALID": "For printing plate, die and color, choose another article with stock category Production supplies, an SKU and stock tracking.",
    "BLOCK_AUTOMATIC": "The system sets and lifts this block: it disappears once the tooling is booked in.",
    "PRICE_LIST_GONE": "The price list was deleted in the meantime. Calculate again.",
    "PRICE_LIST_PARSE": "Row {row} of the price list cannot be read.",
    "PRICE_LIST_HEADER_INCOMPLETE": "The header of the price list lacks the number, the start date or the price unit.",
    "PRICE_LIST_THRESHOLDS_INVALID": "The tier thresholds do not match the prices: one threshold per price, ascending.",
    "PRICE_LIST_NUMBER_MISMATCH": "The PDF belongs to a different offer than the CSV.",
    "PRICE_LIST_PDF_UNKNOWN": "This PDF is not a price list the app can read. Choose the matching CSV.",
    "PRICE_LIST_PDF_TOO_LARGE": "This PDF is too large or too complex to read. A price list has a few pages.",
    "PRICE_LIST_PDF_LINE": "This line in the PDF cannot be read: {line}",
    "PRICE_LIST_DATES_INVALID": "Running orders cannot change price before new orders do.",
    "PRICE_LIST_TOO_MANY_TIERS": "A quality in this price list has more than six tiers; the calculation has six.",
    "PRICE_LIST_CURRENCY_MISMATCH": "The price list is in a different currency than the supplier.",
    "PRICE_LIST_LOSING_PRICE_NOT_ACKNOWLEDGED": "Some qualities get no price with this list. Confirm that first.",
    "PRICE_LIST_EXISTS": "This price list was already imported for one of these suppliers.",
    "PRICE_LIST_THRESHOLDS_FIXED": "The tier thresholds of this price list come from the file and cannot be changed.",
    "PRICE_LIST_NOT_FOUND": "Price list not found.",
    "PRICE_LIST_IN_USE": "A calculation or purchase order took a price from this list; it cannot be deleted.",
    "PRICE_LIST_LINE_EXISTS": "This quality is already in the price list. Reload the quality and change the price there.",
    "SEARCH_FIELD_UNKNOWN": "You cannot search on this field.",
    "SEARCH_VALUE_INVALID": "A search value is not valid. Check the fields with a message.",
    "SEARCH_REQUEST_EMPTY": "Fill in at least one field in every search request.",
    "SEARCH_LIMIT_EXCEEDED": "This search is too large. Use fewer requests or fields, or search more precisely.",
    "SEARCH_TIMEOUT": "The search took too long. Search more precisely and try again.",
    "FOUND_SET_NOT_FOUND": "This found set no longer exists. Search again.",
    "BOARD_VERSION_NOT_FOUND": "This version no longer exists on this board.",
    "LIBRARY_ITEM_NOT_FOUND": "This item is not in the library.",
    "LIBRARY_FULL": "The library is full (2,000 items). Remove items you no longer use first.",
    "LIBRARY_PAYLOAD_TOO_LARGE": "This item is too large for the library.",
    "FONT_FILE_INVALID": "This file is not a font. Upload a WOFF2, OTF or TTF file.",
    "FONT_LIMIT": "The library already holds 200 fonts. Remove fonts you no longer use first.",
    "FONT_EXISTS": "This font, in this weight and style, is already in the library.",
    "FONT_NOT_FOUND": "This font is not in the library.",
    "BOARD_TEMPLATE_NOT_FOUND": "This template no longer exists.",
    "BADGE_UNKNOWN": "This badge does not belong to any employee.",
    "BADGE_NUMBER_TAKEN": "This badge already belongs to another employee.",
    "BADGE_NUMBER_INVALID": "This badge number does not fit the code type {label}.",
    "BADGE_NUMBERS_DO_NOT_FIT": "{count, plural, one {# badge number does} other {# badge numbers do}} not fit this code type ({names}). Change them first.",
    "SCAN_IN_FUTURE": "The scan time is in the future.",
    "REGISTRATION_END_BEFORE_START": "A registration cannot end before it starts.",
    "REGISTRATION_ALREADY_OPEN": "This employee already has an open registration.",
    "LEAVE_TYPE_CODE_TAKEN": "An absence type with this code already exists.",
    "LEAVE_TYPE_NOT_FOUND": "This absence type does not exist or is inactive.",
    "LEAVE_END_REQUIRED": "Enter an end date. Only a sick report may be open-ended.",
    "LEAVE_END_BEFORE_START": "The leave ends before it starts.",
    "MAIL_FORMAT_UNKNOWN": "This file is not an e-mail (.eml or .msg).",
    "MAIL_TOO_LARGE": "This e-mail is larger than {maxMb} MB. Download it to open it.",
    "MAIL_UNREADABLE": "This e-mail could not be read. Download it to open it in your mail program."
  },
  "auth": {
    "email": "Email",
    "emailPlaceholder": "name@example.com",
    "password": "Password",
    "backToSignIn": "Back to sign in",
    "signIn": {
      "title": "Sign in",
      "forgotPassword": "Forgot your password?",
      "submit": "Continue with email",
      "submitting": "Signing in…",
      "failed": "Sign-in failed",
      "failedDetail": "Sign-in failed. Please try again."
    },
    "twoFactor": {
      "title": "Two-factor authentication",
      "description": "Enter the 6-digit code from your authenticator app.",
      "code": "Verification code",
      "codePlaceholder": "6-digit code",
      "verify": "Verify and continue",
      "failed": "Verification failed"
    },
    "workspace": {
      "title": "Choose workspace",
      "description": "Your account has access to multiple workspaces. Pick one to sign in to.",
      "status": {
        "active": "Active",
        "paused": "Paused (read-only)",
        "pending_deletion": "Pending deletion"
      }
    },
    "forgot": {
      "title": "Reset your password",
      "description": "Enter your email address and we'll send you a link to choose a new password.",
      "submit": "Send reset link",
      "submitting": "Sending…",
      "sentTitle": "Check your email",
      "sentBody": "If an account exists for {email}, we've sent a password reset link. Follow the link in the email to choose a new password.",
      "notReceived": "Didn't get an email? Check your spam folder.",
      "otherAddress": "Try a different address"
    },
    "reset": {
      "invalidTitle": "Invalid reset link",
      "invalidBody": "The link is missing a reset token. Request a new link to continue.",
      "requestNew": "Request a new link",
      "title": "Choose a new password",
      "description": "At least 8 characters.",
      "newPassword": "New password",
      "confirm": "Confirm new password",
      "mismatch": "The passwords do not match.",
      "submit": "Update password",
      "submitting": "Updating…",
      "failed": "The password could not be reset. The link may have expired."
    },
    "setup2fa": {
      "title": "Set up two-factor authentication",
      "intro": "Admin accounts must have two-factor authentication enabled. You'll need an authenticator app (Google Authenticator, Authy, 1Password, etc.) on your phone. Enter your current password to get started.",
      "currentPassword": "Current password",
      "continue": "Continue",
      "settingUp": "Setting up…",
      "scan": "Scan this QR code with your authenticator app, then continue to enter the 6-digit code.",
      "manualEntry": "Can't scan? Show the setup URI",
      "backupCodes": "Backup codes (save these somewhere safe)",
      "scanned": "I've scanned it — next",
      "verifyIntro": "Enter the 6-digit code from your authenticator app to confirm the setup.",
      "code": "Code",
      "verify": "Verify and activate",
      "verifying": "Verifying…",
      "enableFailed": "Two-factor authentication could not be enabled.",
      "activated": "Two-factor authentication is now active"
    },
    "invite": {
      "loading": "Looking up your invite…",
      "unavailableTitle": "Invite not available",
      "missingToken": "This link is missing a token.",
      "welcome": "Welcome to {tenantName}",
      "invitedBy": "Invited by {email}",
      "password": "Choose a password (at least 8 characters)",
      "submit": "Set up account",
      "submitting": "Setting up…",
      "failed": "The account could not be set up."
    }
  },
  "integrations": {
    "alert": {
      "failing": {
        "subject": "Integration failing: {task}",
        "body": "<p>The task <b>{task}</b> ({connection}) has failed {count} times in a row.</p><p>Last error: {error}</p>"
      },
      "recovered": {
        "subject": "Integration recovered: {task}",
        "body": "<p>The task <b>{task}</b> ({connection}) is running successfully again.</p>"
      }
    },
    "secret": {
      "keep": "Saved — leave empty to keep",
      "empty": "Not set",
      "requiredNewDestination": "Required — new destination or sign-in"
    },
    "runs": {
      "noBody": "No body",
      "bodyPurged": "Body removed after {days} days",
      "bodyTooLarge": "Too large to show — download it",
      "download": "Download",
      "title": "Messages",
      "listEmpty": "No messages yet",
      "notFound": "Message not found",
      "attemptN": "Attempt {n}",
      "rerun": "Run again",
      "rerunQueued": "Queued",
      "changesTruncated": "The first {shown} of {total} changes",
      "noChanges": "No changes",
      "noHeaders": "No headers",
      "sections": {
        "overview": "Overview",
        "request": "Request",
        "response": "Response",
        "changes": "Changes",
        "attempts": "Attempts"
      },
      "fields": {
        "startedAt": "Time",
        "finishedAt": "Finished",
        "task": "Task",
        "trigger": "Trigger",
        "attempt": "Attempt",
        "status": "Status",
        "httpStatus": "HTTP status",
        "duration": "Duration",
        "fileName": "File",
        "fileSize": "File size",
        "recordsCreated": "New",
        "recordsUpdated": "Changed",
        "recordsUnchanged": "Unchanged",
        "recordsRemoved": "Removed",
        "error": "Error",
        "url": "Method and URL",
        "headers": "Headers",
        "body": "Body"
      },
      "filters": {
        "allTasks": "All tasks",
        "allStatuses": "All statuses",
        "allTriggers": "All triggers"
      },
      "changeKinds": {
        "created": "New",
        "updated": "Changed",
        "removed": "Removed"
      },
      "columns": {
        "httpStatus": "HTTP",
        "trigger": "Trigger"
      }
    },
    "connections": {
      "title": "Connections",
      "listEmpty": "No connections yet.",
      "new": "New connection",
      "saved": "Connection saved",
      "created": "Connection created",
      "deleted": "Connection deleted",
      "deleteConfirmTitle": "Delete connection?",
      "deleteConfirmBody": "This cannot be undone.",
      "testConnection": "Test connection",
      "testOk": "Connection succeeded",
      "testFailed": "Connection failed",
      "notFound": "Connection not found",
      "tasksEmpty": "This connection has no tasks yet.",
      "sections": {
        "general": "General",
        "auth": "Authentication",
        "headers": "Headers",
        "tasks": "Tasks"
      },
      "fields": {
        "name": "Name",
        "protocol": "Protocol",
        "partner": "Partner",
        "target": "Address",
        "isActive": "Active",
        "baseUrl": "Base URL",
        "host": "Host",
        "port": "Port",
        "basePath": "Base path",
        "note": "Note",
        "authType": "Authentication type",
        "authUsername": "Username",
        "authParamName": "Parameter name",
        "authSecret": "Secret",
        "privateKey": "Private key",
        "headerName": "Name",
        "headerSecret": "Secret",
        "headerValue": "Value",
        "hostKey": "SSH host key"
      },
      "hostKey": {
        "forget": "Forget",
        "notYet": "Not recorded yet — recorded on the first connection.",
        "hint": "The server’s key is recorded on the first connection; if it later differs, the connection refuses to connect.",
        "forgetTitle": "Forget host key?",
        "forgetBody": "Only do this if the partner confirms the server has a new key. After saving, the next connection records the key again, without checking it."
      },
      "taskSecretsCleared": "{count, plural, one {# secret task header was cleared} other {# secret task headers were cleared}} because of the new destination — enter them again on the tasks."
    },
    "authTypes": {
      "none": "None",
      "basic": "Basic",
      "bearer": "Bearer token",
      "apikey_header": "API key (header)",
      "apikey_query": "API key (query)",
      "password": "Password",
      "private_key": "Private key"
    },
    "taskKinds": {
      "http_request": "HTTP request",
      "http_inbound": "Inbound (HTTP)",
      "file_in": "Fetch file",
      "file_out": "Send file"
    },
    "runStatuses": {
      "queued": "Queued",
      "running": "Running",
      "success": "Succeeded",
      "failed": "Failed",
      "retry_scheduled": "Retry scheduled"
    },
    "runTriggers": {
      "schedule": "Schedule",
      "manual": "Manual",
      "retry": "Retry",
      "inbound": "Push",
      "test": "Test"
    },
    "tasks": {
      "title": "Tasks",
      "listEmpty": "No tasks yet.",
      "new": "New task",
      "saved": "Task saved",
      "created": "Task created",
      "deleted": "Task deleted",
      "deleteConfirmTitle": "Delete task?",
      "deleteConfirmBody": "The task, its message log and its dataset are deleted. This cannot be undone.",
      "notFound": "Task not found",
      "runNow": "Run now",
      "runQueued": "Queued",
      "scheduleManual": "Manual",
      "schedulePush": "By push",
      "filters": {
        "allConnections": "All connections",
        "allKinds": "All kinds",
        "allStatuses": "All statuses"
      },
      "sections": {
        "general": "General",
        "schedule": "Schedule",
        "headers": "Headers",
        "mapping": "Mapping",
        "menu": "Menu",
        "inbound": "Inbound",
        "alerts": "Alerts"
      },
      "fields": {
        "connection": "Connection",
        "name": "Name",
        "kind": "Kind",
        "method": "Method",
        "path": "Path",
        "format": "Format",
        "filePattern": "File pattern",
        "afterDownload": "After download",
        "fileNameTemplate": "File name",
        "isActive": "Active",
        "query": "Query parameters",
        "queryName": "Name",
        "queryValue": "Value",
        "bodyTemplate": "Body",
        "templateHint": "Template: '{{ now }}, {{ today }}, {{ cursor.lastSuccessAt }}, {{ run.id }}, {{ task.name }}'",
        "scheduleCron": "Schedule",
        "scheduleCronHint": "Cron expression (minute hour day month weekday); empty = manual only.",
        "timezone": "Time zone",
        "recordsPath": "Records path",
        "recordsPathHint": "Where the list sits in the response, e.g. data.items[]; empty = the whole response.",
        "keyPath": "Key path",
        "keyPathHint": "The field that makes a record unique; empty = no dataset.",
        "allowEmptyFullFetch": "Allow an empty full fetch",
        "allowEmptyFullFetchHint": "Otherwise a run that returns zero records while the dataset has some fails, and the dataset is kept.",
        "mappingFields": "Fields",
        "fieldName": "Name",
        "fieldLabel": "Label",
        "fieldPath": "Path",
        "fieldType": "Type",
        "transforms": "Transforms",
        "lookup": "Lookup",
        "lookupTarget": "Link to",
        "lookupNone": "None",
        "planningRole": "Use in planning",
        "showInList": "In list",
        "menuModuleKey": "Module",
        "menuModuleKeyHint": "Shows the dataset in this module's menu; empty = not in a menu.",
        "menuIcon": "Icon",
        "menuLabel": "Menu label",
        "inboundAuthUsername": "Username (basic auth)",
        "inboundAuthSecret": "Password (basic auth)",
        "alertEmail": "Alert e-mail",
        "alertAfterFailures": "Alert after consecutive failures",
        "retentionDays": "Keep bodies (days)",
        "retentionDaysHint": "After that the request and response bodies are deleted; the log record stays.",
        "lastRunAt": "Last run",
        "lastStatus": "Status",
        "consecutiveFailures": "Failures in a row",
        "moduleInactive": "inactive",
        "moduleNoMenu": "no menu"
      },
      "cronPresets": {
        "label": "Quick pick:",
        "every15": "Every 15 minutes",
        "hourly": "Every hour",
        "weekdays6": "Weekdays 06:00"
      },
      "schedulePreview": {
        "title": "Next five times",
        "manual": "No schedule — the task only runs manually."
      },
      "test": {
        "title": "Test mapping",
        "saveFirst": "Save the task first.",
        "saveChanges": "Save your changes first — this uses the saved task.",
        "neverSends": "This task sends data; a test therefore never fetches live and sends nothing.",
        "run": "Test",
        "running": "Running…",
        "emptyPaths": "Paths that found nothing: {paths}",
        "noRecords": "No records found.",
        "source": {
          "live": "Fetch live",
          "last": "Last stored body",
          "paste": "Paste a body"
        }
      },
      "inbound": {
        "endpoint": "Endpoint",
        "noToken": "No token yet — issue one.",
        "newToken": "New token",
        "replaces": "A new token invalidates the previous one.",
        "dialogTitle": "New token",
        "shownOnce": "Copy it now: it will not be shown again.",
        "url": "URL for the partner",
        "token": "Token",
        "copied": "Copied",
        "copy": "Copy",
        "copyFailed": "Copy failed — select and copy the text yourself."
      },
      "viewDataset": "View dataset"
    },
    "fieldTypes": {
      "text": "Text",
      "number": "Number",
      "date": "Date",
      "boolean": "Yes/no",
      "list": "List",
      "weekdays": "Weekdays"
    },
    "transforms": {
      "trim": "Trim",
      "upper": "Upper case",
      "lower": "Lower case",
      "required": "Required",
      "default": "Default",
      "number": "Number",
      "date": "Date format",
      "map": "Value map",
      "join": "Join",
      "add": "Add transform…",
      "none": "No transforms.",
      "decimalPoint": "Decimal point (1.5)",
      "decimalComma": "Decimal comma (1,5)",
      "mapHint": "One line per value: SOURCE=TARGET",
      "defaultValue": "Value when empty",
      "separator": "Separator",
      "dateFormatMissing": "Without a format this transform is dropped on save (dates are then read as yyyy-MM-dd).",
      "mapLinesIgnored": "These lines have no SOURCE= and will not be saved: {lines}"
    },
    "afterDownload": {
      "archive": "Archive",
      "delete": "Delete",
      "keep": "Keep"
    },
    "lookups": {
      "qualitySupplierCode": "Paperboard supplier quality code",
      "params": {
        "supplierPaperboardIds": "Paperboard suppliers",
        "supplierPaperboardHint": "Every supplier (plant) these codes come from."
      }
    },
    "planningRole": {
      "carton_next_delivery_date": "Next board delivery date",
      "carton_delivery_days": "Board delivery days"
    },
    "datasets": {
      "title": "Datasets",
      "tasksEmpty": "No task with a dataset yet. Set a key path on a task to create one.",
      "listEmpty": "This dataset has no records yet.",
      "notFound": "Record not found",
      "key": "Key",
      "removed": "Removed",
      "removedAt": "Removed on",
      "lookupColumn": "{label} (linked)",
      "noHistory": "No changes yet.",
      "noMenu": "No menu entry",
      "sections": {
        "fields": "Fields",
        "history": "History"
      },
      "fields": {
        "name": "Task",
        "connection": "Connection",
        "menu": "Menu entry",
        "recordCount": "Records"
      }
    },
    "validation": {
      "title": "Please check these fields:",
      "row": "row {row}",
      "required": "is required",
      "fieldName": "“{name}” may only contain letters, digits and _ and must start with a letter",
      "headerName": "“{name}” is not a valid header name (no spaces or characters such as : ( ) , ;)",
      "url": "must be a full address starting with http:// or https://",
      "email": "is not a valid email address",
      "range": "must be a whole number between {min} and {max}",
      "duplicate": "“{name}” occurs more than once",
      "baseUrlQuery": "may not contain a query (?) or fragment (#)"
    }
  },
  "workCalendar": {
    "title": "Work schedule",
    "subtitle": "Time zone and working days",
    "fields": {
      "timeZone": "Time zone",
      "workdays": "Working days",
      "workdaysHint": "For loading, production and material dates. An extra day or overtime does not count here."
    },
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "saved": "Work schedule saved"
  },
  "calendar": {
    "title": "Company calendar",
    "listEmpty": "No exceptions this year.",
    "new": "New exception",
    "loading": "Loading exception…",
    "notFound": "Exception not found",
    "kind": {
      "closed": "Closed",
      "open": "Open"
    },
    "category": {
      "holiday": "Public holiday",
      "closure": "Closure",
      "overtime": "Overtime",
      "other": "Other"
    },
    "wholeDay": "Whole day",
    "untilEndOfDay": "Until end of day",
    "fields": {
      "date": "Date",
      "endDate": "Up to and including",
      "kind": "Kind",
      "category": "Category",
      "label": "Description",
      "shiftType": "Shift",
      "startTime": "From",
      "endTime": "To"
    },
    "saved": "Exception saved",
    "created": "Exception created",
    "deleted": "Exception deleted",
    "deleteConfirm": "Delete this exception?",
    "deleteConfirmTitle": "Delete exception",
    "delete": "Delete",
    "holidays": {
      "open": "Suggest public holidays",
      "title": "Suggest public holidays",
      "country": "Country",
      "region": "Region",
      "year": "Year",
      "regionIgnored": "This region is not known; the public holidays of the whole country are shown.",
      "from": "from {time}",
      "type": {
        "public": "Public",
        "bank": "Bank holiday",
        "school": "School holiday",
        "optional": "Optional"
      },
      "alreadyAdded": "Already added",
      "add": "Add {count}",
      "added": "{count} public holidays added",
      "attribution": "Public holidays: date-holidays (CC BY 3.0)"
    }
  },
  "machineCalendar": {
    "title": "Machine calendar",
    "noMachines": "Machines come from the Packaging module.",
    "loading": "Loading machine calendar…",
    "notFound": "Machine not found",
    "sections": {
      "general": "General",
      "week": "Week",
      "exceptions": "Exceptions",
      "series": "Maintenance",
      "qualifications": "Employees"
    },
    "fields": {
      "runsThroughBreaks": "Runs through breaks",
      "runsThroughBreaksHint": "Someone takes over, so the machine keeps running during breaks.",
      "weekHint": "A day without a shift: the machine doesn't run that day.",
      "note": "Note",
      "idMachine": "Machine",
      "window": "Time window"
    },
    "exceptions": {
      "add": "Add exception",
      "edit": "Edit exception",
      "empty": "No exceptions for this machine.",
      "deleteConfirmTitle": "Delete exception?",
      "deleteConfirm": "This exception will be permanently deleted."
    },
    "series": {
      "add": "Add series",
      "empty": "No maintenance series for this machine.",
      "title": "Title",
      "pattern": "Pattern",
      "window": "Time window"
    },
    "saved": "Machine calendar saved"
  },
  "maintenance": {
    "pattern": {
      "weekly": "Weekly",
      "monthly_nth_weekday": "Monthly on a weekday",
      "monthly_day": "Monthly on a date"
    },
    "title": "Maintenance",
    "listEmpty": "No maintenance in this period.",
    "allMachines": "All machines",
    "skipped": "Skipped",
    "modified": "Adjusted",
    "skip": "Skip",
    "unskip": "Don't skip",
    "fromSeries": "From a series: skip instead of deleting.",
    "deleteConfirmTitle": "Delete maintenance?",
    "deleteConfirm": "This one-off occurrence will be permanently deleted.",
    "saved": "Maintenance saved",
    "created": "Maintenance created",
    "deleted": "Maintenance deleted",
    "series": {
      "title": "Maintenance series",
      "deleteConfirmTitle": "Delete series?",
      "deleteConfirm": "The series and its future, unmoved occurrences are deleted. Past and moved occurrences stay as one-off occurrences."
    },
    "fields": {
      "machine": "Machine",
      "title": "Description",
      "date": "Date",
      "startTime": "From",
      "endTime": "To",
      "pattern": "Pattern",
      "everyNWeeks": "Every … weeks",
      "everyNMonths": "Every … months",
      "weekday": "Weekday",
      "nth": "Which",
      "dayOfMonth": "Day of month",
      "startsOn": "From",
      "endsOn": "Until"
    },
    "nth": {
      "1": "first",
      "2": "second",
      "3": "third",
      "4": "fourth",
      "last": "last"
    },
    "summary": {
      "weekly": "Every {day}",
      "everyNWeeks": "Every {n} weeks on {day}",
      "monthlyNth": "Monthly on the {nth} {day}",
      "everyNMonthsNth": "Every {n} months on the {nth} {day}",
      "monthlyDay": "Monthly on day {date}",
      "everyNMonthsDay": "Every {n} months on day {date}"
    }
  },
  "capacity": {
    "title": "Machine planning",
    "zoom": {
      "week": "Week",
      "month": "Month",
      "day": "Day"
    },
    "today": "Today",
    "block": {
      "open": "Open",
      "break": "Break",
      "maintenance": "Maintenance"
    },
    "empty": "No machines with a schedule yet.",
    "netHours": "Net hours",
    "hoursShort": "h"
  },
  "machineQualification": {
    "employee": "Employee",
    "level": "Level",
    "validUntil": "Valid until",
    "levels": {
      "assistant": "Assistant (manual work)",
      "trainee": "In training",
      "qualified": "Qualified",
      "instructor": "Instructor"
    },
    "add": "Add employee",
    "edit": "Edit qualification",
    "empty": "No employees qualified for this machine yet.",
    "expired": "Expired",
    "unlimited": "Unlimited",
    "saved": "Qualification saved",
    "deleted": "Qualification deleted",
    "deleteConfirmTitle": "Delete qualification?",
    "deleteConfirm": "The employee will no longer be qualified for this machine."
  },
  "planning": {
    "updatedAt": "Updated at {time}",
    "updating": "Updating…",
    "noWorkCalendar": "No work calendar: nothing is planned.",
    "lastError": "The last recalculation failed; this is the previous plan.",
    "late": "Misses delivery date (−{n} wd)",
    "dueDate": "Delivery date",
    "needDate": "Board needed on",
    "supplyStep": "Material status",
    "dayLoad": "Planned {planned} h of {open} h",
    "col": {
      "start": "Start",
      "end": "End",
      "order": "Order",
      "article": "Article",
      "quantity": "Quantity"
    },
    "tone": {
      "normal": "Planned",
      "started": "Started",
      "stock": "Stock order",
      "notApproved": "Not approved"
    },
    "legend": {
      "late": "Late",
      "overdue": "Overdue (old slot)"
    },
    "runFlag": {
      "overdue": "Overdue",
      "not_schedulable": "Cannot be scheduled",
      "predecessor_unplaced": "Previous step not scheduled",
      "no_machine": "No machine",
      "not_plannable_machine": "Lead time unknown",
      "no_minutes": "No time",
      "same_day_carton": "Starts on board delivery day"
    },
    "orderFlag": {
      "unschedulable": "Cannot be scheduled",
      "lead_time_unknown": "Lead time unknown",
      "carton_lead_time_unknown": "Board lead time unknown",
      "carton_late": "Board too late",
      "tooling_lead_time_unknown": "Tooling lead time unknown",
      "handover_late": "Too late for the creditor"
    },
    "summary": {
      "planned": "Planned (engine)",
      "readyAt": "Ready (engine)",
      "feasible": "Feasible delivery date",
      "flag": "Flag"
    },
    "cartonWanted": "Board",
    "cartonWantedText": "Needed by {wanted}",
    "cartonConfirmedText": "confirmed {confirmed}",
    "tooling": {
      "title": "Tooling",
      "none": "Not needed",
      "present": "In stock",
      "role": {
        "print": "Printing plate",
        "diecut": "Die",
        "ink": "Ink"
      },
      "expected": "expected {date}",
      "atThirdParty": "held by a third party",
      "unknown": "lead time unknown"
    }
  },
  "help": {
    "title": "Manual",
    "part": {
      "work": "Working with Cloud ERP",
      "settings": "Settings"
    },
    "chapter": {
      "start": "Getting started",
      "chain": "The order chain",
      "sales": "Sales",
      "purchasing": "Purchasing",
      "integrations": "Integrations"
    },
    "search": {
      "placeholder": "Search the manual…",
      "noResults": "Nothing found for this search."
    },
    "openScreen": "Open this screen",
    "onThisPage": "On this page",
    "previous": "Previous",
    "next": "Next",
    "untranslated": "This page has not been translated yet.",
    "notFound": "This page does not exist.",
    "notAvailable": "This page belongs to a module or setting that is not available to you.",
    "permissionsFailed": "Not all chapters could be loaded.",
    "loadFailed": "The manual could not be loaded.",
    "retry": "Try again",
    "backToIndex": "Back to the contents",
    "home": {
      "intro": "Read here how to work with Cloud ERP. Choose a chapter, or search for a word.",
      "pageCount": "Pages: {count}"
    },
    "button": "Manual for this screen",
    "moreInManual": "More in the manual"
  },
  "findMode": {
    "find": "Find",
    "findTitle": "Find {entity}",
    "request": "Request {n}",
    "addRequest": "+ request",
    "removeRequest": "Remove request",
    "omit": "Omit",
    "search": "Find",
    "cancel": "Cancel",
    "nothingFound": "Nothing matches this search.",
    "emptyRequest": "Fill in at least one field.",
    "tooMany": "Too many requests or fields.",
    "operatorsHelp": "Symbols: = empty · = whole word · == whole field · * unknown characters · a...b from–to · ...b up to · a... from · < > <= >= less/greater.",
    "yes": "Yes",
    "no": "No",
    "any": "—",
    "emptyOption": "(empty)",
    "foundOf": "Found {size} of {total}",
    "omitFromFound": "Omit from found set",
    "constrain": "Constrain",
    "extend": "Extend",
    "showOmitted": "Show omitted",
    "showAll": "Show all",
    "expired": "This found set has expired.",
    "emptySet": "This found set is empty.",
    "rerun": "Search again",
    "error": {
      "invalidOperator": "This symbol does not fit this field.",
      "notANumber": "Use digits only.",
      "tooLong": "Too long."
    }
  }
}
